import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Grid,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Divider,
  SelectChangeEvent,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import {
  Add,
  Delete,
  Download,
  FilterList,
  MoreVert,
  Search,
  Clear,
  FirstPage,
  LastPage,
  Remove,
  CloudUpload,
  Close,
  GridOn,
  PhotoCamera,
} from "@mui/icons-material";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/system";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import ImageIcon from "@mui/icons-material/Image";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import {
  employeeSearchParams,
  createPayroll,
  uploadItemPhoto,
  deletePayroll,
  updatePayroll,
  getPayrollById,
  fetchPayrollPhotoBlob,
  formatPositionDisplay,
  fetchInorganicEmployee,
  getEmployeeById,
  fetchEmployeePhotoBlob,
  fetchOffices,
  fetchRoles,
  fetchVendors,
  fetchPayroll,
  getEmployees,
  searchPayroll,
  uploadItemFile,
  fetchPayrollFile,
  bulkCreatePayroll,
  getTarifTER,
  bulkUpsertPayrollExcel,
} from "../services/payrollServices.tsx";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

interface Employee {
  id: string;
  name: string;
  nik: string;
  position: any[];
  division: string;
  office: string;
  status: string;
  employeeType: string;
  userId: string; // Tambahkan ini
  email: string; // Tambahkan ini
}

interface Role {
  id: string;
  name: string;
  description?: string;
}

interface RoleOption {
  id: string;
  name: string;
  description?: string;
}

interface SelectedRole {
  id: string;
  name: string;
  selected: boolean;
}

interface Vendor {
  vendorId: string;
  vendorName: string; // Perbaiki typo dari vendorNameame
  vendorAddress: string;
  vendorContactNumber: string;
  vendorEmail: string;
  vendorType: string;
  vendorTaxId: string;
  vendorBankDetails: string;
  vendorStatus: string;
  photoVendor?: string; // Tambahkan field untuk foto
}

interface Office {
  officeId: string;
  officeName: string;
  officeAddress: string;
  latitude: string;
  longitude: string;
  region: string;
  province: string;
  city: string;
  district: string;
  managerName: string;
  contactNumber: string;
  officeEmail: string;
  officeType: string;
  file: File | null;
}

interface EmployeeOption {
  id: string;
  name: string;
  // add other properties that might be in your API response
}

interface OfficeOption {
  officeId: string;
  officeName: string;
}

interface VendorOption {
  vendorId: string;
  vendorName: string;
}

type PayrollEntry = {
  id: string;
  employeeId?: number | null;
  periodMonth: number | null;
  periodYear: number | null;
  paymentStatus: string;
  paymentEvidence: File | null | string; // File untuk upload, string untuk URL existing
  paymentEvidenceType?: string;
  paymentDate: Date | null;
  paymentType: string;
  thrInstallmentCoeff: number | null;
  thrInstallment: number | null;
  pensionDplkInstallmentCoeff: number | null;
  pensionDplkInstallment: number | null;
  jkk: number | null;
  jkm: number | null;
  payrollPph21: number | null;
  grossPayroll: number | null;
  bonusCoeff: number | null;
  takeHomePay: number | null;
  bpjsKesCompany: number | null;
  overtime: number | null;
  bpjsTkContributionCoeff: number | null;
  bpjsTkContribution: number | null;
  cicilKom?: number | null;
  overtimePay?: number | null;
  sppd?: number | null;
  bonus?: number | null;
  thr?: number | null;
  kompensasi?: number | null;
  others?: number | null;
  tarifTER: number | null;
  TER?: number | null; // Field asli dari API
  pph21?: number | null; // Field asli dari API
  gross?: number | null; // Field asli dari API
  // employee: {
  //   id: number;
  //   name: string;
  // };
};

interface PayrollFormState {
  details: PayrollEntry[];
  currentDetail: PayrollEntry;
}

type PTKPCategory =
  | "TK/0"
  | "TK/1"
  | "TK/2"
  | "TK/3"
  | "K/0"
  | "K/1"
  | "K/2"
  | "K/3";

type CategoryTER = "TER A" | "TER B" | "TER C";

const bankData = [
  "-",
  "Bank Rakyat Indonesia (BRI) - 002",
  "Bank Mandiri - 008",
  "Bank Negara Indonesia (BNI) - 009",
  "Bank Tabungan Negara (BTN) - 200",
  "Bank Syariah Indonesia (BSI) - 451",
  "Bank Central Asia (BCA) - 014",
  "Bank CIMB Niaga - 022",
  "Bank Danamon - 011",
  "Bank Permata - 013",
  "Bank Maybank Indonesia - 016",
  "Bank Panin - 019",
  "Bank OCBC NISP - 028",
  "Bank Sinarmas - 153",
  "Bank Mega - 426",
  "Bank KB Bukopin - 441",
  "Bank BTPN - 213",
  "Bank UOB Indonesia - 023",
  "Bank BCA Syariah - 536",
  "Bank Muamalat - 147",
  "Bank BTPN Syariah - 547",
  "Bank Victoria International - 566",
  "Bank Woori Saudara - 212",
  "Bank Jago - 542",
  "Bank Neo Commerce - 490",
  "Allo Bank - 567",
  "SeaBank - 535",
  "Bank Amar Indonesia - 531",
  "Bank Aladin Syariah - 947",
  "Bank Jenius (BTPN) - 213",
  "Bank Raya (BRI Agro) - 494",
  "Bank MNC Internasional - 485",
  "Bank Hana - 484",
  "Bank QNB Indonesia - 167",
  "Bank Mayora - 553",
  "Bank Index Selindo - 555",
  "Bank Sahabat Sampoerna - 523",
  "Bank Oke Indonesia - 526",
  "Bank Ina Perdana - 513",
  "Bank Ganesha - 161",
  "Bank Maspion - 157",
  "Bank Capital Indonesia - 054",
  "Bank Resona Perdania - 047",
  "Bank ICBC Indonesia - 164",
  "Bank JTrust Indonesia - 095",
  "Bank Artha Graha Internasional - 037",
  "Bank Commonwealth - 950",
  "Bank CTBC Indonesia - 949",
  "Bank of China - 069",
  "Standard Chartered Bank - 050",
  "Citibank - 031",
  "JP. Morgan Chase Bank, N.A. - 032",
  "Bank of America, N.A - 033",
  "Bank Mizuho Indonesia - 048",
  "Bank Sumitomo Mitsui Indonesia - 045",
  "The Bank of Tokyo Mitsubishi UFJ LTD - 042",
  "American Express Bank LTD - 030",
  "Bank DKI Jakarta - 111",
  "Bank Jabar Banten (BJB) - 110",
  "Bank BPD DIY - 112",
  "Bank Jateng - 113",
  "Bank Jatim - 114",
  "Bank Jambi - 115",
  "Bank Aceh - 116",
  "Bank Sumut - 117",
  "Bank Nagari (Sumbar) - 118",
  "Bank Riau Kepri - 119",
  "Bank Sumsel Babel - 120",
  "Bank Lampung - 121",
  "Bank Kalsel - 122",
  "Bank Kalbar - 123",
  "Bank Kaltimtara - 124",
  "Bank Kalteng - 125",
  "Bank Sulselbar - 126",
  "Bank SulutGo - 127",
  "Bank NTB - 128",
  "Bank BPD Bali - 129",
  "Bank NTT - 130",
  "Bank Maluku Malut - 131",
  "Bank Papua - 132",
  "Bank Bengkulu - 133",
  "Bank Sulteng - 134",
  "Bank Sultra - 135",
  "Bank Banten - 137",
];

const positionData = {
  Direksi: {
    Direksi: [
      "Direktur Utama",
      "Direktur Operasional dan Teknik",
      "Direktur Pengembangan Usaha",
      "Direktur Keuangan",
    ],
  },
  "Satuan Pengawas Internal": {
    "Satuan Pengawas Internal": [
      "Kepala Satuan Pengawas Internal",
      "Staf Satuan Pengawas Internal",
    ],
  },
  "Sekretaris Perusahaan": {
    "Sekretaris Perusahaan": [
      "Sekretaris Perusahaan",
      "Staf Sekretaris Perusahaan",
    ],
  },
  "Satuan K3 dan Sistem Manajemen": {
    "Satuan K3 dan Sistem Manajemen": [
      "Kepala Satuan K3 dan Sistem Manajemen",
      "Staf Kepala Satuan K3 dan Sistem Manajemen",
    ],
  },
  "Pengembangan Usaha": {
    "Pengembangan Usaha, Pemasaran, Teknologi Informasi dan Investasi": [
      "Kepala Divisi Pengembangan Usaha, Pemasaran, Teknologi Informasi dan Investasi",
      "Staf Ahli Teknologi Informasi",
      "Programmer",
      "Data Center Spesialis",
    ],
    "Pengembangan Usaha dan Pemasaran": [
      "Manajer Pengembangan Usaha dan Pemasaran",
      "Staf Pengembangan Usaha dan Pemasaran",
    ],
    Investasi: ["Manajer Investasi", "Staf Investasi"],
    "Perencanaan Korporat dan Perijinan": [
      "Kepala Divisi Perencanaan Korporat dan Perijinan",
    ],
    "Perencanaan Korporat dan Portofolio": [
      "Manajer Perencanaan Korporat dan Portofolio",
      "Staf Perencanaan Korporat dan Portofolio",
    ],
    "Pengadaan dan Perijinan": [
      "Manajer Pengadaan dan Perijinan",
      "Staf Pengadaan dan Perijinan",
    ],
  },
  Keuangan: {
    "SDM, Umum dan Hukum": ["Kepala Divisi SDM, Umum dan Hukum"],
    "Hukum dan Manajemen Risiko": [
      "Manajer Hukum dan Manajemen Risiko",
      "Staf Manajer Hukum dan Manajemen Risiko",
    ],
    "SDM dan Umum": ["Manajer SDM dan Umum", "Staf SDM dan Umum"],
    "Jasa Penyedia Tenaga Kerja": [
      "Manajer Jasa Penyedia Tenaga Kerja",
      "Staf Jasa Penyedia Tenaga Kerja",
    ],
    Keuangan: ["Kepala Divisi Keuangan"],
    "Anggaran dan Keuangan": [
      "Manajer Anggaran dan Keuangan",
      "Staf Anggaran dan Keuangan",
    ],
    "Akuntansi dan Pajak": ["Manajer Akuntansi dan Pajak"],
    Akuntansi: ["Asisten Manajer Akuntansi", "Staf Akuntansi"],
    "Pajak, Asuransi dan Pendanaan": [
      "Asisten Manajer Pajak, Asuransi dan Pendanaan",
      "Staf Pajak, Asuransi dan Pendanaan",
    ],
  },
  "Operasional dan Teknik": {
    "Pengendalian Proyek Konstruksi": [
      "Kepala Divisi Pengendalian Proyek Konstruksi",
      "Supervisor Pengendalian Proyek Konstruksi",
      "Staf Pengendalian Proyek Konstruksi",
    ],
    "Perencanaan Konstruksi": [
      "Manajer Perencanaan Konstruksi",
      "Staf Perencanaan Konstruksi",
    ],
    "Pengendalian Proyek Konstruksi dan Konstruksi": [
      "Manajer Pengendalian Proyek Konstruksi dan Konstruksi",
    ],
    "Administrasi Proyek Konstruksi": [
      "Asisten Manajer Administrasi Proyek Konstruksi",
      "Staf Administrasi Proyek Konstruksi",
    ],
    "Pengelolaan dan Pemeliharaan Gedung": [
      "Kepala Divisi Pengelolaan dan Pemeliharaan Gedung",
    ],
    "Jasa Pengelolaan dan Pemeliharaan Gedung": [
      "Manajer Jasa Pengelolaan dan Pemeliharaan Gedung",
      "Staf Jasa Pengelolaan dan Pemeliharaan Gedung",
    ],
    "Jasa Pengelolaan Gedung": [
      "Asisten Manajer Jasa Pengelolaan Gedung",
      "Staf Jasa Pengelolaan Gedung",
    ],
    "Jasa Pemeliharaan Gedung": [
      "Asisten Manajer Jasa Pemeliharaan Gedung",
      "Staf Jasa Pemeliharaan Gedung",
    ],
  },
  Vendor: {
    Vendor: ["Vendor"],
  },
  MBPST: { MBPST: ["MBPST"] },
  PJTKRBG: { PJTKRBG: ["PJTKRBG"] },
  PJTKBTM: { PJTKBTM: ["PJTKBTM"] },
  PJTKPTN: { PJTKPTN: ["PJTKPTN"] },
  PJTKBPP: { PJTKBPP: ["PJTKBPP"] },
  PJTKMKS: { PJTKMKS: ["PJTKMKS"] },
  PJTKLSM: { PJTKLSM: ["PJTKLSM"] },
  PJTKPRT: { PJTKPRT: ["PJTKPRT"] },
  PJTKNTB: { PJTKNTB: ["PJTKNTB"] },
  PJTKMRK: { PJTKMRK: ["PJTKMRK"] },
  PJTKBLW: { PJTKBLW: ["PJTKBLW"] },
  PJTKPDG: { PJTKPDG: ["PJTKPDG"] },
  MBWIJAYA: { MBWIJAYA: ["MBWIJAYA"] },
  MBIP: { MBIP: ["MBIP"] },
  MBUIPJBB: { MBUIPJBB: ["MBUIPJBB"] },
};

interface AdvancedSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearchResults: (results: Employee[]) => void;
}

const PayrollPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryPayrollDetail, setSearchQueryPayrollDetail] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [rowsPayrollDetail, setRowsPayrollDetail] = useState<any[]>([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddEmployeeDialog, setOpenAddEmployeeDialog] = useState(false);
  const [openEditEmployeeDialog, setOpenEditEmployeeDialog] = useState(false);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [limit, setLimit] = useState(10); // Jumlah item per halaman
  const [rowsPerPage, setRowsPerPage] = useState(10); // Jumlah item per halaman
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [currentPage, setCurrentPage] = useState(1); // Halaman aktif
  const [totalPages, setTotalPages] = useState(1); // Total halaman
  const [rowsPerPagePayrollDetail, setRowsPerPagePayrollDetail] = useState(10); // Jumlah item per halaman
  const [totalItemsPayrollDetail, setTotalItemsPayrollDetail] = useState(0); // Total semua data
  const [currentPagePayrollDetail, setCurrentPagePayrollDetail] = useState(1); // Halaman aktif
  const [totalPagesPayrollDetail, setTotalPagesPayrollDetail] = useState(1); // Total halaman

  const [isUploading, setIsUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState<any>(null);

  const [selectedDirectorateAdd, setSelectedDirectorateAdd] = useState("");
  const [selectedDivisionAdd, setSelectedDivisionAdd] = useState("");
  const [selectedJobTitleAdd, setSelectedJobTitleAdd] = useState("");

  const [selectedDirectorateEdit, setSelectedDirectorateEdit] = useState("");
  const [selectedDivisionEdit, setSelectedDivisionEdit] = useState("");
  const [selectedJobTitleEdit, setSelectedJobTitleEdit] = useState("");

  const [employeeOptions, setEmployeeOptions] = useState<EmployeeOption[]>([]);
  const [loading, setLoading] = useState(false);

  const [loadingTarifTER, setLoadingTarifTER] = useState(false);

  const [officeFilterOptions, setOfficeFilterOptions] = useState<
    OfficeOption[]
  >([]);
  const [vendorFilterOptions, setVendorFilterOptions] = useState<
    VendorOption[]
  >([]);

  const [pdfDisabled, setPdfDisabled] = useState(true);

  const [baseTakeHomePay, setBaseTakeHomePay] = useState<number | null>(null);

  // Fungsi untuk mengambil data karyawan

  // Employee Data Table ========================================================================
  // Fungsi untuk mengambil data karyawan
  const reloadEmployeeInorganic = async () => {
    setIsLoading(true);
    setError(""); // Reset error sebelum memuat ulang data
    try {
      const result = await getEmployees({
        // const result = await fetchInorganicEmployee({
        // employeeType:"Inorganic",
        ...filterParams,
        ...filterPayrollParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      const employeesWithPaymentStatus = result.data.map((emp) => {
        // Get all payment statuses for this employee's payrolls
        const paymentStatuses = emp.payrollTads.map(
          (payroll) => payroll.paymentStatus
        );

        // Determine the overall status
        let overallStatus;
        if (paymentStatuses.length === 0) {
          overallStatus = "No Payroll";
        } else if (paymentStatuses.every((status) => status === "Paid")) {
          overallStatus = "Paid";
        } else if (paymentStatuses.some((status) => status === "Paid")) {
          overallStatus = "Partial Paid";
        } else {
          overallStatus = "Unpaid";
        }

        return {
          ...emp,
          overallPaymentStatus: overallStatus,
        };
      });

      // Format position data sebelum disimpan ke state
      const formattedData = employeesWithPaymentStatus.map((employee) => ({
        ...employee,
        position: formatPositionDisplay(employee.position),
      }));

      setRows(formattedData);
      setTotalItems(result.total);
      setTotalPages(result.pagination.totalPages);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const reloadEmployee = async () => {
    setIsLoading(true);
    setError(""); // Reset error sebelum memuat ulang data
    try {
      const result = await getEmployees({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      // Format position data sebelum disimpan ke state
      const formattedData = result.data.map((employee) => ({
        ...employee,
        position: formatPositionDisplay(employee.position),
      }));

      setRows(formattedData);
      setTotalItems(result.total);
      setTotalPages(result.pagination.totalPages);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const offset = (currentPage - 1) * rowsPerPage;
  const offsetPayrollDetail =
    (currentPagePayrollDetail - 1) * rowsPerPagePayrollDetail;

  const [filterParams, setFilterParams] = useState<{
    id?: string;
    name?: string;
    nik?: string;
    jobTitle?: string;
    division?: string;
    office?: string;
    status?: string;
    employeeType?: string;
    keyword?: string;
  }>({});

  const [filterPayrollParams, setFilterPayrollParams] = useState<{
    employeeId?: string;
    periodMonth?: string;
    periodYear?: string;
    paymentStatus?: string;
    paymentType?: string;
    keyword?: string;
  }>({});

  // Sort
  const [sortConfig, setSortConfig] = useState<{
    orderBy: string;
    order: "asc" | "desc";
  }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };

  // Fungsi untuk menangani pemilihan checkbox baris
  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const CustomTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      backgroundColor: "#f5f5f5",
      borderRadius: 4,
      padding: "8px 12px",
    },
  });

  // 🔄 Pastikan selectedRows update setelah rows berubah
  // useEffect(() => {
  //   const loadVendors = async () => {
  //     setLoadingVendors(true);
  //     try {
  //       const vendorsData = await fetchVendors();
  //       setVendors(vendorsData);
  //     } catch (error) {
  //       console.error("Gagal memuat vendors:", error);
  //     } finally {
  //       setLoadingVendors(false);
  //     }
  //   };

  //   loadVendors();

  //   setSelectedRows([]);
  // }, [rows]);

  const [filters, setFilters] = useState([{ field: "name", value: "" }]);
  const [employees, setEmployees] = useState<Employee[]>([]);

  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "name", label: "Employee Name" },
    { value: "nik", label: "Employee Number" },
    { value: "jobTitle", label: "Employee Job Title" },
    { value: "division", label: "Employee Division" },
    { value: "office", label: "Employee Office Location" },
    { value: "company", label: "Employee Vendor" },
    { value: "status", label: "Employee Status" },
    { value: "employeeType", label: "Employee Type" },
  ];

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ItemSearchParams`
      const searchParams: employeeSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getItems(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "name", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    setIsLoading(true);
    setError("");

    try {
      // Untuk search, gunakan reloadEmployee (semua data)
      setFilterParams({
        keyword: searchQuery,
      });
    } catch (err: any) {
      // Error handling tetap sama
      let errorMessage = "Terjadi kesalahan saat melakukan pencarian";
      if (err.response?.data) {
        const backendError = err.response.data;
        errorMessage = backendError.error || errorMessage;
        if (backendError.details) {
          errorMessage += `: ${backendError.details}`;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }
      setError(errorMessage);
      Swal.fire({
        icon: "error",
        title: "Gagal melakukan pencarian",
        text: errorMessage,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Pagination untuk payroll details dalam dialog
  const handlePayrollDetailPageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPagePayrollDetail(page);
  };

  const filterPayrollDetails = () => {
    if (!selectedEmployeeId) return [];

    // Pastikan semua data yang sesuai dengan employeeId terfilter
    const baseFiltered = payrollDetails.filter(
      (payroll) => payroll.employeeId === selectedEmployeeId
    );

    // Jika ada search query, tambahkan filter pencarian
    if (searchQueryPayrollDetail) {
      return baseFiltered.filter(
        (payroll) =>
          String(payroll.periodMonth).includes(searchQueryPayrollDetail) ||
          String(payroll.periodYear).includes(searchQueryPayrollDetail) ||
          payroll.paymentStatus
            .toLowerCase()
            .includes(searchQueryPayrollDetail.toLowerCase()) ||
          payroll.paymentType
            .toLowerCase()
            .includes(searchQueryPayrollDetail.toLowerCase())
      );
    }

    return baseFiltered;
  };

  const handleSearchPayrollDetail = async () => {
    // Skip jika search kosong
    if (!searchQuery.trim()) return;

    setIsLoading(true);
    setError("");

    try {
      // Panggil API search
      const results = await searchPayroll(searchQueryPayrollDetail.trim());

      // Update state dengan hasil
      setRowsPayrollDetail(results);
      setTotalItemsPayrollDetail(results.length);
      setTotalPagesPayrollDetail(
        Math.ceil(results.length / rowsPerPagePayrollDetail)
      );
    } catch (err: any) {
      let errorMessage = "Gagal melakukan pencarian";
      if (err.response?.data) {
        errorMessage = err.response.data.message || errorMessage;
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });

      // Fallback ke data lokal jika ada error
      const filtered = filterPayrollDetails();
      setRowsPayrollDetail(filtered);
      setTotalItemsPayrollDetail(filtered.length);
    } finally {
      setIsLoading(false);
    }
  };

  const resetFieldsByPaymentType = (paymentType: string) => {
    if (
      paymentType === "Bonus" ||
      paymentType === "THR" ||
      paymentType === "Other"
    ) {
      setPayrollData((prev) => ({
        ...prev,
        thrInstallmentCoeff: 0,
        thrInstallment: 0,
        pensionDplkInstallmentCoeff: 0,
        pensionDplkInstallment: 0,
        bpjsTkContributionCoeff: 0,
        bpjsTkContribution: 0,
        bpjsKesCompany: 0,
      }));
    }
  };

  const handleDownloadSlipGajiPDF = async (payroll: PayrollEntry) => {
    try {
      setIsLoading(true);

      // Ambil data employee
      const employee = rows.find((r) => r.id === payroll.employeeId);
      if (!employee) {
        Swal.fire("Error", "Data karyawan tidak ditemukan", "error");
        return;
      }

      const doc = new jsPDF("portrait", "mm", "a4");
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;

      // Tentukan posisi awal dengan padding minimal
      let yPos = 10;
      const leftMargin = 10;
      const rightMargin = 200;
      const lineHeight = 4; // Reduced line height
      const sectionSpacing = 3; // Reduced spacing between sections

      // ========== HEADER ==========
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", leftMargin, 5, 190, 30); // Reduced height to 30mm
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      yPos = 40; // Start after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 5;

      // ========== TITLE ==========
      doc.setFontSize(14); // Reduced from 16
      doc.text("SLIP GAJI", pageWidth / 2, yPos, { align: "center" });
      yPos += 6;
      doc.text("PT. Sinergi Properti Pratama", pageWidth / 2, yPos, {
        align: "center",
      });
      yPos += 5;

      // ========== PERIOD ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text(
        `Periode: ${payroll.periodMonth} ${payroll.periodYear}`,
        pageWidth / 2,
        yPos,
        { align: "center" }
      );
      yPos += 6;

      doc.setFontSize(8);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      // ========== EMPLOYEE INFO ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text("Informasi Karyawan", leftMargin, yPos);
      yPos += 6;

      doc.setFontSize(8); // Reduced from 10

      // Lebar kolom yang lebih fleksibel
      const col1Label = leftMargin; // Label kolom 1
      const col1Value = leftMargin + 48; // Value kolom 1
      const col2Label = leftMargin + 100; // Label kolom 2 (dari 90 jadi 80)
      const col2Value = leftMargin + 140; // Value kolom 2 (dari 125 jadi 105)

      // NIP dan Nama dalam 2 kolom
      doc.text(`NIP`, col1Label, yPos);
      doc.text(`: ${employee.nik || "-"}`, col1Value - 2, yPos);
      doc.text(`Nama Karyawan`, col2Label, yPos);
      doc.text(`: ${employee.name || "-"}`, col2Value - 5, yPos);
      yPos += lineHeight + 2;

      // Jabatan dan Wilayah
      doc.text(`Jabatan`, col1Label, yPos);
      const jobTitle = employee.jobTitle || "-";

      // Potong teks jabatan jika terlalu panjang
      const maxJobTitleWidth = col2Label - col1Value - 15; // Lebar maksimal untuk jabatan
      const truncatedJobTitle = doc.splitTextToSize(jobTitle, maxJobTitleWidth);

      // Tampilkan jabatan (mungkin multi-line jika panjang)
      let jobTitleY = yPos;
      if (truncatedJobTitle.length === 1) {
        doc.text(`: ${truncatedJobTitle[0]}`, col1Value - 2, jobTitleY);
      } else {
        // Multi-line untuk jabatan panjang
        doc.text(`: `, col1Value - 2, jobTitleY);
        for (let i = 0; i < truncatedJobTitle.length; i++) {
          doc.text(truncatedJobTitle[i], col1Value, jobTitleY + i * lineHeight);
        }
        // Update yPos untuk line berikutnya
        jobTitleY += (truncatedJobTitle.length - 1) * lineHeight;
      }

      const officeName =
        offices.find((o) => o.officeId === employee.office)?.officeName || "-";
      doc.text(`Wilayah`, col2Label, yPos);
      doc.text(`: ${officeName}`, col2Value - 5, yPos);

      // Update yPos dengan mempertimbangkan multi-line jabatan
      yPos = Math.max(yPos, jobTitleY) + lineHeight;

      // ========== UPAH TETAP (Compressed) ==========
      doc.setFontSize(10);
      doc.text("PEMASUKAN", leftMargin, yPos);
      doc.text("1. UPAH TETAP", leftMargin, yPos + 5);
      yPos += 11;

      doc.setFontSize(8);
      const upahPokok = Number(employee.salary) || 0;
      const tunjanganMasaKerja = Number(employee.serviceAllowance) || 0;
      const subtotalUpahTetap = upahPokok + tunjanganMasaKerja;

      // Column layout untuk menghemat space
      const col1 = leftMargin;
      const col2 = leftMargin + 48;
      const col3 = leftMargin + 120;
      const col4 = leftMargin + 170;

      doc.text(`Upah Pokok`, col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(upahPokok)}`, col2 - 2, yPos);
      yPos += lineHeight;

      doc.text(`Tunjangan Masa Kerja`, col1, yPos);
      doc.text(
        `: Rp ${formatNumberForSlip(tunjanganMasaKerja)}`,
        col2 - 2,
        yPos
      );
      yPos += lineHeight;

      doc.setFont(undefined, "bold");
      doc.text(`Subtotal Upah Tetap`, col1, yPos);
      doc.text(
        `: Rp ${formatNumberForSlip(subtotalUpahTetap)}`,
        col2 - 2,
        yPos
      );
      doc.setFont(undefined, "normal");
      yPos += 10;

      // ========== BANTUAN NON UPAH (Compressed - 2 columns) ==========
      // doc.line(leftMargin, yPos, rightMargin, yPos);
      // yPos += 6;

      doc.setFontSize(10);
      doc.text("2. BANTUAN NON UPAH", leftMargin, yPos);
      yPos += 6;

      doc.setFontSize(8);

      const bantuanItems = [
        {
          label: "Kontribusi",
          value: Number(employee.contributionAllowance) || 0,
        },
        {
          label: "Pembinaan",
          value: Number(employee.coachingAllowance) || 0,
        },
        {
          label: "Transportasi",
          value: Number(employee.transportAllowance) || 0,
        },
        { label: "Perumahan", value: Number(employee.housingAllowance) || 0 },
        {
          label: "Telekomunikasi",
          value: Number(employee.telecommunicationAllowance) || 0,
        },
        { label: "Jabatan", value: Number(employee.positionAllowance) || 0 },
        { label: "Pulsa", value: Number(employee.mobilePhoneAllowance) || 0 },
        { label: "Natura", value: Number(employee.naturaAllowance) || 0 },
        { label: "Lainnya", value: Number(employee.otherAllowance) || 0 },
        // { label: "Overtime", value: Number(payroll.overtimePay) || 0 },
        // { label: "Sppd", value: Number(payroll.sppd) || 0 },
      ];

      const subtotalBantuanNonUpah = bantuanItems.reduce(
        (sum, item) => sum + item.value,
        0
      );

      // Render bantuan dalam 2 kolom
      const bantuanCol1X = leftMargin;
      const bantuanCol2X = leftMargin + 100;
      const bantuanValueX = leftMargin + 48;
      const bantuanValueX2 = leftMargin + 140;

      let currentBantuanY = yPos;

      // Column 1 (items 1-5)
      for (let i = 0; i < 5 && i < bantuanItems.length; i++) {
        doc.text(bantuanItems[i].label, bantuanCol1X, currentBantuanY);
        doc.text(`:`, bantuanValueX - 2, currentBantuanY);
        doc.text(
          `Rp ${formatNumberForSlip(bantuanItems[i].value)}`,
          bantuanValueX,
          currentBantuanY
        );
        currentBantuanY += lineHeight;
      }

      // Reset untuk column 2
      currentBantuanY = yPos;

      // Column 2 (items 6-9)
      for (let i = 5; i < bantuanItems.length; i++) {
        doc.text(bantuanItems[i].label, bantuanCol2X, currentBantuanY);
        doc.text(`:`, bantuanValueX2 - 5, currentBantuanY);
        doc.text(
          `Rp ${formatNumberForSlip(bantuanItems[i].value)}`,
          bantuanValueX2 - 2,
          currentBantuanY
        );
        currentBantuanY += lineHeight;
      }

      yPos = Math.max(yPos + 5 * lineHeight, currentBantuanY);

      // Subtotal Bantuan Non Upah
      doc.setFont(undefined, "bold");
      doc.text(`Subtotal Bantuan Non Upah`, col1, yPos);
      doc.text(`:`, col2 - 2, yPos);
      doc.text(`Rp ${formatNumberForSlip(subtotalBantuanNonUpah)}`, col2, yPos);
      doc.setFont(undefined, "normal");
      yPos += 10;

      // ========== BONUS, THR, KOMPENSASI & OTHER ==========
      doc.setFontSize(10);
      doc.text("3. BONUS, THR, KOMPENSASI & LAIN-LAIN", leftMargin, yPos);
      yPos += 6;

      doc.setFontSize(8);
      const thr = payroll.thr || 0;
      const bonus = payroll.bonus || 0;
      const kompensasi = payroll.kompensasi || 0;
      const others = payroll.others || 0;

      const subtotal = bonus + thr + kompensasi + others;

      doc.text(`Bonus`, col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(bonus)}`, col2 - 2, yPos);
      yPos += lineHeight;

      doc.text(`Tunjangan Hari Raya (THR)`, col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(thr)}`, col2 - 2, yPos);
      yPos += lineHeight;

      doc.text(`Kompensasi`, col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(kompensasi)}`, col2 - 2, yPos);
      yPos += lineHeight;

      doc.text(`Lain-Lain`, col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(others)}`, col2 - 2, yPos);
      yPos += lineHeight;

      doc.setFont(undefined, "bold");
      doc.text(`Subtotal`, col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(subtotal)}`, col2 - 2, yPos);
      doc.setFont(undefined, "normal");
      yPos += 8;

      // ========== TOTAL PEMASUKAN ==========
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      doc.setFontSize(10);
      doc.text("TOTAL PEMASUKAN (A)", col1, yPos);
      const totalPemasukan =
        subtotalUpahTetap + subtotalBantuanNonUpah + subtotal;
      doc.setFontSize(8);
      doc.text(`Rp ${formatNumberForSlip(totalPemasukan)}`, col2, yPos);
      yPos += 8;

      // ========== POTONGAN ==========
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      doc.setFontSize(10);
      doc.text("POTONGAN", col1, yPos);
      yPos += 6;

      doc.setFontSize(8);

      const potonganBpjsKesehatan = Number(employee.potBpjsKes) || 0;
      const potonganBpjsTK = Number(employee.potBpjsTk) || 0;
      const potonganPph21 = Number(payroll.pph21);

      doc.text(`BPJS Kesehatan`, col1, yPos);
      doc.text(`Rp ${formatNumberForSlip(potonganBpjsKesehatan)}`, col2, yPos);
      yPos += lineHeight;

      doc.text(`BPJS Ketengakerjaan`, col1, yPos);
      doc.text(`Rp ${formatNumberForSlip(potonganBpjsTK)}`, col2, yPos);
      yPos += lineHeight;

      doc.text(`PPH 21`, col1, yPos);
      doc.text(`Rp ${formatNumberForSlip(potonganPph21)}`, col2, yPos);
      yPos += 6;

      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      // ========== TOTAL POTONGAN ==========
      doc.setFontSize(10);
      doc.text("TOTAL POTONGAN (B)", col1, yPos);
      const totalPotongan =
        potonganBpjsKesehatan + potonganBpjsTK + potonganPph21;
      doc.setFontSize(8);
      doc.text(`Rp ${formatNumberForSlip(totalPotongan)}`, col2, yPos);
      yPos += 8;

      // ========== GAJI BERSIH ==========
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      doc.text("GAJI BERSIH (A - B)", col1, yPos);
      const gajiBersih = totalPemasukan - totalPotongan;
      doc.text(`Rp ${formatNumberForSlip(gajiBersih)}`, col2, yPos);
      yPos += 70;

      // ========== FOOTER ==========
      doc.setFontSize(6); // Very small font for footer
      doc.setFont(undefined, "normal");

      // Cek jika masih ada space untuk footer
      if (yPos < pageHeight - 10) {
        doc.text(
          "Ini adalah slip gaji yang dibuat oleh komputer dan dianggap sah tanpa tanda tangan.",
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
        yPos += 4;
        doc.text(
          `Generated on: ${new Date().toLocaleDateString(
            "id-ID"
          )} ${new Date().toLocaleTimeString("id-ID")}`,
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
      }

      // ========== TANDA TANGAN (jika ada space) ==========
      // if (yPos < pageHeight - 30) {
      //   yPos = pageHeight - 30;
      //   doc.line(leftMargin + 120, yPos + 15, leftMargin + 170, yPos + 15);
      //   doc.text("Disetujui,", leftMargin + 145, yPos + 25, {
      //     align: "center",
      //   });
      // }

      // Download file
      doc.save(
        `Slip_Gaji_${employee.nik}_${employee.name}_${payroll.periodMonth}_${payroll.periodYear}.pdf`
      );
    } catch (error) {
      console.error("Error generating slip gaji PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate slip gaji PDF",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadSlipBonusPDF = async (payroll: PayrollEntry) => {
    try {
      setIsLoading(true);

      // Ambil data employee
      const employee = rows.find((r) => r.id === payroll.employeeId);
      if (!employee) {
        Swal.fire("Error", "Data karyawan tidak ditemukan", "error");
        return;
      }

      const doc = new jsPDF("portrait", "mm", "a4");
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;

      // Tentukan posisi awal dengan padding minimal
      let yPos = 10;
      const leftMargin = 10;
      const rightMargin = 200;
      const lineHeight = 4; // Reduced line height
      const sectionSpacing = 3; // Reduced spacing between sections

      // ========== HEADER ==========
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", leftMargin, 5, 190, 30); // Reduced height to 30mm
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      yPos = 40; // Start after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 5;

      // ========== TITLE ==========
      doc.setFontSize(14); // Reduced from 16
      doc.text("SLIP BONUS", pageWidth / 2, yPos, { align: "center" });
      yPos += 6;
      doc.text("PT. Sinergi Properti Pratama", pageWidth / 2, yPos, {
        align: "center",
      });
      yPos += 5;

      // ========== PERIOD ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text(
        `Periode: ${payroll.periodMonth} ${payroll.periodYear}`,
        pageWidth / 2,
        yPos,
        { align: "center" }
      );
      yPos += 6;

      doc.setFontSize(8);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      // ========== EMPLOYEE INFO ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text("Informasi Karyawan", leftMargin, yPos);
      yPos += 6;

      doc.setFontSize(8); // Reduced from 10

      // Lebar kolom yang lebih fleksibel
      const col1Label = leftMargin; // Label kolom 1
      const col1Value = leftMargin + 48; // Value kolom 1
      const col2Label = leftMargin + 100; // Label kolom 2 (dari 90 jadi 80)
      const col2Value = leftMargin + 140; // Value kolom 2 (dari 125 jadi 105)

      // NIP dan Nama dalam 2 kolom
      doc.text(`NIP`, col1Label, yPos);
      doc.text(`: ${employee.nik || "-"}`, col1Value - 2, yPos);
      doc.text(`Nama Karyawan`, col2Label, yPos);
      doc.text(`: ${employee.name || "-"}`, col2Value - 5, yPos);
      yPos += lineHeight + 2;

      // Jabatan dan Wilayah
      doc.text(`Jabatan`, col1Label, yPos);
      const jobTitle = employee.jobTitle || "-";

      // Potong teks jabatan jika terlalu panjang
      const maxJobTitleWidth = col2Label - col1Value - 15; // Lebar maksimal untuk jabatan
      const truncatedJobTitle = doc.splitTextToSize(jobTitle, maxJobTitleWidth);

      // Tampilkan jabatan (mungkin multi-line jika panjang)
      let jobTitleY = yPos;
      if (truncatedJobTitle.length === 1) {
        doc.text(`: ${truncatedJobTitle[0]}`, col1Value - 2, jobTitleY);
      } else {
        // Multi-line untuk jabatan panjang
        doc.text(`: `, col1Value - 2, jobTitleY);
        for (let i = 0; i < truncatedJobTitle.length; i++) {
          doc.text(truncatedJobTitle[i], col1Value, jobTitleY + i * lineHeight);
        }
        // Update yPos untuk line berikutnya
        jobTitleY += (truncatedJobTitle.length - 1) * lineHeight;
      }

      const officeName =
        offices.find((o) => o.officeId === employee.office)?.officeName || "-";
      doc.text(`Wilayah`, col2Label, yPos);
      doc.text(`: ${officeName}`, col2Value - 5, yPos);

      // Update yPos dengan mempertimbangkan multi-line jabatan
      yPos = Math.max(yPos, jobTitleY) + lineHeight;

      // ========== UPAH TETAP (Compressed) ==========
      doc.setFontSize(10);
      const upahPokok = Number(employee.salary) || 0;
      const tunjanganMasaKerja = Number(employee.serviceAllowance) || 0;
      const subtotalUpahTetap = upahPokok + tunjanganMasaKerja;
      const bonus = Number(payroll.bonus) || 0;

      // Column layout untuk menghemat space
      const col1 = leftMargin;
      const col2 = leftMargin + 48;
      const col3 = leftMargin + 120;
      yPos += 10;

      doc.text("PEMASUKAN", leftMargin, yPos);
      doc.text("1. BONUS", leftMargin, yPos + 5);
      doc.text(`: Rp ${formatNumberForSlip(bonus)}`, col2Value - 5, yPos + 5);
      yPos += 11;

      // ========== BONUS ==========
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      doc.text(" TOTAL BONUS", col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(bonus)}`, col2Value - 5, yPos);
      yPos += 160;

      // ========== FOOTER ==========
      doc.setFontSize(6); // Very small font for footer
      doc.setFont(undefined, "normal");

      // Cek jika masih ada space untuk footer
      if (yPos < pageHeight - 10) {
        doc.text(
          "Ini adalah slip bonus yang dibuat oleh komputer dan dianggap sah tanpa tanda tangan.",
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
        yPos += 4;
        doc.text(
          `Generated on: ${new Date().toLocaleDateString(
            "id-ID"
          )} ${new Date().toLocaleTimeString("id-ID")}`,
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
      }

      doc.save(
        `Slip_Bonus_${employee.nik}_${employee.name}_${payroll.periodMonth}_${payroll.periodYear}.pdf`
      );
    } catch (error) {
      console.error("Error generating slip gaji PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate slip gaji PDF",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadSlipThrPDF = async (payroll: PayrollEntry) => {
    try {
      setIsLoading(true);

      // Ambil data employee
      const employee = rows.find((r) => r.id === payroll.employeeId);
      if (!employee) {
        Swal.fire("Error", "Data karyawan tidak ditemukan", "error");
        return;
      }

      const doc = new jsPDF("portrait", "mm", "a4");
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;

      // Tentukan posisi awal dengan padding minimal
      let yPos = 10;
      const leftMargin = 10;
      const rightMargin = 200;
      const lineHeight = 4; // Reduced line height
      const sectionSpacing = 3; // Reduced spacing between sections

      // ========== HEADER ==========
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", leftMargin, 5, 190, 30); // Reduced height to 30mm
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      yPos = 40; // Start after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 5;

      // ========== TITLE ==========
      doc.setFontSize(14); // Reduced from 16
      doc.text("SLIP TUNJANGAN HARI RAYA (THR)", pageWidth / 2, yPos, {
        align: "center",
      });
      yPos += 6;
      doc.text("PT. Sinergi Properti Pratama", pageWidth / 2, yPos, {
        align: "center",
      });
      yPos += 5;

      // ========== PERIOD ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text(
        `Periode: ${payroll.periodMonth} ${payroll.periodYear}`,
        pageWidth / 2,
        yPos,
        { align: "center" }
      );
      yPos += 6;

      doc.setFontSize(8);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      // ========== EMPLOYEE INFO ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text("Informasi Karyawan", leftMargin, yPos);
      yPos += 6;

      doc.setFontSize(8); // Reduced from 10

      // Lebar kolom yang lebih fleksibel
      const col1Label = leftMargin; // Label kolom 1
      const col1Value = leftMargin + 48; // Value kolom 1
      const col2Label = leftMargin + 100; // Label kolom 2 (dari 90 jadi 80)
      const col2Value = leftMargin + 140; // Value kolom 2 (dari 125 jadi 105)

      // NIP dan Nama dalam 2 kolom
      doc.text(`NIP`, col1Label, yPos);
      doc.text(`: ${employee.nik || "-"}`, col1Value - 2, yPos);
      doc.text(`Nama Karyawan`, col2Label, yPos);
      doc.text(`: ${employee.name || "-"}`, col2Value - 5, yPos);
      yPos += lineHeight + 2;

      // Jabatan dan Wilayah
      doc.text(`Jabatan`, col1Label, yPos);
      const jobTitle = employee.jobTitle || "-";

      // Potong teks jabatan jika terlalu panjang
      const maxJobTitleWidth = col2Label - col1Value - 15; // Lebar maksimal untuk jabatan
      const truncatedJobTitle = doc.splitTextToSize(jobTitle, maxJobTitleWidth);

      // Tampilkan jabatan (mungkin multi-line jika panjang)
      let jobTitleY = yPos;
      if (truncatedJobTitle.length === 1) {
        doc.text(`: ${truncatedJobTitle[0]}`, col1Value - 2, jobTitleY);
      } else {
        // Multi-line untuk jabatan panjang
        doc.text(`: `, col1Value - 2, jobTitleY);
        for (let i = 0; i < truncatedJobTitle.length; i++) {
          doc.text(truncatedJobTitle[i], col1Value, jobTitleY + i * lineHeight);
        }
        // Update yPos untuk line berikutnya
        jobTitleY += (truncatedJobTitle.length - 1) * lineHeight;
      }

      const officeName =
        offices.find((o) => o.officeId === employee.office)?.officeName || "-";
      doc.text(`Wilayah`, col2Label, yPos);
      doc.text(`: ${officeName}`, col2Value - 5, yPos);

      // Update yPos dengan mempertimbangkan multi-line jabatan
      yPos = Math.max(yPos, jobTitleY) + lineHeight;

      // ========== UPAH TETAP (Compressed) ==========
      doc.setFontSize(10);
      const upahPokok = Number(employee.salary) || 0;
      const tunjanganMasaKerja = Number(employee.serviceAllowance) || 0;
      const subtotalUpahTetap = upahPokok + tunjanganMasaKerja;
      const thr = Number(payroll.thr) || 0;

      // Column layout untuk menghemat space
      const col1 = leftMargin;
      const col2 = leftMargin + 48;
      const col3 = leftMargin + 120;
      yPos += 10;

      doc.text("PEMASUKAN", leftMargin, yPos);
      doc.text("1. TUNJANGAN HARI RAYA (THR)", leftMargin, yPos + 5);
      doc.text(`: Rp ${formatNumberForSlip(thr)}`, col2Value - 5, yPos + 5);
      yPos += 11;

      // ========== BONUS ==========
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      doc.text(" TOTAL TUNJANGAN HARI RAYA (THR)", col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(thr)}`, col2Value - 5, yPos);
      yPos += 160;

      // ========== FOOTER ==========
      doc.setFontSize(6); // Very small font for footer
      doc.setFont(undefined, "normal");

      // Cek jika masih ada space untuk footer
      if (yPos < pageHeight - 10) {
        doc.text(
          "Ini adalah slip THR yang dibuat oleh komputer dan dianggap sah tanpa tanda tangan.",
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
        yPos += 4;
        doc.text(
          `Generated on: ${new Date().toLocaleDateString(
            "id-ID"
          )} ${new Date().toLocaleTimeString("id-ID")}`,
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
      }

      doc.save(
        `Slip_THR_${employee.nik}_${employee.name}_${payroll.periodMonth}_${payroll.periodYear}.pdf`
      );
    } catch (error) {
      console.error("Error generating slip gaji PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate slip gaji PDF",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadSlipKompensasiPDF = async (payroll: PayrollEntry) => {
    try {
      setIsLoading(true);

      // Ambil data employee
      const employee = rows.find((r) => r.id === payroll.employeeId);
      if (!employee) {
        Swal.fire("Error", "Data karyawan tidak ditemukan", "error");
        return;
      }

      const doc = new jsPDF("portrait", "mm", "a4");
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;

      // Tentukan posisi awal dengan padding minimal
      let yPos = 10;
      const leftMargin = 10;
      const rightMargin = 200;
      const lineHeight = 4; // Reduced line height
      const sectionSpacing = 3; // Reduced spacing between sections

      // ========== HEADER ==========
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", leftMargin, 5, 190, 30); // Reduced height to 30mm
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      yPos = 40; // Start after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 5;

      // ========== TITLE ==========
      doc.setFontSize(14); // Reduced from 16
      doc.text("SLIP KOMPENSASI", pageWidth / 2, yPos, { align: "center" });
      yPos += 6;
      doc.text("PT. Sinergi Properti Pratama", pageWidth / 2, yPos, {
        align: "center",
      });
      yPos += 5;

      // ========== PERIOD ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text(
        `Periode: ${payroll.periodMonth} ${payroll.periodYear}`,
        pageWidth / 2,
        yPos,
        { align: "center" }
      );
      yPos += 6;

      doc.setFontSize(8);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      // ========== EMPLOYEE INFO ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text("Informasi Karyawan", leftMargin, yPos);
      yPos += 6;

      doc.setFontSize(8); // Reduced from 10

      // Lebar kolom yang lebih fleksibel
      const col1Label = leftMargin; // Label kolom 1
      const col1Value = leftMargin + 48; // Value kolom 1
      const col2Label = leftMargin + 100; // Label kolom 2 (dari 90 jadi 80)
      const col2Value = leftMargin + 140; // Value kolom 2 (dari 125 jadi 105)

      // NIP dan Nama dalam 2 kolom
      doc.text(`NIP`, col1Label, yPos);
      doc.text(`: ${employee.nik || "-"}`, col1Value - 2, yPos);
      doc.text(`Nama Karyawan`, col2Label, yPos);
      doc.text(`: ${employee.name || "-"}`, col2Value - 5, yPos);
      yPos += lineHeight + 2;

      // Jabatan dan Wilayah
      doc.text(`Jabatan`, col1Label, yPos);
      const jobTitle = employee.jobTitle || "-";

      // Potong teks jabatan jika terlalu panjang
      const maxJobTitleWidth = col2Label - col1Value - 15; // Lebar maksimal untuk jabatan
      const truncatedJobTitle = doc.splitTextToSize(jobTitle, maxJobTitleWidth);

      // Tampilkan jabatan (mungkin multi-line jika panjang)
      let jobTitleY = yPos;
      if (truncatedJobTitle.length === 1) {
        doc.text(`: ${truncatedJobTitle[0]}`, col1Value - 2, jobTitleY);
      } else {
        // Multi-line untuk jabatan panjang
        doc.text(`: `, col1Value - 2, jobTitleY);
        for (let i = 0; i < truncatedJobTitle.length; i++) {
          doc.text(truncatedJobTitle[i], col1Value, jobTitleY + i * lineHeight);
        }
        // Update yPos untuk line berikutnya
        jobTitleY += (truncatedJobTitle.length - 1) * lineHeight;
      }

      const officeName =
        offices.find((o) => o.officeId === employee.office)?.officeName || "-";
      doc.text(`Wilayah`, col2Label, yPos);
      doc.text(`: ${officeName}`, col2Value - 5, yPos);

      // Update yPos dengan mempertimbangkan multi-line jabatan
      yPos = Math.max(yPos, jobTitleY) + lineHeight;

      // ========== UPAH TETAP (Compressed) ==========
      doc.setFontSize(10);
      const upahPokok = Number(employee.salary) || 0;
      const tunjanganMasaKerja = Number(employee.serviceAllowance) || 0;
      const subtotalUpahTetap = upahPokok + tunjanganMasaKerja;
      const kompensasi = Number(payroll.kompensasi) || 0;

      // Column layout untuk menghemat space
      const col1 = leftMargin;
      const col2 = leftMargin + 48;
      const col3 = leftMargin + 120;
      yPos += 10;

      doc.text("PEMASUKAN", leftMargin, yPos);
      doc.text("1. KOMPENSASI", leftMargin, yPos + 5);
      doc.text(
        `: Rp ${formatNumberForSlip(kompensasi)}`,
        col2Value - 5,
        yPos + 5
      );
      yPos += 11;

      // ========== BONUS ==========
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      doc.text(" TOTAL KOMPENSASI", col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(kompensasi)}`, col2Value - 5, yPos);
      yPos += 160;

      // ========== FOOTER ==========
      doc.setFontSize(6); // Very small font for footer
      doc.setFont(undefined, "normal");

      // Cek jika masih ada space untuk footer
      if (yPos < pageHeight - 10) {
        doc.text(
          "Ini adalah slip kompensasi yang dibuat oleh komputer dan dianggap sah tanpa tanda tangan.",
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
        yPos += 4;
        doc.text(
          `Generated on: ${new Date().toLocaleDateString(
            "id-ID"
          )} ${new Date().toLocaleTimeString("id-ID")}`,
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
      }

      doc.save(
        `Slip_Kompensasi_${employee.nik}_${employee.name}_${payroll.periodMonth}_${payroll.periodYear}.pdf`
      );
    } catch (error) {
      console.error("Error generating slip gaji PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate slip gaji PDF",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadSlipOthersPDF = async (payroll: PayrollEntry) => {
    try {
      setIsLoading(true);

      // Ambil data employee
      const employee = rows.find((r) => r.id === payroll.employeeId);
      if (!employee) {
        Swal.fire("Error", "Data karyawan tidak ditemukan", "error");
        return;
      }

      const doc = new jsPDF("portrait", "mm", "a4");
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;

      // Tentukan posisi awal dengan padding minimal
      let yPos = 10;
      const leftMargin = 10;
      const rightMargin = 200;
      const lineHeight = 4; // Reduced line height
      const sectionSpacing = 3; // Reduced spacing between sections

      // ========== HEADER ==========
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", leftMargin, 5, 190, 30); // Reduced height to 30mm
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      yPos = 40; // Start after header
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 5;

      // ========== TITLE ==========
      doc.setFontSize(14); // Reduced from 16
      doc.text("SLIP LAIN-LAIN", pageWidth / 2, yPos, { align: "center" });
      yPos += 6;
      doc.text("PT. Sinergi Properti Pratama", pageWidth / 2, yPos, {
        align: "center",
      });
      yPos += 5;

      // ========== PERIOD ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text(
        `Periode: ${payroll.periodMonth} ${payroll.periodYear}`,
        pageWidth / 2,
        yPos,
        { align: "center" }
      );
      yPos += 6;

      doc.setFontSize(8);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      // ========== EMPLOYEE INFO ==========
      doc.setFontSize(10); // Reduced from 12
      doc.text("Informasi Karyawan", leftMargin, yPos);
      yPos += 6;

      doc.setFontSize(8); // Reduced from 10

      // Lebar kolom yang lebih fleksibel
      const col1Label = leftMargin; // Label kolom 1
      const col1Value = leftMargin + 48; // Value kolom 1
      const col2Label = leftMargin + 100; // Label kolom 2 (dari 90 jadi 80)
      const col2Value = leftMargin + 140; // Value kolom 2 (dari 125 jadi 105)

      // NIP dan Nama dalam 2 kolom
      doc.text(`NIP`, col1Label, yPos);
      doc.text(`: ${employee.nik || "-"}`, col1Value - 2, yPos);
      doc.text(`Nama Karyawan`, col2Label, yPos);
      doc.text(`: ${employee.name || "-"}`, col2Value - 5, yPos);
      yPos += lineHeight + 2;

      // Jabatan dan Wilayah
      doc.text(`Jabatan`, col1Label, yPos);
      const jobTitle = employee.jobTitle || "-";

      // Potong teks jabatan jika terlalu panjang
      const maxJobTitleWidth = col2Label - col1Value - 15; // Lebar maksimal untuk jabatan
      const truncatedJobTitle = doc.splitTextToSize(jobTitle, maxJobTitleWidth);

      // Tampilkan jabatan (mungkin multi-line jika panjang)
      let jobTitleY = yPos;
      if (truncatedJobTitle.length === 1) {
        doc.text(`: ${truncatedJobTitle[0]}`, col1Value - 2, jobTitleY);
      } else {
        // Multi-line untuk jabatan panjang
        doc.text(`: `, col1Value - 2, jobTitleY);
        for (let i = 0; i < truncatedJobTitle.length; i++) {
          doc.text(truncatedJobTitle[i], col1Value, jobTitleY + i * lineHeight);
        }
        // Update yPos untuk line berikutnya
        jobTitleY += (truncatedJobTitle.length - 1) * lineHeight;
      }

      const officeName =
        offices.find((o) => o.officeId === employee.office)?.officeName || "-";
      doc.text(`Wilayah`, col2Label, yPos);
      doc.text(`: ${officeName}`, col2Value - 5, yPos);

      // Update yPos dengan mempertimbangkan multi-line jabatan
      yPos = Math.max(yPos, jobTitleY) + lineHeight;

      // ========== UPAH TETAP (Compressed) ==========
      doc.setFontSize(10);
      const upahPokok = Number(employee.salary) || 0;
      const tunjanganMasaKerja = Number(employee.serviceAllowance) || 0;
      const subtotalUpahTetap = upahPokok + tunjanganMasaKerja;
      const others = Number(payroll.others) || 0;

      // Column layout untuk menghemat space
      const col1 = leftMargin;
      const col2 = leftMargin + 48;
      const col3 = leftMargin + 120;
      yPos += 10;

      doc.text("PEMASUKAN", leftMargin, yPos);
      doc.text("1. LAIN-LAIN", leftMargin, yPos + 5);
      doc.text(`: Rp ${formatNumberForSlip(others)}`, col2Value - 5, yPos + 5);
      yPos += 11;

      // ========== BONUS ==========
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 6;

      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      doc.text(" TOTAL LAIN-LAIN", col1, yPos);
      doc.text(`: Rp ${formatNumberForSlip(others)}`, col2Value - 5, yPos);
      yPos += 160;

      // ========== FOOTER ==========
      doc.setFontSize(6); // Very small font for footer
      doc.setFont(undefined, "normal");

      // Cek jika masih ada space untuk footer
      if (yPos < pageHeight - 10) {
        doc.text(
          "Ini adalah slip lain-lain yang dibuat oleh komputer dan dianggap sah tanpa tanda tangan.",
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
        yPos += 4;
        doc.text(
          `Generated on: ${new Date().toLocaleDateString(
            "id-ID"
          )} ${new Date().toLocaleTimeString("id-ID")}`,
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
      }

      doc.save(
        `Slip_Lain-lain_${employee.nik}_${employee.name}_${payroll.periodMonth}_${payroll.periodYear}.pdf`
      );
    } catch (error) {
      console.error("Error generating slip gaji PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate slip gaji PDF",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Fungsi helper untuk format number di slip gaji
  const formatNumberForSlip = (value: number): string => {
    if (isNaN(value) || value === null || value === undefined) return "0";
    return new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const handleDownloadPph21PDF = async (payroll: PayrollEntry) => {
    try {
      if (payroll.paymentType === "Monthly Salary") {
        setIsLoading(true);

        // Ambil data employee
        const employee = rows.find((r) => r.id === payroll.employeeId);
        if (!employee) {
          Swal.fire("Error", "Data karyawan tidak ditemukan", "error");
          return;
        }

        const doc = new jsPDF("portrait", "mm", "a4");
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.width;

        // Tentukan posisi awal dengan padding minimal
        let yPos = 10;
        const leftMargin = 10;
        const rightMargin = 200;
        const lineHeight = 4; // Reduced line height
        const sectionSpacing = 3; // Reduced spacing between sections

        // ========== HEADER ==========
        try {
          const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
          const response = await fetch(headerImageUrl);
          if (response.ok) {
            const blob = await response.blob();
            const base64Image = await new Promise<string>((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result as string);
              reader.readAsDataURL(blob);
            });
            doc.addImage(base64Image, "JPEG", leftMargin, 5, 190, 30); // Reduced height to 30mm
          }
        } catch (imgError) {
          console.error("Failed to load header image:", imgError);
        }

        yPos = 40; // Start after header
        doc.setDrawColor(0);
        doc.setLineWidth(0.3);
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 5;

        // ========== TITLE ==========
        doc.setFontSize(14); // Reduced from 16
        doc.text("RINCIAN PPH 21", pageWidth / 2, yPos, { align: "center" });
        yPos += 6;

        doc.setFontSize(10);
        doc.text("Bukti Perhitungan Pajak Penghasilan", pageWidth / 2, yPos, {
          align: "center",
        });
        yPos += 6;

        doc.setFontSize(12);
        doc.text("PT. Sinergi Properti Pratama", pageWidth / 2, yPos, {
          align: "center",
        });
        yPos += 5;

        // ========== PERIOD ==========
        doc.setFontSize(10); // Reduced from 12
        doc.text(
          `Periode: ${payroll.periodMonth} ${payroll.periodYear}`,
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
        yPos += 2;

        doc.setFontSize(8);
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        // ========== EMPLOYEE INFO ==========
        doc.setFontSize(10); // Reduced from 12
        doc.text("Informasi Karyawan", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8); // Reduced from 10

        // Lebar kolom yang lebih fleksibel
        const col1Label = leftMargin; // Label kolom 1
        const col1Value = leftMargin + 50; // Value kolom 1
        const col2Label = leftMargin + 100; // Label kolom 2 (dari 90 jadi 80)
        const col2Value = leftMargin + 140; // Value kolom 2 (dari 125 jadi 105)

        // NIP dan Nama dalam 2 kolom
        doc.text(`NIP`, col1Label, yPos);
        doc.text(`: ${employee.nik || "-"}`, col1Value, yPos);
        doc.text(`Nama Karyawan`, col2Label, yPos);
        doc.text(`: ${employee.name || "-"}`, col2Value - 5, yPos);
        yPos += lineHeight + 2;

        // Jabatan dan Wilayah
        doc.text(`Jabatan`, col1Label, yPos);
        const jobTitle = employee.jobTitle || "-";

        // Potong teks jabatan jika terlalu panjang
        const maxJobTitleWidth = col2Label - col1Value - 15; // Lebar maksimal untuk jabatan
        const truncatedJobTitle = doc.splitTextToSize(
          jobTitle,
          maxJobTitleWidth
        );

        // Tampilkan jabatan (mungkin multi-line jika panjang)
        let jobTitleY = yPos;
        if (truncatedJobTitle.length === 1) {
          doc.text(`: ${truncatedJobTitle[0]}`, col1Value, jobTitleY);
        } else {
          // Multi-line untuk jabatan panjang
          doc.text(`: `, col1Value, jobTitleY);
          for (let i = 0; i < truncatedJobTitle.length; i++) {
            doc.text(
              truncatedJobTitle[i],
              col1Value + 2,
              jobTitleY + i * lineHeight
            );
          }
          // Update yPos untuk line berikutnya
          jobTitleY += (truncatedJobTitle.length - 1) * lineHeight;
        }

        const officeName =
          offices.find((o) => o.officeId === employee.office)?.officeName ||
          "-";
        doc.text(`Wilayah`, col2Label, yPos);
        doc.text(`: ${officeName}`, col2Value - 5, yPos);

        // Update yPos dengan mempertimbangkan multi-line jabatan
        yPos = Math.max(yPos, jobTitleY) + lineHeight;

        // ========== UPAH TETAP (Compressed) ==========
        doc.setFontSize(10);
        doc.text("PENGHASILAN BRUTO", leftMargin, yPos);
        doc.text("1. GAJI & TUNJANGAN TETAP", leftMargin, yPos + 5);
        yPos += 11;

        doc.setFontSize(8);
        const gajiPokok = Number(employee.salary) || 0;
        const tunjanganMasaKerja = Number(employee.serviceAllowance) || 0;
        const subtotalGajiTunjanganTetap = gajiPokok + tunjanganMasaKerja;

        // Column layout untuk menghemat space
        const col1 = leftMargin;
        const col2 = leftMargin + 50;
        const col3 = leftMargin + 120;
        const col4 = leftMargin + 170;

        doc.text(`Gaji Pokok`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(gajiPokok)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Tunjangan Masa Kerja`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(tunjanganMasaKerja)}`, col2, yPos);
        yPos += lineHeight;

        doc.setFont(undefined, "bold");
        doc.text(`Subtotal Gaji & Tunjangan Tetap`, col1, yPos);
        doc.text(
          `: Rp ${formatNumberForSlip(subtotalGajiTunjanganTetap)}`,
          col2,
          yPos
        );
        doc.setFont(undefined, "normal");
        yPos += 10;

        // ========== BANTUAN NON UPAH (Compressed - 2 columns) ==========
        // doc.line(leftMargin, yPos, rightMargin, yPos);
        // yPos += 6;

        doc.setFontSize(10);
        doc.text("2. BANTUAN LAIN, LEMBUR & SPPD", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8);

        const bantuanLemburSppdItems = [
          {
            label: "Kontribusi",
            value: Number(employee.contributionAllowance) || 0,
          },
          {
            label: "Pembinaan",
            value: Number(employee.coachingAllowance) || 0,
          },
          {
            label: "Transportasi",
            value: Number(employee.transportAllowance) || 0,
          },
          { label: "Perumahan", value: Number(employee.housingAllowance) || 0 },
          {
            label: "Telekomunikasi",
            value: Number(employee.telecommunicationAllowance) || 0,
          },
          { label: "Jabatan", value: Number(employee.positionAllowance) || 0 },
          { label: "Pulsa", value: Number(employee.mobilePhoneAllowance) || 0 },
          { label: "Natura", value: Number(employee.naturaAllowance) || 0 },
          { label: "Lainnya", value: Number(employee.otherAllowance) || 0 },
          { label: "Lembur", value: Number(payroll.overtimePay) || 0 },
          { label: "SPPD", value: Number(payroll.sppd) || 0 },
        ];

        const subtotalBantuanNonUpah = bantuanLemburSppdItems.reduce(
          (sum, item) => sum + item.value,
          0
        );

        // Render bantuan dalam 2 kolom
        const bantuanCol1X = leftMargin;
        const bantuanCol2X = leftMargin + 100;
        const bantuanValueX = leftMargin + 40;
        const bantuanValueX2 = leftMargin + 140;

        let currentBantuanY = yPos;

        // Column 1 (items 1-5)
        for (let i = 0; i < 5 && i < bantuanLemburSppdItems.length; i++) {
          doc.text(
            bantuanLemburSppdItems[i].label,
            bantuanCol1X,
            currentBantuanY
          );
          doc.text(`:`, bantuanValueX + 10, currentBantuanY);
          doc.text(
            `Rp ${formatNumberForSlip(bantuanLemburSppdItems[i].value)}`,
            bantuanValueX + 12,
            currentBantuanY
          );
          currentBantuanY += lineHeight;
        }

        // Reset untuk column 2
        currentBantuanY = yPos;

        // Column 2 (items 6-11)
        for (let i = 5; i < bantuanLemburSppdItems.length; i++) {
          doc.text(
            bantuanLemburSppdItems[i].label,
            bantuanCol2X,
            currentBantuanY
          );
          doc.text(`:`, bantuanValueX2 - 25, currentBantuanY);
          doc.text(
            `Rp ${formatNumberForSlip(bantuanLemburSppdItems[i].value)}`,
            bantuanValueX2 - 23,
            currentBantuanY
          );
          currentBantuanY += lineHeight;
        }

        yPos = Math.max(yPos + 5 * lineHeight, currentBantuanY);

        // Subtotal Bantuan Non Upah
        doc.setFont(undefined, "bold");
        doc.text(`Subtotal Bantuan Non Upah`, col1, yPos);
        doc.text(`:`, col1 + 20, yPos);
        doc.text(
          `: Rp ${formatNumberForSlip(subtotalBantuanNonUpah)}`,
          col2,
          yPos
        );
        doc.setFont(undefined, "normal");
        yPos += 10;

        // ========== PREMI JAMSOSTEK (Compressed) ==========
        doc.setFontSize(10);
        doc.text("3. PREMI JAMSOSTEK (DIBAYAR PERUSAHAAN)", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8);
        const jkk = Number(payroll.jkk) || 0;
        const jkm = Number(payroll.jkm) || 0;
        const bpjsKesCompany = Number(payroll.bpjsKesCompany) || 0;
        const subtotalPremiJamsostek = jkk + jkm + bpjsKesCompany;

        doc.text(`Jaminan Kecelakaan Kerja (JKK)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(jkk)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Jaminan Kematian (JKM)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(jkm)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`BPJS Kesehatan (JKS)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(bpjsKesCompany)}`, col2, yPos);
        yPos += lineHeight;

        doc.setFont(undefined, "bold");
        doc.text(`Subtotal Premi Jamsostek`, col1, yPos);
        doc.text(
          `: Rp ${formatNumberForSlip(subtotalPremiJamsostek)}`,
          col2,
          yPos
        );
        doc.setFont(undefined, "normal");
        yPos += 8;

        // ========== BONUS, THR, KOMPENSASI & OTHER ==========
        doc.setFontSize(10);
        doc.text("4. BONUS, THR, KOMPENSASI & LAIN-LAIN", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8);
        const thr = payroll.thr || 0;
        const bonus = payroll.bonus || 0;
        const kompensasi = payroll.kompensasi || 0;
        const others = payroll.others || 0;

        const subtotal = bonus + thr + kompensasi + others;

        doc.text(`Bonus`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(bonus)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Tunjangan Hari Raya (THR)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(thr)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Kompensasi`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(kompensasi)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`LAIN-LAIN`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(others)}`, col2, yPos);
        yPos += lineHeight;

        doc.setFont(undefined, "bold");
        doc.text(`Subtotal`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(subtotal)}`, col2, yPos);
        doc.setFont(undefined, "normal");
        yPos += 8;

        // ========== TOTAL PEMASUKAN ==========
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        doc.setFontSize(10);
        doc.text("TOTAL PEMASUKAN (A)", col1, yPos);

        let totalPemasukan = 0;

        if (payroll.paymentType === "Monthly Salary") {
          totalPemasukan =
            subtotalGajiTunjanganTetap +
            subtotalBantuanNonUpah +
            subtotalPremiJamsostek +
            subtotal;
        } else {
          totalPemasukan = subtotal;
        }

        doc.setFontSize(8);
        doc.text(`: Rp ${formatNumberForSlip(totalPemasukan)}`, col2, yPos);
        yPos += 8;

        // ========== POTONGAN ==========
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        doc.setFontSize(10);
        doc.text("Perhitungan PPh 21 (TER)", col1, yPos);
        yPos += 6;

        doc.setFontSize(8);

        const kategoriTER = employee.kategoriTER || 0;
        const TER = payroll.TER || 0;
        const pph21 = Number(payroll.pph21) || 0;

        doc.text(`Dasar Pengenaan Pajak`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(totalPemasukan)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Kategori TER`, col1, yPos);
        doc.text(`: ${kategoriTER}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Tarif Efektif`, col1, yPos);
        doc.text(`: ${TER}`, col2, yPos);
        yPos += lineHeight;

        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        // ========== GAJI BERSIH ==========
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text("PPH 21 Terhutang Bulan Ini", col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(pph21)}`, col3, yPos);
        yPos += 15;

        // ========== FOOTER ==========
        doc.setFontSize(6); // Very small font for footer
        doc.setFont(undefined, "normal");

        // Cek jika masih ada space untuk footer
        if (yPos < pageHeight - 10) {
          doc.text(
            "*Nilai ini adalah potongan pajak yang mengurangi Take Home Pay anda",
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
          yPos += 4;
          doc.text(
            "Document ini digenerate secara otomatis oleh sistem payroll PT. Sinergi Properti Pratama.",
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
          yPos += 4;
          doc.text(
            "Informasi ini bersifat rahasia dan hanya untuk pengguna pribadi karyawan yang bersangkutan.",
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
          yPos += 4;
          doc.text(
            `Generated on: ${new Date().toLocaleDateString(
              "id-ID"
            )} ${new Date().toLocaleTimeString("id-ID")}`,
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
        }

        // ========== TANDA TANGAN (jika ada space) ==========
        // if (yPos < pageHeight - 30) {
        //   yPos = pageHeight - 30;
        //   doc.line(leftMargin + 120, yPos + 15, leftMargin + 170, yPos + 15);
        //   doc.text("Disetujui,", leftMargin + 145, yPos + 25, {
        //     align: "center",
        //   });
        // }

        // Download file
        doc.save(
          `Slip_PPH21_${employee.nik}_${employee.name}_${payroll.periodMonth}_${payroll.periodYear}.pdf`
        );
      } else {
        setIsLoading(true);

        // Ambil data employee
        const employee = rows.find((r) => r.id === payroll.employeeId);
        if (!employee) {
          Swal.fire("Error", "Data karyawan tidak ditemukan", "error");
          return;
        }

        const doc = new jsPDF("portrait", "mm", "a4");
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.width;

        // Tentukan posisi awal dengan padding minimal
        let yPos = 10;
        const leftMargin = 10;
        const rightMargin = 200;
        const lineHeight = 4; // Reduced line height
        const sectionSpacing = 3; // Reduced spacing between sections

        // ========== HEADER ==========
        try {
          const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
          const response = await fetch(headerImageUrl);
          if (response.ok) {
            const blob = await response.blob();
            const base64Image = await new Promise<string>((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result as string);
              reader.readAsDataURL(blob);
            });
            doc.addImage(base64Image, "JPEG", leftMargin, 5, 190, 30); // Reduced height to 30mm
          }
        } catch (imgError) {
          console.error("Failed to load header image:", imgError);
        }

        yPos = 40; // Start after header
        doc.setDrawColor(0);
        doc.setLineWidth(0.3);
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 5;

        // ========== TITLE ==========
        doc.setFontSize(14); // Reduced from 16
        doc.text("RINCIAN PPH 21", pageWidth / 2, yPos, { align: "center" });
        yPos += 6;

        doc.setFontSize(10);
        doc.text("Bukti Perhitungan Pajak Penghasilan", pageWidth / 2, yPos, {
          align: "center",
        });
        yPos += 6;

        doc.setFontSize(12);
        doc.text("PT. Sinergi Properti Pratama", pageWidth / 2, yPos, {
          align: "center",
        });
        yPos += 5;

        // ========== PERIOD ==========
        doc.setFontSize(10); // Reduced from 12
        doc.text(
          `Periode: ${payroll.periodMonth} ${payroll.periodYear}`,
          pageWidth / 2,
          yPos,
          { align: "center" }
        );
        yPos += 2;

        doc.setFontSize(8);
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        // ========== EMPLOYEE INFO ==========
        doc.setFontSize(10); // Reduced from 12
        doc.text("Informasi Karyawan", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8); // Reduced from 10

        // Lebar kolom yang lebih fleksibel
        const col1Label = leftMargin; // Label kolom 1
        const col1Value = leftMargin + 48; // Value kolom 1
        const col2Label = leftMargin + 100; // Label kolom 2 (dari 90 jadi 80)
        const col2Value = leftMargin + 140; // Value kolom 2 (dari 125 jadi 105)

        // NIP dan Nama dalam 2 kolom
        doc.text(`NIP`, col1Label, yPos);
        doc.text(`: ${employee.nik || "-"}`, col1Value - 2, yPos);
        doc.text(`Nama Karyawan`, col2Label, yPos);
        doc.text(`: ${employee.name || "-"}`, col2Value - 5, yPos);
        yPos += lineHeight + 2;

        // Jabatan dan Wilayah
        doc.text(`Jabatan`, col1Label, yPos);
        const jobTitle = employee.jobTitle || "-";

        // Potong teks jabatan jika terlalu panjang
        const maxJobTitleWidth = col2Label - col1Value - 15; // Lebar maksimal untuk jabatan
        const truncatedJobTitle = doc.splitTextToSize(
          jobTitle,
          maxJobTitleWidth
        );

        // Tampilkan jabatan (mungkin multi-line jika panjang)
        let jobTitleY = yPos;
        if (truncatedJobTitle.length === 1) {
          doc.text(`: ${truncatedJobTitle[0]}`, col1Value - 2, jobTitleY);
        } else {
          // Multi-line untuk jabatan panjang
          doc.text(`: `, col1Value - 2, jobTitleY);
          for (let i = 0; i < truncatedJobTitle.length; i++) {
            doc.text(
              truncatedJobTitle[i],
              col1Value,
              jobTitleY + i * lineHeight
            );
          }
          // Update yPos untuk line berikutnya
          jobTitleY += (truncatedJobTitle.length - 1) * lineHeight;
        }

        const officeName =
          offices.find((o) => o.officeId === employee.office)?.officeName ||
          "-";
        doc.text(`Wilayah`, col2Label, yPos);
        doc.text(`: ${officeName}`, col2Value - 5, yPos);

        // Update yPos dengan mempertimbangkan multi-line jabatan
        yPos = Math.max(yPos, jobTitleY) + lineHeight;

        // ========== UPAH TETAP (Compressed) ==========
        doc.setFontSize(10);
        doc.text("PENGHASILAN BRUTO", leftMargin, yPos);
        doc.text("1. GAJI & TUNJANGAN TETAP", leftMargin, yPos + 5);
        yPos += 11;

        doc.setFontSize(8);
        const gajiPokok = Number(employee.salary) || 0;
        const tunjanganMasaKerja = Number(employee.serviceAllowance) || 0;
        const subtotalGajiTunjanganTetap = gajiPokok + tunjanganMasaKerja;

        // Column layout untuk menghemat space
        const col1 = leftMargin;
        const col2 = leftMargin + 50;
        const col3 = leftMargin + 120;
        const col4 = leftMargin + 170;

        doc.text(`Gaji Pokok`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(gajiPokok)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Tunjangan Masa Kerja`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(tunjanganMasaKerja)}`, col2, yPos);
        yPos += lineHeight;

        doc.setFont(undefined, "bold");
        doc.text(`Subtotal Gaji & Tunjangan Tetap`, col1, yPos);
        doc.text(
          `: Rp ${formatNumberForSlip(subtotalGajiTunjanganTetap)}`,
          col2,
          yPos
        );
        doc.setFont(undefined, "normal");
        yPos += 10;

        // ========== BANTUAN NON UPAH (Compressed - 2 columns) ==========
        // doc.line(leftMargin, yPos, rightMargin, yPos);
        // yPos += 6;

        doc.setFontSize(10);
        doc.text("2. BANTUAN LAIN, LEMBUR & SPPD", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8);

        const bantuanLemburSppdItems = [
          {
            label: "Kontribusi",
            value: Number(employee.contributionAllowance) || 0,
          },
          {
            label: "Pembinaan",
            value: Number(employee.coachingAllowance) || 0,
          },
          {
            label: "Transportasi",
            value: Number(employee.transportAllowance) || 0,
          },
          { label: "Perumahan", value: Number(employee.housingAllowance) || 0 },
          {
            label: "Telekomunikasi",
            value: Number(employee.telecommunicationAllowance) || 0,
          },
          { label: "Jabatan", value: Number(employee.positionAllowance) || 0 },
          { label: "Pulsa", value: Number(employee.mobilePhoneAllowance) || 0 },
          { label: "Natura", value: Number(employee.naturaAllowance) || 0 },
          { label: "Lainnya", value: Number(employee.otherAllowance) || 0 },
          { label: "Lembur", value: Number(payroll.overtimePay) || 0 },
          { label: "SPPD", value: Number(payroll.sppd) || 0 },
        ];

        const subtotalBantuanNonUpah = bantuanLemburSppdItems.reduce(
          (sum, item) => sum + item.value,
          0
        );

        // Render bantuan dalam 2 kolom
        const bantuanCol1X = leftMargin;
        const bantuanCol2X = leftMargin + 100;
        const bantuanValueX = leftMargin + 40;
        const bantuanValueX2 = leftMargin + 140;

        let currentBantuanY = yPos;

        // Column 1 (items 1-5)
        for (let i = 0; i < 5 && i < bantuanLemburSppdItems.length; i++) {
          doc.text(
            bantuanLemburSppdItems[i].label,
            bantuanCol1X,
            currentBantuanY
          );
          doc.text(`:`, bantuanValueX + 10, currentBantuanY);
          doc.text(
            `Rp ${formatNumberForSlip(bantuanLemburSppdItems[i].value)}`,
            bantuanValueX + 12,
            currentBantuanY
          );
          currentBantuanY += lineHeight;
        }

        // Reset untuk column 2
        currentBantuanY = yPos;

        // Column 2 (items 6-11)
        for (let i = 5; i < bantuanLemburSppdItems.length; i++) {
          doc.text(
            bantuanLemburSppdItems[i].label,
            bantuanCol2X,
            currentBantuanY
          );
          doc.text(`:`, bantuanValueX2 - 25, currentBantuanY);
          doc.text(
            `Rp ${formatNumberForSlip(bantuanLemburSppdItems[i].value)}`,
            bantuanValueX2 - 23,
            currentBantuanY
          );
          currentBantuanY += lineHeight;
        }

        yPos = Math.max(yPos + 5 * lineHeight, currentBantuanY);

        // Subtotal Bantuan Non Upah
        doc.setFont(undefined, "bold");
        doc.text(`Subtotal Bantuan Non Upah`, col1, yPos);
        doc.text(`:`, col1 + 20, yPos);
        doc.text(
          `: Rp ${formatNumberForSlip(subtotalBantuanNonUpah)}`,
          col2,
          yPos
        );
        doc.setFont(undefined, "normal");
        yPos += 10;

        // ========== PREMI JAMSOSTEK (Compressed) ==========
        doc.setFontSize(10);
        doc.text("3. PREMI JAMSOSTEK (DIBAYAR PERUSAHAAN)", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8);
        const jkk = Number(payroll.jkk) || 0;
        const jkm = Number(payroll.jkm) || 0;
        const bpjsKesCompany = Number(payroll.bpjsKesCompany) || 0;
        const subtotalPremiJamsostek = jkk + jkm + bpjsKesCompany;

        doc.text(`Jaminan Kecelakaan Kerja (JKK)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(jkk)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Jaminan Kematian (JKM)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(jkm)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`BPJS Kesehatan (JKS)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(bpjsKesCompany)}`, col2, yPos);
        yPos += lineHeight;

        doc.setFont(undefined, "bold");
        doc.text(`Subtotal Premi Jamsostek`, col1, yPos);
        doc.text(
          `: Rp ${formatNumberForSlip(subtotalPremiJamsostek)}`,
          col2,
          yPos
        );
        doc.setFont(undefined, "normal");
        yPos += 8;

        // ========== BONUS, THR, KOMPENSASI & OTHER==========
        doc.setFontSize(10);
        doc.text("4. BONUS, THR, KOMPENSASI & LAIN-LAIN", leftMargin, yPos);
        yPos += 6;

        doc.setFontSize(8);
        const thr = payroll.thr || 0;
        const bonus = payroll.bonus || 0;
        const kompensasi = payroll.kompensasi || 0;
        const others = payroll.others || 0;

        const subtotal = bonus + thr + kompensasi + others;

        doc.text(`Bonus`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(bonus)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Tunjangan Hari Raya (THR)`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(thr)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Kompensasi`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(kompensasi)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Lain-lain`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(others)}`, col2, yPos);
        yPos += lineHeight;

        doc.setFont(undefined, "bold");
        doc.text(`Subtotal`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(subtotal)}`, col2, yPos);
        doc.setFont(undefined, "normal");
        yPos += 8;

        // ========== TOTAL PEMASUKAN ==========
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        doc.setFontSize(10);
        doc.text("TOTAL PEMASUKAN (A)", col1, yPos);

        const totalPemasukan =
          subtotalGajiTunjanganTetap +
          subtotalBantuanNonUpah +
          subtotalPremiJamsostek +
          subtotal;

        doc.setFontSize(8);
        doc.text(`: Rp ${formatNumberForSlip(totalPemasukan)}`, col2, yPos);
        yPos += 8;

        // ========== POTONGAN ==========
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        doc.setFontSize(10);
        doc.text("Perhitungan PPh 21 (TER)", col1, yPos);
        yPos += 6;

        doc.setFontSize(8);

        const kategoriTER = employee.kategoriTER || 0;
        const TER = payroll.TER || 0;
        const pph21 = Number(payroll.pph21) || 0;

        doc.text(`Dasar Pengenaan Pajak`, col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(totalPemasukan)}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Kategori TER`, col1, yPos);
        doc.text(`: ${kategoriTER}`, col2, yPos);
        yPos += lineHeight;

        doc.text(`Tarif Efektif`, col1, yPos);
        doc.text(`: ${TER}`, col2, yPos);
        yPos += lineHeight;

        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        // ========== GAJI BERSIH ==========
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 6;

        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text("PPH 21 Terhutang Bulan Ini", col1, yPos);
        doc.text(`: Rp ${formatNumberForSlip(pph21)}`, col3, yPos);
        yPos += 15;

        // ========== FOOTER ==========
        doc.setFontSize(6); // Very small font for footer
        doc.setFont(undefined, "normal");

        // Cek jika masih ada space untuk footer
        if (yPos < pageHeight - 10) {
          doc.text(
            "*Nilai ini adalah potongan pajak yang mengurangi Take Home Pay anda",
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
          yPos += 4;
          doc.text(
            "Document ini digenerate secara otomatis oleh sistem payroll PT. Sinergi Properti Pratama.",
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
          yPos += 4;
          doc.text(
            "Informasi ini bersifat rahasia dan hanya untuk pengguna pribadi karyawan yang bersangkutan.",
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
          yPos += 4;
          doc.text(
            `Generated on: ${new Date().toLocaleDateString(
              "id-ID"
            )} ${new Date().toLocaleTimeString("id-ID")}`,
            pageWidth / 2,
            yPos,
            { align: "center" }
          );
        }

        // ========== TANDA TANGAN (jika ada space) ==========
        // if (yPos < pageHeight - 30) {
        //   yPos = pageHeight - 30;
        //   doc.line(leftMargin + 120, yPos + 15, leftMargin + 170, yPos + 15);
        //   doc.text("Disetujui,", leftMargin + 145, yPos + 25, {
        //     align: "center",
        //   });
        // }

        // Download file
        doc.save(
          `Slip_PPH21_${employee.nik}_${employee.name}_${payroll.periodMonth}_${payroll.periodYear}.pdf`
        );
      }
    } catch (error) {
      console.error("Error generating slip gaji PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate slip gaji PDF",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportToPDF = async () => {
    try {
      const doc = new jsPDF("landscape");

      // Fungsi format number dengan pembulatan tanpa desimal
      const formatNumberPDF = (value: number | null | undefined): string => {
        if (value === null || value === undefined || isNaN(value))
          return "Rp. 0";
        // Bulatkan ke bilangan bulat terdekat
        const roundedValue = Math.round(value);
        const formatted = new Intl.NumberFormat("id-ID", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(roundedValue);
        return `Rp. ${formatted}`;
      };

      // 1. Get all employee data with current filters
      const allEmployees = await getEmployees({
        ...filterParams,
        limit: 10000, // Get all data
        offset: 0,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      const employeesWithPaymentStatus = allEmployees.data.map((emp) => {
        // Get all payment statuses for this employee's payrolls
        const paymentStatuses = emp.payrollTads.map(
          (payroll) => payroll.paymentStatus
        );

        // Determine the overall status
        let overallStatus;
        if (paymentStatuses.length === 0) {
          overallStatus = "No Payroll";
        } else if (paymentStatuses.every((status) => status === "Paid")) {
          overallStatus = "Paid";
        } else if (paymentStatuses.some((status) => status === "Paid")) {
          overallStatus = "Partial Paid";
        } else {
          overallStatus = "Unpaid";
        }

        return {
          ...emp,
          overallPaymentStatus: overallStatus,
        };
      });

      // 2. Header Perusahaan
      try {
        const headerImageUrl = window.location.origin + "/img/KOP_SPP.jpg";
        const response = await fetch(headerImageUrl);
        if (response.ok) {
          const blob = await response.blob();
          const base64Image = await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
          });
          doc.addImage(base64Image, "JPEG", 10, 5, 280, 40);
        }
      } catch (imgError) {
        console.error("Failed to load header image:", imgError);
      }

      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(10, 42, 290, 42);

      // 3. Judul dan Informasi Filter
      doc.setFontSize(16);
      const officeName =
        offices.find((o) => o.officeId === filterParams.office)?.officeName ||
        rows[0]?.office ||
        "-";
      doc.text(`PAYROLL ${officeName}`, 150, 50, { align: "center" });
      doc.text(
        `PERIODE TAHUN ${filterPayrollParams.periodYear} BULAN ${filterPayrollParams.periodMonth}`,
        150,
        60,
        { align: "center" }
      );

      // 4. Siapkan header tabel
      const headers = [
        "No",
        "Employee Name",
        "Employee Number",
        "Upah Pokok",
        "Tunjangan Masa Kerja",
        "Bantuan-Bantuan",
        "Status",
        "Employee Type",
        "Total Gaji",
        "PPH 21",
        "BPJS Kesehatan",
        "BPJS TK",
        "Take Home Pay",
      ];

      // 5. Filter data berdasarkan kriteria yang sama dengan UI
      const filteredData = employeesWithPaymentStatus;

      // 6. Ambil semua data payroll untuk periode yang dipilih
      const allPayrolls = await fetchPayroll();

      console.log("allPayrolls", allPayrolls);

      const tableData = filteredData.map((employee, index) => {
        // Find payroll record for this employee berdasarkan filter periode
        const payroll = allPayrolls.find(
          (p) =>
            p.employeeId === employee.id &&
            (!filterPayrollParams.periodMonth ||
              Number(p.periodMonth) ===
                Number(filterPayrollParams.periodMonth)) &&
            (!filterPayrollParams.periodYear ||
              Number(p.periodYear) === Number(filterPayrollParams.periodYear))
        );

        console.log("payroll", payroll);

        const employeeOfficeName =
          offices.find((o) => o.officeId === employee.office)?.officeName ||
          "-";

        const baseSalary =
          Number(employee.salary || 0) + Number(employee.serviceAllowance || 0);
        const bantuan =
          (Number(employee.coachingAllowance) || 0) +
          (Number(employee.transportAllowance) || 0) +
          (Number(employee.housingAllowance) || 0) +
          (Number(employee.positionAllowance) || 0) +
          (Number(employee.telecommunicationAllowance) || 0) +
          (Number(employee.mobilePhoneAllowance) || 0) +
          (Number(employee.naturaAllowance) || 0) +
          (Number(employee.otherAllowance) || 0);

        console.log("Data payroll untuk employee:", {
          employeeId: employee.id,
          employeeName: employee.name,
          payrollTakeHomePay: payroll?.takeHomePay,
          employeeNetSalary: employee.netSalary,
        });

        // Ambil langsung dari payrollTads (tanpa fallback ke data employee)
        const takeHomePay =
          payroll?.takeHomePay ??
          // payroll?.cicilKom ??
          // payroll?.netSalary ??
          // payroll?.nettSalary ??
          // payroll?.gross ??
          // payroll?.grossPayroll ??
          0;

        const pph21 =
          payroll?.pph21 ??
          // payroll?.payrollPph21 ??
          // payroll?.potPph21 ??
          0;

        const totalGaji =
          payroll?.gross ?? payroll?.grossPayroll ?? employee.grossSalary ?? 0;

        // Debug log untuk memastikan data yang digunakan di PDF
        console.log("PDF export row", {
          employeeId: employee.id,
          employeeName: employee.name,
          periodMonth: filterPayrollParams.periodMonth,
          periodYear: filterPayrollParams.periodYear,
          payrollMatched: payroll,
          values: {
            totalGaji,
            pph21,
            takeHomePay,
            bpjsKes: employee.potBpjsKes,
            bpjsTk: employee.potBpjsTk,
          },
        });

        console.log("takeHomePay", takeHomePay, " pph21 ", pph21);

        return [
          (index + 1).toString(),
          employee.name || "-",
          employee.nik || "-",
          formatNumberPDF(baseSalary) || "0",
          formatNumberPDF(employee.serviceAllowance) || "0",
          formatNumberPDF(bantuan) || "0",
          employee.status || "-",
          employee.employeeType || "-",
          formatNumberPDF(totalGaji) || "0",
          formatNumberPDF(pph21) || "0",
          formatNumberPDF(employee.potBpjsKes) || "0",
          formatNumberPDF(employee.potBpjsTk) || "0",
          formatNumberPDF(takeHomePay) || "0",
        ];
      });

      // 7. Buat tabel di PDF
      autoTable(doc, {
        head: [headers],
        body:
          tableData.length > 0
            ? tableData
            : [
                [
                  "No data available",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                ],
              ],
        startY: 75,
        margin: { left: 10, right: 10 },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 8,
        },
        styles: {
          fontSize: 8,
          cellPadding: 3,
          overflow: "linebreak",
          halign: "left",
        },
        columnStyles: {
          0: { cellWidth: 10, halign: "left" }, // No
          1: { cellWidth: 35, halign: "left" }, // Employee Name
          2: { cellWidth: 25, halign: "left" }, // Employee Number
          3: { cellWidth: 25, halign: "left" }, // Upah Pokok
          4: { cellWidth: 20, halign: "left" }, // Tunjangan Masa Kerja
          5: { cellWidth: 18, halign: "left" }, // Bantuan-Bantuan
          6: { cellWidth: 15, halign: "left" }, // Status
          7: { cellWidth: 20, halign: "left" }, // Employee Type
          8: { cellWidth: 25, halign: "left" }, // Total Gaji
          9: { cellWidth: 20, halign: "left" }, // PPH 21
          10: { cellWidth: 20, halign: "left" }, // BPJS Kesehatan
          11: { cellWidth: 22, halign: "left" }, // BPJS TK
          12: { cellWidth: 25, halign: "left" }, // Take Home Pay
        },
        didDrawPage: function (data) {
          if (tableData.length === 0) {
            doc.setFontSize(10);
            doc.setTextColor(255, 0, 0);
            doc.text(
              "No data available for selected filters",
              15,
              data.cursor?.y + 15 || 100
            );
          }

          // Footer
          doc.setFontSize(8);
          doc.setTextColor(100);
          doc.text(
            `Showing ${tableData.length} entries`,
            15,
            doc.internal.pageSize.height - 10
          );
          doc.text(
            "Generated by Payroll SIMPRO",
            150,
            doc.internal.pageSize.height - 10,
            { align: "center" }
          );
          doc.text(
            `Page ${data.pageNumber}`,
            280,
            doc.internal.pageSize.height - 10,
            { align: "right" }
          );
        },
      });

      // 8. Simpan PDF
      const date = new Date().toISOString().slice(0, 10);
      doc.save(
        `Payroll_Report_${officeName}_${
          filterPayrollParams.periodMonth || "all"
        }_${filterPayrollParams.periodYear || "all"}.pdf`
      );
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: "Preparing Export...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Dapatkan data untuk export
      const exportData = await getExportData();

      // Buat workbook dengan dua sheet
      const wb = XLSX.utils.book_new();

      // Sheet untuk data employee
      const wsEmployees = XLSX.utils.json_to_sheet(exportData.employees);
      XLSX.utils.book_append_sheet(wb, wsEmployees, "Employees");

      // Sheet untuk data payroll
      const wsPayrolls = XLSX.utils.json_to_sheet(exportData.payrolls);
      XLSX.utils.book_append_sheet(wb, wsPayrolls, "Payrolls");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Payroll_Data_${date}.xlsx`);

      // Tutup loading
      Swal.close();
    } catch (error) {
      console.error("Export failed:", error);
      Swal.fire({
        icon: "error",
        title: "Export Gagal",
        text: error.message || "Gagal export data karyawan dan payroll",
      });
    }
  };

  // Fungsi untuk menentukan categoryTER berdasarkan PTKP
  const getCategoryTERFromPTKP = (ptkpCategory: PTKPCategory): CategoryTER => {
    switch (ptkpCategory) {
      case "TK/0": // Tidak Kawin dan Tidak Ada Tanggungan
      case "TK/1": // Tidak Kawin dengan Satu Tanggungan
      case "K/0": // Kawin dan Tidak Ada Tanggungan
        return "TER A";
      case "TK/2": // Tidak Kawin dengan Dua Tanggungan
      case "TK/3": // Tidak Kawin dengan Tiga Tanggungan
      case "K/1": // Kawin dengan Satu Tanggungan
      case "K/2": // Kawin dengan Dua Tanggungan
        return "TER B";
      case "K/3": // Kawin dengan Tiga Tanggungan
        return "TER C";
      default:
        return "TER A"; // Default value
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    try {
      // Ambil semua data employee dengan filter yang sama seperti tabel
      const allEmployees = await getEmployees({
        ...filterParams,
        limit: 1000000, // Ambil semua data
        offset: 0,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      // Formatting helper functions
      const formatDate = (date: Date | string | null): string => {
        if (!date) return "-";
        return new Date(date).toLocaleDateString("id-ID");
      };

      const formatDateTime = (date: Date | string | null): string => {
        if (!date) return "-";
        return new Date(date).toLocaleString("id-ID", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      };

      const formatCurrency = (amount: number | null | undefined): string => {
        if (amount === null || amount === undefined || isNaN(amount))
          return "-";
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(amount);
      };

      const formatNumber = (value, decimals = 2) => {
        if (value === null || value === undefined || value === "") return "";

        let num;

        // Handle jika value sudah number
        if (typeof value === "number") {
          num = value;
        }
        // Handle jika value string
        else if (typeof value === "string") {
          // Hapus semua karakter non-digit kecuali titik, koma, dan minus
          const cleanValue = value.replace(/[^\d.,-]/g, "");

          // Jika ada koma dan titik, asumsikan koma adalah desimal (format Indonesia)
          if (cleanValue.includes(",") && cleanValue.includes(".")) {
            // Format: 1.234,56 -> hapus titik ribu, ganti koma dengan titik
            num = parseFloat(cleanValue.replace(/\./g, "").replace(",", "."));
          }
          // Jika hanya ada koma
          else if (cleanValue.includes(",") && !cleanValue.includes(".")) {
            // Cek apakah koma sebagai pemisah ribu (1,234) atau desimal (1,23)
            const parts = cleanValue.split(",");
            if (parts.length === 2 && parts[1].length <= 2) {
              // Koma sebagai desimal (format Indonesia/Eropa)
              num = parseFloat(cleanValue.replace(",", "."));
            } else {
              // Koma sebagai pemisah ribu (format US)
              num = parseFloat(cleanValue.replace(/,/g, ""));
            }
          }
          // Jika hanya ada titik
          else if (!cleanValue.includes(",") && cleanValue.includes(".")) {
            // Cek apakah titik sebagai pemisah ribu (1.234) atau desimal (1.23)
            const parts = cleanValue.split(".");
            if (parts.length === 2 && parts[1].length <= 2) {
              // Titik sebagai desimal
              num = parseFloat(cleanValue);
            } else {
              // Titik sebagai pemisah ribu (format Indonesia)
              num = parseFloat(cleanValue.replace(/\./g, ""));
            }
          }
          // Tidak ada koma atau titik
          else {
            num = parseFloat(cleanValue);
          }
        }
        // Untuk tipe data lain
        else {
          num = Number(value);
        }

        if (isNaN(num)) {
          console.warn(`Cannot parse number from: ${value}`);
          return value; // Kembalikan as-is jika tidak bisa di-parse
        }

        // Return sebagai NUMBER (bukan string) untuk Excel
        // Gunakan Math.round untuk menghindari floating point issues
        const factor = Math.pow(10, decimals);
        return Math.round((num + Number.EPSILON) * factor) / factor;
      };

      let allPayroll = [];

      // Format data employee untuk sheet pertama
      const employeeData = allEmployees.data.map((employee) => {
        const companyName = employee.company
          ? vendors.find((v) => v.vendorId === employee.company)?.vendorName ||
            employee.company
          : "-";

        const officeName = employee.office
          ? offices.find((o) => o.officeId === employee.office)?.officeName ||
            employee.office
          : "-";

        // Hitung ulang nilai-nilai finansial untuk memastikan tidak ada NaN
        // const salary = Number(employee.salary) || 0;
        // const salaryCoefficient = Number(employee.salaryCoefficient) || 0;
        // const salaryDelta = Number(employee.salaryDelta) || 0;
        // const grossSalary = Number(employee.grossSalary) || 0;

        // const totalAllowances =
        //   (Number(employee.contributionAllowance) || 0) +
        //   (Number(employee.serviceAllowance) || 0) +
        //   (Number(employee.coachingAllowance) || 0) +
        //   (Number(employee.transportAllowance) || 0) +
        //   (Number(employee.housingAllowance) || 0) +
        //   (Number(employee.positionAllowance) || 0) +
        //   (Number(employee.telecommunicationAllowance) || 0) +
        //   (Number(employee.mobilePhoneAllowance) || 0) +
        //   (Number(employee.naturaAllowance) || 0) +
        //   (Number(employee.otherAllowance) || 0);

        // // const grossSalary =
        // //   (salaryCoefficient * salary) + (salaryDelta * salary) + totalAllowances;
        // const bpjsKesehatan = Number(employee.potBpjsKes) || 0;
        // const bpjsTK = Number(employee.potBpjsTk) || 0;

        // // Hitung PPH21
        // const PTKP =
        //   employee.pTKPCategory === "TK/0"
        //     ? 54000000
        //     : employee.pTKPCategory === "K/0"
        //     ? 58500000
        //     : employee.pTKPCategory === "K/1"
        //     ? 63000000
        //     : employee.pTKPCategory === "K/2"
        //     ? 67500000
        //     : 72000000;

        // const PKP = Math.max(0, grossSalary * 12 - PTKP);
        // let pph21PerTahun = 0;

        // if (PKP <= 60000000) {
        //   pph21PerTahun = PKP * 0.05;
        // } else if (PKP <= 250000000) {
        //   pph21PerTahun = 3000000 + (PKP - 60000000) * 0.15;
        // } else if (PKP <= 500000000) {
        //   pph21PerTahun = 34500000 + (PKP - 250000000) * 0.25;
        // } else if (PKP <= 5000000000) {
        //   pph21PerTahun = 97000000 + (PKP - 500000000) * 0.3;
        // } else {
        //   pph21PerTahun = 1447000000 + (PKP - 5000000000) * 0.35;
        // }

        // const pph21 = pph21PerTahun / 12;
        // const nettSalary = grossSalary - bpjsKesehatan - bpjsTK;

        employee.payrollTads.map((payroll) => allPayroll.push(payroll));

        return {
          // Identitas Dasar
          NIK: employee.nik || "-",
          "Nama Karyawan": employee.name || "-",
          "Jenis Kelamin": employee.gender || "-",
          "Tanggal Lahir": formatDate(employee.dateOfBirth),
          "Kota Lahir": employee.cityOfBirth || "-",
          Agama: employee.religion || "-",
          // "Status Pernikahan": employee.maritalStatus || "-",
          // "Jumlah Anak":
          //   employee.totalAnak !== null ? employee.totalAnak.toString() : "-",

          // Pekerjaan
          Perusahaan: companyName || "-",
          Direktorat: employee.directorate || "-",
          Divisi: employee.division || "-",
          Position: employee.position || "-",
          "Job Title": employee.jobTitle || "-",
          "Status Karyawan": employee.status || "-",
          "Tipe Karyawan": employee.employeeType || "-",
          Kantor: officeName || "-",
          "Tanggal Bergabung": formatDate(employee.dateOfJoining),
          "Tanggal Berakhir": formatDate(employee.expiredDate),

          // Data Finansial
          NPWP: employee.taxIdNumber || "-",
          Salary: formatNumber(employee.salary),
          "Salary Coefficient": employee.salaryCoefficient,
          "Salary Delta": formatNumber(employee.salaryDelta),
          "Tunjangan Masa Kerja": formatNumber(employee.serviceAllowance),
          "Bantuan Kontribusi": formatNumber(employee.contributionAllowance),
          "Bantuan Pembinaan": formatNumber(employee.pembinaan),
          "Bantuan Transportasi": formatNumber(employee.transportAllowance),
          "Bantuan Perumahaan": formatNumber(employee.housingAllowance),
          "Bantuan Telekomunikasi": formatNumber(employee.telkomAllowance),
          "Bantuan Jabatan": formatNumber(employee.positionAllowance),
          "Bantuan Pulsa": formatNumber(employee.pulsaAllowance),
          "Bantuan Natura": formatNumber(employee.naturaAllowance),
          "Bantuan Lainnya": formatNumber(employee.otherAllowance),
          "BPJS Kesehatan": formatNumber(employee.potBpjsKes),
          "BPJS TK": formatNumber(employee.potBpjsTk),
          "Category PTKP": employee.ptkpCategory || "-",
          "Category TER": employee.kategoriTER || "-",
          //PPH21: formatNumber(employee.potPph21),
          "Gross Salary": formatNumber(employee.grossSalary),
          "Bayar Pegawai": formatNumber(employee.netSalary),

          // Rekening Bank
          "Nama Bank": employee.bankName || "-",
          "Nomor Rekening": employee.bankNumber || "-",
          "Nama Pemilik Rekening": employee.bankAccountName || "-",

          // Lainnya
          Catatan: employee.notes || "-",
          "Tanggal Dibuat": formatDateTime(employee.createdAt),
          "Tanggal Diupdate": formatDateTime(employee.updateAt),
        };
      });

      console.log("payroll", allPayroll);

      // Format data payroll untuk sheet kedua
      // Pastikan payrollDetails terisi dengan memuat ulang data jika kosong
      let payrollDetailsToExport = payrollDetails;
      if (payrollDetails.length === 0) {
        const allPayrolls = await fetchPayroll();
        payrollDetailsToExport = allPayrolls;
      }

      const payrollData = allPayroll.map((payroll) => {
        // Cari data employee terkait
        const employee =
          rows.find((r) => r.id === payroll.employeeId) ||
          allEmployees.data.find((e) => e.id === payroll.employeeId);

        const grossSalary = employee?.grossSalary || 0;
        const nettSalary = employee?.nettSalary || 0;

        // Hitung komponen-komponen payroll
        const thrInstallment = (1 / 12) * grossSalary;
        const pensionDplkInstallment = (1 / 12) * grossSalary;

        // Hitung takeHomePay, gunakan nilai dari payroll jika ada, jika tidak hitung
        const takeHomePay =
          payroll.takeHomePay !== null && payroll.takeHomePay !== undefined
            ? payroll.takeHomePay
            : 0;

        // Perbaikan untuk bonusCoeff - handle undefined, null, dan non-number values
        let bonusCoeffFormatted = "-";
        if (payroll.bonusCoeff !== null && payroll.bonusCoeff !== undefined) {
          // Pastikan bonusCoeff adalah number sebelum memanggil toFixed()
          const bonusCoeffValue =
            typeof payroll.bonusCoeff === "number"
              ? payroll.bonusCoeff
              : Number(payroll.bonusCoeff);
          if (!isNaN(bonusCoeffValue)) {
            bonusCoeffFormatted = bonusCoeffValue.toFixed(2);
          }
        }

        return {
          NIK: employee?.nik || "-",
          "Employee Name": employee?.name || "-",
          "Payroll Period Month": payroll.periodMonth || "-",
          "Payroll Period Year": payroll.periodYear || "-",
          "Payment Status": payroll.paymentStatus || "-",
          "Payment Type": payroll.paymentType || "-",
          "Payment Date": payroll.paymentDate
            ? formatDate(payroll.paymentDate)
            : "-",
          "Cicilan THR": formatNumber(payroll.thrInstallment),
          "Cicilan Pensiun/Kompensasi": formatNumber(
            payroll.pensionDplkInstallment
          ),
          // "Koefisien Bonus": payroll.bonusCoeff !== null ? payroll.bonusCoeff.toFixed(2) : "-",

          // "Koefisien Iuran BPJS TK":
          //   payroll.bpjsTkContributionCoeff !== null
          //     ? payroll.bpjsTkContributionCoeff.toFixed(2)
          //     : "-",
          "Iuran JKK": formatNumber(payroll.jkk),
          "Iuran JKM": formatNumber(payroll.jkm),
          "Iuran JKS": formatNumber(payroll.bpjsKesCompany),
          Overtime: formatNumber(payroll.overtimePay) || 0,
          SPPD: formatNumber(payroll.sppd) || 0,
          PPH21: formatNumber(payroll.pph21),
          "Gross Payroll": formatNumber(payroll.gross),
          "Tarif TER": formatNumber(payroll.TER),
          "Take Home Pay": formatNumber(payroll.takeHomePay),
          "Bukti Pembayaran": payroll.paymentEvidence ? "Ada" : "Tidak Ada",
        };
      });

      return {
        employees: employeeData,
        payrolls: payrollData,
      };
    } catch (error) {
      console.error("Error preparing export data:", error);
      throw error;
    }
  };

  // Fungsi untuk memformat data karyawan untuk export
  const formatEmployeeForExport = (employee) => ({
    "Employee Name": employee.name,
    "Employee Number": employee.nik,
    Position: employee.position,
    Division: employee.division,
    Office: employee.office,
    Status: employee.status,
    "Employee Type": employee.employeeType,
    // ... tambahkan field lainnya sesuai kebutuhan
  });

  const [bulkDialogOpen, setBulkDialogOpen] = useState(false);
  const [bulkDialogExcelOpen, setBulkDialogExcelOpen] = useState(false);
  // Perbaikan state sesuai payload requirement
  const [bulkFormData, setBulkFormData] = useState({
    office: filterParams.office || "", // ← Tambahkan office dari filter
    employeeStatus: filterParams.status || "", // ← Tambahkan employeeStatus dari filter
    paymentType: "",
    periodMonth: null as number | null,
    periodYear: null as number | null,
    paymentStatus: "",
    paymentDate: null as Date | null,
    bpjsTkContributionCoeff: null as number | null,
    bonusCoeff: null as number | null,
  });

  // add payroll data ========================================================================
  const [payrollDataAdd, setPayrollDataAdd] = useState<{
    periodMonth: number | null;
    periodYear: number | null;
    paymentStatus: string;
    paymentEvidence: File | null;
    paymentDate: Date | null;
    paymentType: string;
    employeeId: number | null;
    thrInstallmentCoeff: number | null;
    thrInstallment: number | null;
    pensionDplkInstallmentCoeff: number | null;
    pensionDplkInstallment: number | null;
    jkk: number | null;
    jkm: number | null;
    payrollPph21: number | null;
    grossPayroll: number | null;
    bonusCoeff: number | null;
    takeHomePay: number | null;
    bpjsKesCompany: number | null;
    bonus: number | null;
    thr: number | null;
    kompensasi: number | null;
    others: number | null;
    overtime: number | null;
    sppd: number | null;
    bpjsTkContributionCoeff: number | null;
    bpjsTkContribution: number | null;
    tarifTER: number | null;
  }>({
    periodMonth: null,
    periodYear: null,
    paymentStatus: "",
    paymentEvidence: null,
    paymentDate: null,
    paymentType: "",
    employeeId: null,
    thrInstallmentCoeff: null,
    thrInstallment: null,
    pensionDplkInstallmentCoeff: null,
    pensionDplkInstallment: null,
    jkk: null,
    jkm: null,
    payrollPph21: null,
    grossPayroll: null,
    bonusCoeff: null,
    takeHomePay: null,
    bpjsKesCompany: null,
    bonus: null,
    thr: null,
    kompensasi: null,
    others: null,
    overtime: null,
    sppd: null,
    bpjsTkContributionCoeff: null,
    bpjsTkContribution: null,
    tarifTER: null,
  });

  const [payrollData, setPayrollData] = useState<PayrollEntry>({
    id: "",
    periodMonth: null,
    periodYear: null,
    paymentStatus: "",
    paymentEvidence: null,
    paymentEvidenceType: "",
    paymentDate: null,
    paymentType: "",
    thrInstallmentCoeff: null,
    thrInstallment: null,
    pensionDplkInstallmentCoeff: null,
    pensionDplkInstallment: null,
    jkk: null,
    jkm: null,
    payrollPph21: null,
    grossPayroll: null,
    bpjsKesCompany: null,
    bonusCoeff: null,
    takeHomePay: null,
    bonus: null,
    thr: null,
    kompensasi: null,
    others: null,
    overtime: null,
    sppd: null,
    bpjsTkContributionCoeff: null,
    bpjsTkContribution: null,
    tarifTER: null,
  });
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>(
    null
  );

  const [calculatedOpenEdit, setCalculatedOpenEdit] = useState({});

  const [payrollDetails, setPayrollDetails] = useState<PayrollEntry[]>([]);
  // State baru untuk edit form
  const [formData, setFormData] = useState<PayrollEntry>({
    id: "",
    periodMonth: null,
    periodYear: null,
    paymentStatus: "",
    paymentEvidence: null,
    paymentDate: null,
    paymentType: "",
    thrInstallmentCoeff: null,
    thrInstallment: null,
    pensionDplkInstallmentCoeff: null,
    pensionDplkInstallment: null,
    jkk: null,
    jkm: null,
    payrollPph21: null,
    grossPayroll: null,
    bonusCoeff: null,
    takeHomePay: null,
    bpjsKesCompany: null,
    bonus: null,
    thr: null,
    kompensasi: null,
    others: null,
    overtime: null,
    sppd: null,
    bpjsTkContributionCoeff: null,
    bpjsTkContribution: null,
    tarifTER: null,
  });

  // Tambahkan filter saat menampilkan data
  const filteredPayrollDetails = useMemo(() => {
    if (!selectedEmployeeId) return [];
    return payrollDetails.filter(
      (payroll) => payroll.employeeId === selectedEmployeeId
    );
  }, [payrollDetails, selectedEmployeeId]);

  // Di fungsi loadPayrollData:
  const loadPayrollData = async (employeeId: number) => {
    try {
      const allPayrolls = await fetchPayroll();
      const employeePayrolls = allPayrolls.filter(
        (payroll) => payroll.employeeId === employeeId
      );

      console.log("Loaded payroll data for employee:", employeePayrolls); // ← DEBUG

      const formattedPayrolls = employeePayrolls.map((payroll) => ({
        ...payroll,
        // Pastikan field-field kalkulasi ada
        takeHomePay:
          payroll.takeHomePay !== undefined ? payroll.takeHomePay : null,
        bonusCoeff: payroll.bonusCoeff || null,
        tarifTER: payroll.tarifTER || null,
        payrollPph21: payroll.payrollPph21 || null,
        grossPayroll: payroll.grossPayroll || null,
        paymentDate: new Date(payroll.paymentDate),
        paymentEvidence: payroll.paymentEvidence || null,
      }));

      console.log("Formatted payrolls:", formattedPayrolls); // ← DEBUG
      setPayrollDetails(formattedPayrolls);
    } catch (error) {
      console.error("Gagal memuat data payroll:", error);
      Swal.fire("Error", "Gagal memuat data payroll", "error");
    }
  };

  const nullPayroll = {
    id: "",
    periodMonth: null,
    periodYear: null,
    paymentStatus: "",
    paymentEvidence: null,
    paymentDate: null,
    paymentType: "",
    employeeId: null,
    thrInstallmentCoeff: null,
    thrInstallment: null,
    pensionDplkInstallmentCoeff: null,
    pensionDplkInstallment: null,
    jkk: null,
    jkm: null,
    payrollPph21: null,
    grossPayroll: null,
    bonusCoeff: null,
    takeHomePay: null,
    bpjsKesCompany: null,
    bonus: null,
    thr: null,
    kompensasi: null,
    others: null,
    overtime: null,
    sppd: null,
    bpjsTkContributionCoeff: null,
    bpjsTkContribution: null,
    tarifTER: null,
  };

  const initialPayrollDetail: PayrollEntry = {
    id: "",
    employeeId: null,
    periodMonth: null,
    periodYear: null,
    paymentStatus: "",
    paymentEvidence: null,
    paymentDate: null,
    paymentType: "",
    thrInstallmentCoeff: null,
    thrInstallment: null,
    pensionDplkInstallmentCoeff: null,
    pensionDplkInstallment: null,
    jkk: null,
    jkm: null,
    payrollPph21: null,
    grossPayroll: null,
    bonusCoeff: null,
    takeHomePay: null,
    bpjsKesCompany: null,
    bonus: null,
    thr: null,
    kompensasi: null,
    others: null,
    overtime: null,
    sppd: null,
    bpjsTkContributionCoeff: null,
    bpjsTkContribution: null,
    tarifTER: null,
  };

  const [payrollState, setPayrollState] = useState<PayrollFormState>({
    details: [],
    currentDetail: initialPayrollDetail,
  });

  const formatCurrency = (value: number | null): string => {
    if (value === null || isNaN(value)) return "0,00";

    return new Intl.NumberFormat("id-ID", {
      // style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const calculateSalariesEdit = (data: any) => {
    // Konversi semua nilai ke number dengan default 0 jika null/undefined
    const salary = Number(data.salary) || 0;
    const coefficient = Number(data.salaryCoefficient) || 0;
    const delta = Number(data.salaryDelta) || 0;

    // Hitung total allowances dengan konversi ke number
    const totalAllowances =
      (Number(data.contributionAllowance) || 0) +
      (Number(data.serviceAllowance) || 0) +
      (Number(data.coachingAllowance) || 0) +
      (Number(data.transportAllowance) || 0) +
      (Number(data.housingAllowance) || 0) +
      (Number(data.positionAllowance) || 0) +
      (Number(data.telecommunicationAllowance) || 0) +
      (Number(data.mobilePhoneAllowance) || 0) +
      (Number(data.naturaAllowance) || 0) +
      (Number(data.otherAllowance) || 0);

    const MAX_BPJS_BASIS = 12000000;
    const bpjsBasis = Math.min(salary, MAX_BPJS_BASIS);

    // Hitung Gross Salary
    const grossSalary = parseFloat(
      coefficient * salary + delta * salary + totalAllowances.toFixed(2)
    );

    // Hitung BPJS Kesehatan (1% dari gaji pokok)
    const bpjsKesehatan = (salary + data.serviceAllowance) * 0.01;

    // Hitung BPJS Ketenagakerjaan (2% JHT + 1% JP)
    const bpjsTK = (salary + data.serviceAllowance) * 0.03;

    // Hitung PPH21
    const PTKP =
      data.pTKPCategory === "TK/0"
        ? 54000000
        : data.pTKPCategory === "K/0"
        ? 58500000
        : data.pTKPCategory === "K/1"
        ? 63000000
        : data.pTKPCategory === "K/2"
        ? 67500000
        : 72000000;

    const PKP = Math.max(0, grossSalary * 12 - PTKP);
    let pph21PerTahun = 0;

    // Tarif progresif PPh 21
    if (PKP <= 60000000) {
      pph21PerTahun = PKP * 0.05;
    } else if (PKP <= 250000000) {
      pph21PerTahun = 3000000 + (PKP - 60000000) * 0.15;
    } else if (PKP <= 500000000) {
      pph21PerTahun = 34500000 + (PKP - 250000000) * 0.25;
    } else if (PKP <= 5000000000) {
      pph21PerTahun = 97000000 + (PKP - 500000000) * 0.3;
    } else {
      pph21PerTahun = 1447000000 + (PKP - 5000000000) * 0.35;
    }

    //const pph21 = parseFloat((pph21PerTahun / 12).toFixed(2));

    // Hitung Nett Salary
    const nettSalary = parseFloat(
      (grossSalary - bpjsKesehatan - bpjsTK).toFixed(2)
    );

    return {
      bpjsKesehatan: parseFloat(bpjsKesehatan.toFixed(2)),
      bpjsTK: parseFloat(bpjsTK.toFixed(2)),
      grossSalary: parseFloat(grossSalary.toFixed(2)),
      //pph21: parseFloat(pph21.toFixed(2)),
      nettSalary: parseFloat(nettSalary.toFixed(2)),
    };
  };

  const handleSalaryChangeEdit = (
    field: string,
    value: string | number | null,
    setData: Function,
    currentData: any
  ) => {
    // Handle empty string case (when user clears the input)
    const numericValue = value === "" || value === null ? null : Number(value);

    // Only proceed if the value is a valid number or null
    if (numericValue === null || !isNaN(numericValue)) {
      const newData = {
        ...currentData,
        [field]: numericValue,
      };

      const calculated = calculateSalariesEdit(newData);

      setData({
        ...newData,
        ...calculated,
      });
    }
  };

  // Handler untuk perubahan PTKP
  const handlePTKPChangeEdit = (e: React.ChangeEvent<{ value: unknown }>) => {
    const value = e.target.value as string;

    setEmployeeDataEdit((prev) => {
      const newData = {
        ...prev,
        pTKPCategory: value,
      };

      // Hitung ulang nilai yang tergantung
      const calculated = calculateSalariesEdit(newData);

      return {
        ...newData,
        ...calculated,
      };
    });
  };

  const handleAddPayrollDetail = () => {
    // Validasi
    const requiredFields = {
      periodMonth: payrollData.periodMonth,
      periodYear: payrollData.periodYear,
      paymentStatus: payrollData.paymentStatus,
      paymentDate: payrollData.paymentDate,
      paymentType: payrollData.paymentType,
      employeeId: selectedEmployeeId,
      // thrInstallmentCoeff: payrollData.thrInstallmentCoeff,
      // thrInstallment: payrollData.thrInstallment,
      // pensionDplkInstallmentCoeff: payrollData.pensionDplkInstallmentCoeff,
      // pensionDplkInstallment: payrollData.pensionDplkInstallment,
      //bonusCoeff: payrollData.bonusCoeff,
      takeHomePay: payrollData.takeHomePay,
      // bpjsKesCompany: payrollData.bpjsKesCompany,
      // bpjsTkContributionCoeff: payrollData.bpjsTkContributionCoeff,
      // bpjsTkContribution: payrollData.bpjsTkContribution,
    };

    const missingFields = Object.entries(requiredFields)
      .filter(([_, value]) => !value)
      .map(([key]) => key);

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        html: `
        <div>
          <p>Field yang harus diisi:</p>
          <ul>
            ${missingFields.map((field) => `<li>${field}</li>`).join("")}
          </ul>
        </div>
      `,
      });
      return;
    }

    // Tambahkan ke daftar payroll
    const newPayrollDetail: PayrollEntry = {
      ...payrollData,
      employeeId: selectedEmployeeId as number,
    };

    setPayrollDetails([...payrollDetails, newPayrollDetail]);
    resetPayrollFormAdd();
  };

  // Reset form
  const resetPayrollFormAdd = () => {
    setPayrollData({
      id: "",
      periodMonth: null,
      periodYear: null,
      paymentStatus: "",
      paymentEvidence: null,
      paymentDate: null,
      paymentType: "",
      thrInstallmentCoeff: null,
      thrInstallment: null,
      pensionDplkInstallmentCoeff: null,
      pensionDplkInstallment: null,
      jkk: null,
      jkm: null,
      payrollPph21: null,
      grossPayroll: null,
      bpjsKesCompany: null,
      bonusCoeff: null,
      takeHomePay: null,
      bonus: null,
      thr: null,
      kompensasi: null,
      others: null,
      overtime: null,
      sppd: null,
      bpjsTkContributionCoeff: null,
      bpjsTkContribution: null,
      tarifTER: null,
    });
    setPreviewUrl("");
  };

  const handleEditPayrollDetail = (payrollId: string | undefined) => {
    if (!payrollId) return;

    // 1. Validasi data form terlebih dahulu
    if (
      !payrollData.periodMonth ||
      !payrollData.periodYear ||
      !payrollData.paymentStatus ||
      !payrollData.paymentDate ||
      !payrollData.paymentType ||
      !selectedEmployeeId
    ) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan semua field mandatory terisi sebelum menyimpan perubahan.",
      });
      return;
    }

    console.log("Editing payroll data:", payrollData);

    // 2. Update data di state payrollDetails dengan mapping yang benar
    setPayrollDetails((prevDetails) =>
      prevDetails.map((item) =>
        item.id === payrollId
          ? {
              ...item,
              // Data dasar
              periodMonth: payrollData.periodMonth,
              periodYear: payrollData.periodYear,
              paymentStatus: payrollData.paymentStatus,
              paymentDate: payrollData.paymentDate,
              paymentType: payrollData.paymentType,

              // Data coefficients
              thrInstallmentCoeff: payrollData.thrInstallmentCoeff,
              pensionDplkInstallmentCoeff:
                payrollData.pensionDplkInstallmentCoeff,
              bpjsTkContributionCoeff: payrollData.bpjsTkContributionCoeff,

              // Data amounts - mapping ke field backend
              thrInstallment: payrollData.thrInstallment,
              pensionDplkInstallment: payrollData.pensionDplkInstallment,
              bpjsTkContribution: payrollData.bpjsTkContribution,
              bpjsKesCompany: payrollData.bpjsKesCompany,
              jkk: payrollData.jkk,
              jkm: payrollData.jkm,
              payrollPph21: payrollData.payrollPph21,
              grossPayroll: payrollData.grossPayroll,
              takeHomePay: payrollData.takeHomePay,
              bonusCoeff: payrollData.bonusCoeff,
              tarifTER: payrollData.tarifTER,
              bonus: payrollData.bonus,
              thr: payrollData.thr,
              kompensasi: payrollData.kompensasi,
              others: payrollData.others,
              overtime: payrollData.overtime,
              sppd: payrollData.sppd,

              // Evidence3q1
              paymentEvidence:
                payrollData.paymentEvidence || item.paymentEvidence,
            }
          : item
      )
    );

    // 3. Tampilkan konfirmasi dan reset form
    Swal.fire({
      icon: "success",
      title: "Berhasil",
      text: "Data payroll berhasil diupdate",
      timer: 1500,
      showConfirmButton: false,
    });

    // 4. Reset form setelah update
    resetPayrollFormEdit();
  };

  // Fungsi reset form
  const resetPayrollFormEdit = () => {
    setPayrollData({
      id: undefined,
      periodMonth: null,
      periodYear: null,
      paymentStatus: "",
      paymentEvidence: null,
      paymentDate: null,
      paymentType: "",
      employeeId: null,
      thrInstallmentCoeff: null,
      thrInstallment: null,
      pensionDplkInstallmentCoeff: null,
      pensionDplkInstallment: null,
      jkk: null,
      jkm: null,
      payrollPph21: null,
      grossPayroll: null,
      bpjsKesCompany: null,
      bonusCoeff: null,
      takeHomePay: null,
      bonus: null,
      thr: null,
      kompensasi: null,
      others: null,
      overtime: null,
      sppd: null,
      bpjsTkContributionCoeff: null,
      bpjsTkContribution: null,
      tarifTER: null,
    });
    setPreviewUrl("");
  };

  // Handler untuk klik row tabel
  const handleRowClickDetail = (payroll: PayrollEntry) => {
    if (!selectedEmployeeId) return;

    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
      setPreviewUrl("");
    }

    // Pastikan semua field penting di-set
    setPayrollData({
      ...payroll, // Spread existing payroll data
      id: payroll.id,
      employeeId: selectedEmployeeId,
      paymentDate: payroll.paymentDate ? new Date(payroll.paymentDate) : null,

      // Pastikan field-field kalkulasi juga terbawa
      bonusCoeff: payroll.bonusCoeff || null,
      tarifTER: payroll.TER || null,
      payrollPph21: payroll.pph21 || null, // ← TAMBAHKAN INI
      grossPayroll: payroll.gross || null, // ← TAMBAHKAN INI
      takeHomePay: payroll.takeHomePay || null, // ← TAMBAHKAN INI

      // Field lainnya yang mungkin diperlukan
      thrInstallmentCoeff: payroll.thrInstallmentCoeff || null,
      thrInstallment: payroll.thrInstallment || null,
      pensionDplkInstallmentCoeff: payroll.pensionDplkInstallmentCoeff || null,
      pensionDplkInstallment: payroll.pensionDplkInstallment || null,
      bpjsTkContributionCoeff: payroll.bpjsTkContributionCoeff || null,
      bpjsTkContribution: payroll.bpjsTkContribution || null,
      bpjsKesCompany: payroll.bpjsKesCompany || null,
      jkk: payroll.jkk || null,
      jkm: payroll.jkm || null,
      bonus: payroll.bonus || null,
      thr: payroll.thr || null,
      kompensasi: payroll.kompensasi || null,
      others: payroll.others || null,
      overtime: payroll.overtimePay || null,
      sppd: payroll.sppd || null,
    });

    // Handle preview gambar
    if (payroll.paymentEvidence) {
      if (typeof payroll.paymentEvidence === "string") {
        setPreviewUrl(payroll.paymentEvidence);
      } else if (payroll.paymentEvidence instanceof File) {
        const url = URL.createObjectURL(payroll.paymentEvidence);
        setPreviewUrl(url);
      }
    } else {
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleDeletePayrollDetailRow = async (index: number) => {
    try {
      // Get the payroll entry from the state using the index
      const payrollToDelete = payrollDetails[index];

      // Validate the data exists and has an ID
      if (!payrollToDelete || !payrollToDelete.id) {
        throw new Error("Data payroll tidak valid atau tidak memiliki ID");
      }

      // Confirmation dialog
      const confirmDelete = await Swal.fire({
        title: "Apakah Anda yakin?",
        text: `Anda akan menghapus payroll periode ${payrollToDelete.periodMonth}/${payrollToDelete.periodYear}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Ya, hapus!",
        cancelButtonText: "Batal",
      });

      if (!confirmDelete.isConfirmed) return;

      // Delete from API
      await deletePayroll(payrollToDelete.id);

      // Update state by removing the deleted item
      setPayrollDetails((prev) => [
        ...prev.slice(0, index),
        ...prev.slice(index + 1),
      ]);

      // Success notification
      await Swal.fire({
        title: "Berhasil!",
        text: "Data payroll telah dihapus",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Gagal menghapus payroll:", error);
      await Swal.fire({
        title: "Gagal!",
        text: error.message || "Terjadi kesalahan saat menghapus data",
        icon: "error",
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const newPayrollData = {
      ...payrollData,
      [name]: value,
    };

    // Jika paymentType berubah, handle logika khusus
    if (name === "paymentType") {
      handlePaymentTypeChange(value, newPayrollData);
    } else {
      setPayrollData(newPayrollData);
    }

    setErrors({
      ...errors,
      [name]: false,
    });
  };

  // Fungsi khusus untuk handle perubahan payment type
  const handlePaymentTypeChange = (
    paymentType: string,
    newPayrollData: any
  ) => {
    const salary = Number(employeeDataEdit.salary) || 0;
    const grossSalary = Number(employeeDataEdit.grossSalary) || 0;
    const serviceAllowance = Number(employeeDataEdit.serviceAllowance) || 0;
    const overtime = Number(newPayrollData.overtime) || 0;
    const sppd = Number(newPayrollData.sppd) || 0;
    const bonus = Number(newPayrollData.bonus) || 0;
    const thr = Number(newPayrollData.thr) || 0;
    const kompensasi = Number(newPayrollData.kompensasi) || 0;
    const others = Number(newPayrollData.others) || 0;

    let updatedData = { ...newPayrollData };

    // Reset fields berdasarkan payment type
    // if (["Bonus", "THR", "Other"].includes(paymentType)) {
    //   const grossPayroll = salary;

    //   updatedData = {
    //     ...updatedData,
    //     thrInstallmentCoeff: 0,
    //     thrInstallment: 0,
    //     pensionDplkInstallmentCoeff: 0,
    //     pensionDplkInstallment: 0,
    //     bpjsTkContributionCoeff: 0,
    //     bpjsTkContribution: 0,
    //     bpjsKesCompany: 0,
    //     jkk: 0, // Set ke 0 untuk Bonus/THR/Lain-lain
    //     jkm: 0, // Set ke 0 untuk Bonus/THR/Lain-lain
    //     payrollPph21: null,
    //     grossPayroll: grossPayroll,
    //     overtime: null,
    //     sppd: null,
    //     takeHomePay: null,
    //     tarifTER: null,
    //   };
    if (paymentType !== "Monthly Salary") {
      const calculated = calculateInstallments(
        updatedData,
        salary,
        grossSalary,
        overtime,
        sppd,
        bonus,
        thr,
        kompensasi,
        others
      );
      updatedData = {
        ...updatedData,
        ...calculated,
        // jkk: jkk,
        // jkm: jkm,
        // thrInstallment: thrInstallment,
        // pensionDplkInstallment: pensionDplkInstallment,
        // bpjsKesCompany: bpjsKesCompany,
        // grossPayroll: grossPayroll,
        payrollPph21: null,
        takeHomePay: null,
        tarifTER: null,
      };
    } else if (paymentType === "Monthly Salary") {
      // Untuk Monthly Salary: gross payroll = grossSalary + overtime + jkk + jkm + bpjsKesCompany
      // const jkk = (0.24 / 100) * (salary + serviceAllowance);
      // const jkm = (0.3 / 100) * (salary + serviceAllowance);
      // const bpjsKesCompany = (4 / 100) * (salary + serviceAllowance);
      // const grossPayroll =
      //   grossSalary + overtime + jkk + jkm + bpjsKesCompany + sppd;
      // const thrInstallment = (1 / 12) * salary;
      // const pensionDplkInstallment = (1 / 12) * salary;

      // console.log("Perhitungan gross payroll:", {
      //   grossSalary,
      //   overtime,
      //   jkk,
      //   jkm,
      //   bpjsKesCompany,
      //   total: grossPayroll,
      //   salary,
      //   serviceAllowance,
      // });

      // Untuk monthly salary, hitung semua nilai otomatis
      const calculated = calculateInstallments(
        updatedData,
        salary,
        grossSalary,
        overtime,
        sppd,
        bonus,
        thr,
        kompensasi,
        others
      );
      updatedData = {
        ...updatedData,
        ...calculated,
        // jkk: jkk,
        // jkm: jkm,
        // thrInstallment: thrInstallment,
        // pensionDplkInstallment: pensionDplkInstallment,
        // bpjsKesCompany: bpjsKesCompany,
        // grossPayroll: grossPayroll,
        payrollPph21: null,
        takeHomePay: null,
        tarifTER: null,
      };
    }

    setPayrollData(updatedData);
  };

  const handleInputChangeAdd = (e) => {
    const { name, value } = e.target;

    // Default handling for all other fields
    setPayrollDataAdd((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [errors, setErrors] = useState({
    periodMonth: false,
    periodYear: false,
    paymentStatus: false,
    paymentType: false,
    paymentDate: false,
    thrInstallmentCoeff: false,
    thrInstallment: false,
    pensionDplkInstallmentCoeff: false,
    pensionDplkInstallment: false,
    jkk: false,
    jkm: false,
    payrollPph21: false,
    grossPayroll: false,
    bpjsKesCompany: false,
    bonusCoeff: false,
    takeHomePay: false,
    bonus: false,
    thr: false,
    kompensasi: false,
    others: false,
    overtime: false,
    sppd: false,
    bpjsTkContributionCoeff: false,
    bpjsTkContribution: false,
    tarifTER: false,
  });

  const resetAddForm = () => {
    setPayrollDataAdd({
      periodMonth: null,
      periodYear: null,
      paymentStatus: "",
      paymentEvidence: null,
      paymentDate: null,
      paymentType: "",
      employeeId: null,
      thrInstallmentCoeff: null,
      thrInstallment: null,
      pensionDplkInstallmentCoeff: null,
      pensionDplkInstallment: null,
      jkk: null,
      jkm: null,
      payrollPph21: null,
      grossPayroll: null,
      bpjsKesCompany: null,
      bonusCoeff: null,
      takeHomePay: null,
      bonus: null,
      thr: null,
      kompensasi: null,
      others: null,
      overtime: null,
      sppd: null,
      bpjsTkContributionCoeff: null,
      bpjsTkContribution: null,
      tarifTER: null,
    });
    setPreviewUrl("");
  };

  useEffect(() => {
    resetForm();
  }, [selectedEmployeeId]);

  const validateFormAdd = () => {
    const newErrors = {
      periodMonth: !payrollDataAdd.periodMonth,
      periodYear: !payrollDataAdd.periodYear,
      paymentStatus: !payrollDataAdd.paymentStatus,
      paymentEvidence: !payrollDataAdd.paymentEvidence,
      paymentDate: !payrollDataAdd.paymentDate,
      paymentType: !payrollDataAdd.paymentType,
      employeeId: !payrollDataAdd.employeeId,
      thrInstallmentCoeff: !payrollDataAdd.thrInstallmentCoeff,
      thrInstallment: !payrollDataAdd.thrInstallment,
      pensionDplkInstallmentCoeff: !payrollDataAdd.pensionDplkInstallmentCoeff,
      pensionDplkInstallment: !payrollDataAdd.pensionDplkInstallment,
      bpjsKesCompany: !payrollDataAdd.bpjsKesCompany,
      jkk: !payrollDataAdd.jkk,
      jkm: !payrollDataAdd.jkm,
      payrollPph21: !payrollDataAdd.payrollPph21,
      grossPayroll: !payrollDataAdd.grossPayroll,
      // bonusCoeff: !payrollDataAdd.bonusCoeff,
      takeHomePay: !payrollDataAdd.takeHomePay,
      overtime: !payrollDataAdd.overtime,
      sppd: !payrollData.sppd,
      bpjsTkContributionCoeff: !payrollDataAdd.bpjsTkContributionCoeff,
      bpjsTkContribution: !payrollDataAdd.bpjsTkContribution,
      tarifTER: !payrollDataAdd.tarifTER,
    };

    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const [roles, setRoles] = useState<Role[]>([]);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [offices, setOffices] = useState<Office[]>([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [loadingOffices, setLoadingOffices] = useState(false);
  // In your component state:
  const [availableRoles, setAvailableRoles] = useState<Role[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<SelectedRole[]>([]);
  const [roleSearch, setRoleSearch] = React.useState("");

  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleSaveAdd = async () => {
    try {
      if (!validateFormAdd()) {
        showPopupMandatoryError();
        return;
      }

      const result = await createPayroll(payrollDataAdd);

      Swal.fire({
        icon: "success",
        title: "Payroll berhasil dibuat",
        html: `
          <div>
            <p>Data karyawan, user account, dan role assignment sukses dibuat</p>
            <p>Default password: <strong>qwerty123!</strong></p>
            <p><em>User diharuskan mengubah password pada pertama kali login</em></p>
          </div>
        `,
        confirmButtonColor: "#0F62FE",
      });

      setOpenAddEmployeeDialog(false);
      reloadEmployee();
    } catch (error: any) {
      let errorTitle = "Gagal membuat karyawan";
      let errorDetails = "";

      // Handle backend error response
      if (error.response?.data) {
        const backendError = error.response.data;

        // Debug log untuk melihat struktur error
        console.log("Backend Error Structure:", {
          error: backendError.error,
          details: backendError.details,
          errors: backendError.errors,
          duplicates: backendError.duplicates,
        });

        // Main error message
        errorTitle = backendError.error || errorTitle;

        // Handle email validation specifically - PERBAIKAN UTAMA DI SINI
        if (backendError.details) {
          if (
            /validation isEmail on email failed/i.test(backendError.details)
          ) {
            errorTitle = "Format Email Tidak Valid";
            errorDetails =
              "Harap masukkan alamat email yang benar (contoh: nama@perusahaan.com)";
          } else {
            // Hanya gunakan details jika bukan error email
            errorDetails = backendError.details;
          }
        }

        // Handle validation errors
        if (backendError.errors) {
          const validationMessages = Object.values(backendError.errors)
            .map((err: any) => {
              // Custom mapping untuk error email
              if (err.path === "email" && err.validatorKey === "isEmail") {
                return "• Format email tidak valid (contoh: nama@perusahaan.com)";
              }
              return `• ${err.message}`;
            })
            .join("\n");

          // Gabungkan dengan error details jika ada
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }

        // Handle duplicate fields
        if (backendError.duplicates) {
          const duplicateMessages = backendError.duplicates
            .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
            .join("\n");

          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
      // Handle network or other errors
      else {
        errorDetails =
          error.message || "Terjadi kesalahan yang tidak diketahui";
      }

      // Show error in Swal
      Swal.fire({
        icon: "error",
        title: errorTitle,
        html: `
          <div style="text-align: left;">
            <p style="font-weight: bold; margin-bottom: 8px;">${errorTitle}</p>
            ${
              errorDetails
                ? `<div style="
                    color: #d32f2f;
                    background: #ffebee;
                    padding: 10px;
                    border-radius: 4px;
                    font-size: 0.9em;
                    border-left: 3px solid #d32f2f;
                  ">
                    ${errorDetails.replace(/\n/g, "<br>")}
                  </div>`
                : ""
            }
          </div>
        `,
        confirmButtonColor: "#0F62FE",
      });
    }
  };

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const [roleOptions, setRoleOptions] = useState<RoleOption[]>([]);
  const [newRole, setNewRole] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const handleFileUpload = (file: File) => {
    if (!file) return;

    const validTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Format file tidak valid",
        text: "Hanya diperbolehkan file PDF, EXCEL & WORD!",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    setPayrollData((prev) => ({
      ...prev,
      paymentEvidence: file,
      paymentEvidenceType: "pdf",
    }));

    setSelectedFile(file);
    setFileName(file.name);

    // Untuk PDF, kita tidak membuat preview URL seperti gambar
    // Cukup set previewUrl ke string kosong atau null
    setPreviewUrl("file_uploaded"); // Flag bahwa PDF sudah diupload
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleCloseAdd = () => {
    setOpenAddEmployeeDialog(false);
    resetAddForm(); // Reset form saat ditutup
  };

  //edit employee data ========================================================================
  const [isEditing, setIsEditing] = useState(false);
  const [roleSearchEdit, setRoleSearchEdit] = React.useState("");

  const [employeeDataEdit, setEmployeeDataEdit] = useState<{
    id: string;
    name: string;
    dateOfBirth: Date | null;
    cityOfBirth: string;
    religion: string;
    address: string;
    phone: number | null;
    email: string;
    gender: string;
    maritalStatus: string;
    totalAnak: number | null;
    nik: string;
    position: any[];
    directorate: string;
    division: string;
    jobTitle: string;
    status: string;
    employeeType: string;
    office: string;
    company: string; // <-- Jadikan opsional
    dateOfJoining: Date | null;
    expiredDate: Date | null;
    taxIdNumber: string;
    salary: number | null;
    salaryCoefficient: number | null;
    salaryDelta: number | null;
    contributionAllowance: number | null;
    serviceAllowance: number | null;
    coachingAllowance: number | null;
    transportAllowance: number | null;
    housingAllowance: number | null;
    telecommunicationAllowance: number | null;
    positionAllowance: number | null;
    mobilePhoneAllowance: number | null;
    overtimeAllowance: number | null;
    naturaAllowance: number | null;
    otherAllowance: number | null;
    bankName: string;
    bankNumber: string;
    bankAccountName: string;
    notes: string;
    bpjsKesehatan: number | null;
    bpjsTK: number | null;
    pTKPCategory: string;
    categoryTER: CategoryTER;
    pph21: number | null;
    grossSalary: number | null;
    nettSalary: number | null;
    file: File | null;
    photoProfile: string;
    previewUrl: string;
  }>({
    id: "",
    name: "",
    dateOfBirth: null,
    cityOfBirth: "",
    religion: "",
    address: "",
    phone: null,
    email: "",
    gender: "",
    maritalStatus: "",
    totalAnak: 0,
    nik: "",
    position: [],
    directorate: "",
    division: "",
    jobTitle: "",
    status: "",
    employeeType: "",
    office: "",
    company: "", // <-- Tambahkan ini
    dateOfJoining: null,
    expiredDate: null,
    taxIdNumber: "",
    salary: null,
    salaryCoefficient: null,
    salaryDelta: null,
    contributionAllowance: null,
    serviceAllowance: null,
    coachingAllowance: null,
    transportAllowance: null,
    housingAllowance: null,
    telecommunicationAllowance: null,
    positionAllowance: null,
    mobilePhoneAllowance: null,
    overtimeAllowance: null,
    naturaAllowance: null,
    otherAllowance: null,
    bankName: "",
    bankNumber: "",
    bankAccountName: "",
    notes: "",
    bpjsKesehatan: null,
    bpjsTK: null,
    pTKPCategory: "TK/0",
    categoryTER: "TER A",
    pph21: null,
    grossSalary: null,
    nettSalary: null,
    file: null,
    photoProfile: "",
    previewUrl: "",
  });

  const handleOpenEditDialog = async (id: number) => {
    setIsLoading(true);
    try {
      const data = await getEmployeeById(id);
      setSelectedEmployeeId(id);

      // 🔥 LOAD PAYROLL DATA TERBARU SETIAP KALI DIALOG DIBUKA
      await loadPayrollData(id);

      // Set rowsPayrollDetail dengan semua data yang sudah difilter
      const filtered = payrollDetails.filter((p) => p.employeeId === id);
      setRowsPayrollDetail(filtered);
      setTotalItemsPayrollDetail(filtered.length);
      setTotalPagesPayrollDetail(
        Math.ceil(filtered.length / rowsPerPagePayrollDetail)
      );

      let previewUrl;
      if (data.photoProfile) {
        previewUrl = await fetchEmployeePhotoBlob(data.photoProfile);
      }

      const normalizedPosition = Array.isArray(data.position)
        ? data.position
        : typeof data.position === "string" && data.position != ""
        ? JSON.parse(data.position) || []
        : data.position
        ? [data.position]
        : [];

      setEmployeeDataEdit({
        id: data.id,
        name: data.name,
        dateOfBirth: data.dateOfBirth || null,
        cityOfBirth: data.cityOfBirth,
        religion: data.religion,
        address: data.address,
        phone: data.phone || null,
        email: data.email,
        gender: data.gender,
        //maritalStatus: data.maritalStatus,
        //totalAnak: data.totalAnak || 0,
        nik: data.nik,
        position: normalizedPosition,
        directorate: data.directorate,
        division: data.division,
        jobTitle: data.jobTitle,
        status: data.status,
        employeeType: data.employeeType,
        office: data.office || "",
        company: data.company || "",
        dateOfJoining: data.dateOfJoining || null,
        expiredDate: data.expiredDate || null,
        taxIdNumber: data.taxIdNumber,
        salary: data.salary || null,
        salaryCoefficient: data.salaryCoefficient || null,
        salaryDelta: data.salaryDelta || null,
        contributionAllowance: data.contributionAllowance || null,
        serviceAllowance: data.serviceAllowance || null,
        coachingAllowance: data.pembinaan || null,
        transportAllowance: data.transportAllowance || null,
        housingAllowance: data.housingAllowance || null,
        telecommunicationAllowance: data.telkomAllowance || null,
        positionAllowance: data.positionAllowance || null,
        mobilePhoneAllowance: data.pulsaAllowance || null,
        overtimeAllowance: data.overtimeAllowance || null,
        naturaAllowance: data.naturaAllowance || null,
        otherAllowance: data.otherAllowance || null,
        bankName: data.bankName,
        bankNumber: data.bankNumber,
        bankAccountName: data.bankAccountName,
        notes: data.notes || "",
        bpjsKesehatan: data.potBpjsKes || null,
        bpjsTK: data.potBpjsTk || null,
        pTKPCategory: data.ptkpCategory || "TK/0",
        categoryTER:
          data.kategoriTER ||
          getCategoryTERFromPTKP(data.ptkpCategory || "TK/0"),
        //pph21: data.potPph21 || null,
        grossSalary: data.grossSalary || null,
        nettSalary: data.netSalary || null,
        file: null,
        photoProfile: data.photoProfile || "",
        previewUrl: previewUrl,
      });

      setOpenEditEmployeeDialog(true);
      setIsEditing(false);
    } catch (error) {
      console.error("Failed to fetch employee data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal memuat data karyawan",
        text:
          error instanceof Error
            ? error.message
            : "Terjadi kesalahan yang tidak diketahui",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case "Resign":
        return "statusRed";
      case "Probation":
        return "statusGray";
      case "Contract":
        return "statusGray";
      case "Active":
        return "statusGreen";
      default:
        return "";
    }
  };

  const getPaymentClass = (status: string) => {
    switch (status) {
      case "Unpaid":
        return "statusRed";
      case "No Payroll":
        return "statusGray";
      case "Partial Paid":
        return "statusGray";
      case "Paid":
        return "statusGreen";
      default:
        return "";
    }
  };

  const handleChangeEdit = (event) => {
    setEmployeeDataEdit(event.target.value);
  };

  const handleInputChangeEdit = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | { target: { name: string; value: any } }
  ) => {
    const { name, value } = event.target;

    // Special handling for salary coefficient (decimal number field)
    if (name === "salaryCoefficient") {
      // Allow empty string or valid decimal number format
      if (value === "" || /^\d*\.?\d*$/.test(value)) {
        setEmployeeDataEdit((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
      return;
    }

    // Handle marital status change separately
    if (name === "maritalStatus") {
      setEmployeeDataEdit((prevState) => ({
        ...prevState,
        [name]: value,
        ...(value !== "Married" ? { totalAnak: 0 } : {}),
      }));
      return;
    }

    // Default handling for all other fields
    setEmployeeDataEdit((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEmployeeDataEdit({ ...employeeDataEdit, file });
  };

  const handleCloseEdit = () => {
    setOpenEditEmployeeDialog(false);
    setIsEditing(false);
    setSelectedEmployeeId(null);
    setShowSearch(false);
    setModifiedPayrolls(new Set()); // Reset modified flags
  };

  // Handler functions:
  const handleDirectorateChangeEdit = (event: any) => {
    const directorate = event.target.value;
    const divisions = positionData[directorate] || {};

    setEmployeeDataEdit({
      ...employeeDataEdit,
      directorate,
      division: "",
      jobTitle: "",
    });
  };

  const handleDivisionChangeEdit = (event: any) => {
    setEmployeeDataEdit({
      ...employeeDataEdit,
      division: event.target.value,
      jobTitle: "",
    });
  };

  const handleJobTitleChangeEdit = (event: any) => {
    setEmployeeDataEdit({
      ...employeeDataEdit,
      jobTitle: event.target.value,
    });
  };

  // 1. Pastikan divisionsEdit selalu berupa array
  const divisionsEdit = employeeDataEdit.directorate
    ? Array.isArray(positionData[employeeDataEdit.directorate])
      ? positionData[employeeDataEdit.directorate]
      : Object.keys(positionData[employeeDataEdit.directorate] || {})
    : [];

  // 2. Handle case ketika jobTitlesEdit bukan array
  const jobTitlesEdit =
    employeeDataEdit.directorate && employeeDataEdit.division
      ? Array.isArray(
          positionData[employeeDataEdit.directorate][employeeDataEdit.division]
        )
        ? positionData[employeeDataEdit.directorate][employeeDataEdit.division]
        : []
      : [];

  const handleFileChangeEdit = (event) => {
    setEmployeeDataEdit((prevData) => ({
      ...prevData,
      file: event.target.files[0],
    }));
  };

  const handleFetchEmployee = async (id: number) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Unauthorized: Token tidak ditemukan");

      const data = await getEmployeeById(id);

      let previewUrl: string | null = null;
      if (data.photoProfile && typeof data.photoProfile === "string") {
        previewUrl = await fetchEmployeePhotoBlob(data.photoProfile);
      }

      setEmployeeDataEdit({
        ...data,
        file: null,
        previewUrl: previewUrl,
      });
      await console.log(data);
    } catch (error) {
      console.error("Gagal memuat data karyawan:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRowClick = async (
    event: React.MouseEvent,
    id: number,
    employee
  ) => {
    if ((event.target as HTMLElement).closest("input[type='checkbox']")) {
      return;
    }
    handleOpenEditDialog(id);
  };

  const handleGetTarifTER = async () => {
    try {
      setLoadingTarifTER(true);

      // Validasi data
      if (!employeeDataEdit.grossSalary || employeeDataEdit.grossSalary <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Data Belum Lengkap",
          text: "Gross Salary harus diisi dan lebih dari 0",
        });
        return;
      }

      if (!employeeDataEdit.categoryTER) {
        Swal.fire({
          icon: "warning",
          title: "Data Belum Lengkap",
          text: "Category TER harus diisi",
        });
        return;
      }

      // Ambil nilai gross salary
      let grossSalaryValue = employeeDataEdit.grossSalary;
      let grossPayrollValue = payrollData.grossPayroll;

      const nik = employeeDataEdit.nik;
      const name = employeeDataEdit.name;
      const salary = Number(employeeDataEdit.salary) || 0;
      const bpjsTk = Number(employeeDataEdit.bpjsTK) || 0;
      const bpjsKes = Number(employeeDataEdit.bpjsKesehatan) || 0;
      const overtime = Number(payrollData.overtime) || 0;
      const sppd = Number(payrollData.sppd) || 0;
      const bonus = Number(payrollData.bonus) || 0;
      const thr = Number(payrollData.thr) || 0;
      const kompensasi = Number(payrollData.kompensasi) || 0;
      const others = Number(payrollData.others) || 0;

      const allowances =
        (Number(employeeDataEdit.contributionAllowance) || 0) +
        (Number(employeeDataEdit.serviceAllowance) || 0) +
        (Number(employeeDataEdit.coachingAllowance) || 0) +
        (Number(employeeDataEdit.transportAllowance) || 0) +
        (Number(employeeDataEdit.housingAllowance) || 0) +
        (Number(employeeDataEdit.positionAllowance) || 0) +
        (Number(employeeDataEdit.telecommunicationAllowance) || 0) +
        (Number(employeeDataEdit.mobilePhoneAllowance) || 0) +
        (Number(employeeDataEdit.naturaAllowance) || 0) +
        (Number(employeeDataEdit.otherAllowance) || 0);

      // Jika grossSalary berupa string yang diformat, konversi ke number
      if (typeof grossSalaryValue === "string") {
        grossSalaryValue = grossSalaryValue.replace(/[^\d,.]/g, "");
        grossSalaryValue = grossSalaryValue.replace(",", ".");
        grossSalaryValue = parseFloat(grossSalaryValue);
      }

      console.log("Mengambil tarif TER dengan parameter:", {
        nilai: grossPayrollValue,
        jenisTer: employeeDataEdit.categoryTER,
      });

      // Panggil API
      const tarifData = await getTarifTER(
        grossPayrollValue,
        employeeDataEdit.categoryTER
      );

      console.log("Response API Tarif TER:", tarifData);

      // Handle response API
      if (tarifData && tarifData.tarifTer) {
        // Konversi tarifTer dari string ke number
        const tarifValue = parseFloat(tarifData.tarifTer);

        // Ambil nilai Gross Payroll (gunakan nilai yang sudah ada atau hitung ulang)
        const grossPayrollValue = payrollData.grossPayroll || 0;

        // Hitung PPH 21: Gross Payroll * Tarif TER
        const pph21Value = grossPayrollValue * tarifValue;

        // Hitung Take Home Pay: Gross Payroll - PPH 21
        let takeHomePayValue;

        if (payrollData.paymentType === "Monthly Salary") {
          // Untuk Monthly Salary: Gross Salary - PPH 21
          takeHomePayValue =
            grossSalaryValue + overtime + sppd - pph21Value - bpjsTk - bpjsKes;
          console.log("Perhitungan Monthly Salary:", {
            grossSalary: grossSalaryValue,
            overtime: overtime,
            sppd: sppd,
            pph21: pph21Value,
            bpjstk: bpjsTk,
            bpjsKes: bpjsKes,
            takeHomePay: takeHomePayValue,
          });
        } else {
          // Untuk payment type lainnya: Gross Salary - Allowances - PPH 21
          takeHomePayValue =
            grossSalaryValue +
            overtime +
            sppd +
            bonus +
            thr +
            kompensasi +
            others -
            pph21Value -
            bpjsTk -
            bpjsKes;
          console.log("Perhitungan Non-Monthly Salary:", {
            grossSalary: grossSalaryValue,
            allowances: allowances,
            pph21: pph21Value,
            takeHomePay: takeHomePayValue,
          });
        }

        console.log("Perhitungan:", {
          grossPayroll: grossPayrollValue,
          tarifTER: tarifValue,
          pph21: pph21Value,
          takeHomePay: takeHomePayValue,
        });

        // Update payroll data dengan semua nilai yang dihitung
        setPayrollData((prev) => ({
          ...prev,
          // Isi field Tarif TER
          tarifTER: tarifValue,
          // Isi field PPH 21 (hasil kalkulasi)
          payrollPph21: parseFloat(pph21Value.toFixed(2)),
          // Isi field Take Home Pay (hasil kalkulasi)
          takeHomePay: parseFloat(takeHomePayValue.toFixed(2)),
          // Jika perlu menyimpan tarif persentase juga:
          //bpjsTkContributionCoeff: tarifValue * 100, // Konversi ke persentase (0.0150 -> 1.5)
        }));

        Swal.fire({
          icon: "success",
          title: "Berhasil!",
          html: `
        <div style="text-align: left;">
          <p><strong>Tarif TER nik: ${nik} , nama : ${name}</strong></p>
          <p>berhasil diambil dan kalkulasi selesai:</p>
          <p>Gross Payroll: ${formatCurrency(grossPayrollValue)}</p>
          <p>Tarif TER: ${tarifValue}</p>
          <p>PPH 21: ${formatCurrency(pph21Value)}</p>
          <p>Take Home Pay: ${formatCurrency(takeHomePayValue)}</p>
          <p>Range: ${formatCurrency(
            parseFloat(tarifData.batasBawah)
          )} - ${formatCurrency(parseFloat(tarifData.batasAtas))}</p>
        </div>
      `,
        });
      } else {
        throw new Error("Struktur response API tidak sesuai");
      }
    } catch (error) {
      console.error("Error mengambil tarif TER:", error);

      let errorMessage = "Gagal mengambil data tarif TER";

      if (error.response) {
        if (error.response.status === 404) {
          errorMessage = `Data tarif TER tidak ditemukan untuk kategori ${
            employeeDataEdit.categoryTER
          } dan nilai ${formatCurrency(employeeDataEdit.grossSalary)}`;
        } else if (error.response.status === 400) {
          errorMessage = "Parameter tidak valid";
        } else if (error.response.data?.message) {
          errorMessage = error.response.data.message;
        }
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: errorMessage,
      });
    } finally {
      setLoadingTarifTER(false);
    }
  };

  const calculateInstallments = (
    payrollData: any,
    salary: number,
    grossSalary: number,
    overtime: number,
    sppd: number = 0, // Tambahkan parameter sppd dengan default value 0
    bonus: number,
    thr: number,
    kompensasi: number,
    others: number
  ) => {
    // Convert semua ke number
    const salaryNum = Number(salary) || 0;
    const grossSalaryNum = Number(grossSalary) || 0;
    const overtimeNum = Number(overtime) || 0;
    const sppdNum = Number(sppd) || 0; // Konversi sppd ke number
    const bonusNum = Number(bonus) || 0;
    const thrNum = Number(thr) || 0;
    const kompensasiNum = Number(kompensasi) || 0;
    const otherNum = Number(others) || 0;
    const bpjsKesCompanyNum = Number(payrollData.bpjsKesCompany) || 0;
    const serviceAllowanceNum = Number(employeeDataEdit.serviceAllowance);

    // Jika payment type BUKAN Monthly Salary, hanya ambil dari salary saja (tanpa JKK & JKM)
    // if (payrollData.paymentType !== "Monthly Salary") {
    //   const thrInstallment = (1 / 12) * salaryNum;
    //   const pensionDplkInstallment = (1 / 12) * salaryNum;
    //   const bpjsKesCompany = (4 / 100) * (salaryNum + serviceAllowanceNum);

    //   // Hitung BPJS TK berdasarkan coefficient (default 1% jika tidak ada)
    //   const bpjsTkCoeff = 1;
    //   const bpjsTkContribution = (bpjsTkCoeff / 100) * salaryNum;

    //   // Untuk non-Monthly Salary, gross payroll = salary + overtime + sppd (TANPA JKK & JKM)
    //   const grossPayroll = salaryNum + overtimeNum + sppdNum;

    //   return {
    //     thrInstallment: thrInstallment,
    //     pensionDplkInstallment: pensionDplkInstallment,
    //     bpjsTkCoeff: bpjsTkCoeff,
    //     bpjsTkContribution: bpjsTkContribution,
    //     bpjsKesCompany: bpjsKesCompany,
    //     jkk: 0, // Set ke 0
    //     jkm: 0, // Set ke 0
    //     grossPayroll: grossPayroll,
    //   };
    // }

    // Jika payment type Monthly Salary, gunakan grossSalary (perhitungan lengkap)
    const base = salaryNum + serviceAllowanceNum;
    const thrInstallment = (1 / 12) * base;
    const pensionDplkInstallment = (1 / 12) * base;
    const bpjsKesCompany = (4 / 100) * base;

    // Hitung BPJS TK berdasarkan coefficient (default 1% jika tidak ada)
    const bpjsTkCoeff = 1;
    const bpjsTkContribution = (bpjsTkCoeff / 100) * base;

    // Hitung JKK (2.4% dari salary)
    const jkk = (0.24 / 100) * base;

    // Hitung JKM (0.3% dari salary)
    const jkm = (0.3 / 100) * base;

    // Untuk Monthly Salary, gross payroll = grossSalary + overtime + jkk + jkm + bpjsKesCompany + sppd
    const grossPayroll =
      grossSalaryNum +
      jkk +
      jkm +
      bpjsKesCompany +
      bonusNum +
      thrNum +
      kompensasiNum +
      otherNum +
      overtimeNum +
      sppdNum;

    return {
      thrInstallment: thrInstallment,
      pensionDplkInstallment: pensionDplkInstallment,
      bpjsTkCoeff: bpjsTkCoeff,
      bpjsTkContribution: bpjsTkContribution,
      bpjsKesCompany: bpjsKesCompany,
      jkk: jkk,
      jkm: jkm,
      grossPayroll: grossPayroll,
    };
  };

  // Handler khusus untuk bonus allowance
  const handleBonusChange = (value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      bonus: value,
    };

    // Jika payment type monthly, hitung ulang gross payroll
    if (payrollData.paymentType) {
      const salary = employeeDataEdit.salary || 0;
      const grossSalary = employeeDataEdit.grossSalary || 0;
      const overtime = payrollData.overtime || 0;
      const sppd = payrollData.sppd || 0;
      const thr = payrollData.thr || 0;
      const kompensasi = payrollData.kompensasi || 0;
      const others = payrollData.others || 0;

      const calculated = calculateInstallments(
        newPayrollData,
        salary,
        grossSalary,
        value || 0,
        sppd, // Tambahkan sppd
        overtime,
        thr,
        kompensasi,
        others
      );

      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    } else {
      setPayrollData(newPayrollData);
    }
  };

  // Handler khusus untuk thr allowance
  const handleThrChange = (value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      thr: value,
    };

    // Jika payment type monthly, hitung ulang gross payroll
    if (payrollData.paymentType) {
      const salary = employeeDataEdit.salary || 0;
      const grossSalary = employeeDataEdit.grossSalary || 0;
      const sppd = payrollData.sppd || 0;
      const overtime = payrollData.overtime || 0;
      const bonus = payrollData.bonus || 0;
      const kompensasi = payrollData.kompensasi || 0;
      const others = payrollData.others || 0;

      const calculated = calculateInstallments(
        newPayrollData,
        salary,
        grossSalary,
        value || 0,
        sppd, // Tambahkan sppd
        overtime,
        bonus,
        kompensasi,
        others
      );

      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    } else {
      setPayrollData(newPayrollData);
    }
  };

  // Handler khusus untuk kompensasi allowance
  const handleKompensasiChange = (value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      kompensasi: value,
    };

    // Jika payment type monthly, hitung ulang gross payroll
    if (payrollData.paymentType) {
      const salary = employeeDataEdit.salary || 0;
      const grossSalary = employeeDataEdit.grossSalary || 0;
      const sppd = payrollData.sppd || 0;
      const overtime = payrollData.overtime || 0;
      const bonus = payrollData.bonus || 0;
      const thr = payrollData.thr || 0;
      const others = payrollData.others || 0;

      const calculated = calculateInstallments(
        newPayrollData,
        salary,
        grossSalary,
        value || 0,
        sppd, // Tambahkan sppd
        overtime,
        bonus,
        thr,
        others
      );

      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    } else {
      setPayrollData(newPayrollData);
    }
  };

  // Handler khusus untuk other allowance
  const handleOtherChange = (value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      others: value,
    };

    // Jika payment type monthly, hitung ulang gross payroll
    if (payrollData.paymentType) {
      const salary = employeeDataEdit.salary || 0;
      const grossSalary = employeeDataEdit.grossSalary || 0;
      const sppd = payrollData.sppd || 0;
      const overtime = payrollData.overtime || 0;
      const bonus = payrollData.bonus || 0;
      const thr = payrollData.thr || 0;
      const kompensasi = payrollData.kompensasi || 0;

      const calculated = calculateInstallments(
        newPayrollData,
        salary,
        grossSalary,
        value || 0,
        sppd, // Tambahkan sppd
        overtime,
        bonus,
        thr,
        kompensasi
      );

      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    } else {
      setPayrollData(newPayrollData);
    }
  };

  // Handler khusus untuk overtime allowance
  const handleOvertimeChange = (value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      overtime: value,
    };

    // Jika payment type monthly, hitung ulang gross payroll
    if (payrollData.paymentType) {
      const salary = employeeDataEdit.salary || 0;
      const grossSalary = employeeDataEdit.grossSalary || 0;
      const sppd = payrollData.sppd || 0;
      const others = payrollData.others || 0;
      const bonus = payrollData.bonus || 0;
      const thr = payrollData.thr || 0;
      const kompensasi = payrollData.kompensasi || 0;

      const calculated = calculateInstallments(
        newPayrollData,
        salary,
        grossSalary,
        value || 0,
        sppd, // Tambahkan sppd
        others,
        bonus,
        thr,
        kompensasi
      );

      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    } else {
      setPayrollData(newPayrollData);
    }
  };

  // Handler khusus untuk sppd allowance
  const handleSppdChange = (value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      sppd: value,
    };

    // Jika payment type monthly, hitung ulang gross payroll
    if (payrollData.paymentType) {
      const salary = employeeDataEdit.salary || 0;
      const grossSalary = employeeDataEdit.grossSalary || 0;
      const overtime = payrollData.overtime || 0;
      const others = payrollData.others || 0;
      const bonus = payrollData.bonus || 0;
      const thr = payrollData.thr || 0;
      const kompensasi = payrollData.kompensasi || 0;

      const calculated = calculateInstallments(
        newPayrollData,
        salary,
        grossSalary,
        overtime,
        value || 0, // Tambahkan sppd ke parameter
        others,
        bonus,
        thr,
        kompensasi
      );

      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    } else {
      setPayrollData(newPayrollData);
    }
  };

  const calculateBonus = (payrollData: any, nettSalary: number) => {
    // Hitung Cicilan THR

    const takeHomePay = nettSalary * payrollData.bonusCoeff;

    return {
      takeHomePay: parseFloat(takeHomePay.toFixed(2)),
    };
  };

  // GANTI kedua fungsi dengan satu fungsi terpadu
  // Handler khusus untuk perubahan coefficient
  const handleCoefficientChange = (field: string, value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      [field]: value,
    };

    let calculated = {};

    // Jika field adalah bpjsTkContributionCoeff
    if (field === "bpjsTkContributionCoeff") {
      const salary = Number(employeeDataEdit.salary) || 0;
      const grossSalary = Number(employeeDataEdit.grossSalary) || 0;
      const overtime = Number(payrollData.overtime) || 0;
      const sppd = Number(payrollData.sppd) || 0;
      const bonus = Number(payrollData.bonus) || 0;
      const thr = Number(payrollData.thr) || 0;
      const kompensasi = Number(payrollData.kompensasi) || 0;
      const others = Number(payrollData.others) || 0;
      const bpjstk = Number(employeeDataEdit.bpjsTK) || 0;
      const bpjsKes = Number(employeeDataEdit.bpjsKesehatan) || 0;

      const allowances =
        (Number(employeeDataEdit.contributionAllowance) || 0) +
        (Number(employeeDataEdit.serviceAllowance) || 0) +
        (Number(employeeDataEdit.coachingAllowance) || 0) +
        (Number(employeeDataEdit.transportAllowance) || 0) +
        (Number(employeeDataEdit.housingAllowance) || 0) +
        (Number(employeeDataEdit.positionAllowance) || 0) +
        (Number(employeeDataEdit.telecommunicationAllowance) || 0) +
        (Number(employeeDataEdit.mobilePhoneAllowance) || 0) +
        (Number(employeeDataEdit.naturaAllowance) || 0) +
        (Number(employeeDataEdit.otherAllowance) || 0);

      // Hitung base take home pay berdasarkan payment type
      let baseGrossPayroll;
      if (payrollData.paymentType === "Monthly Salary") {
        baseGrossPayroll = grossSalary + overtime + sppd - bpjstk - bpjsKes;
        // grossSalary +
        // overtime +
        // (payrollData.jkk || 0) +
        // (payrollData.jkm || 0);
      } else {
        baseGrossPayroll =
          grossSalary +
          bonus +
          thr +
          kompensasi +
          others +
          overtime +
          sppd -
          bpjstk -
          bpjsKes;
        // salary + overtime + (payrollData.jkk || 0) + (payrollData.jkm || 0);
      }

      const pph21 = payrollData.payrollPph21 || 0;
      const baseTHP = baseGrossPayroll - pph21;

      if (value !== null) {
        const takeHomePay = baseTHP * value;
        calculated = {
          takeHomePay: parseFloat(takeHomePay.toFixed(2)),
        };
      }
    }
    // Untuk field lainnya
    else {
      const salary = employeeDataEdit.salary || 0;
      const grossSalary = employeeDataEdit.grossSalary || 0;
      const calculatedInstallments = calculateInstallments(
        newPayrollData,
        salary,
        grossSalary,
        payrollData.overtime || 0
      );
      calculated = calculatedInstallments;
    }

    setPayrollData({
      ...newPayrollData,
      ...calculated,
    });
  };

  // HAPUS fungsi handleBonusCoefChange yang lama

  const handleBonusCoefChange = (field: string, value: number | null) => {
    if (payrollData.id) {
      handlePayrollChange(payrollData.id);
    }

    const newPayrollData = {
      ...payrollData,
      [field]: value,
    };

    // Menggunakan nettSalary dari employeeDataEdit
    const nettSalary = employeeDataEdit.nettSalary || 0;

    // Jika paymentType adalah Bonus, hitung takeHomePay berdasarkan bonusCoeff
    if (value !== null) {
      const takeHomePay = nettSalary * value;
      const calculated = {
        takeHomePay: parseFloat(takeHomePay.toFixed(2)),
      };

      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    } else {
      // Untuk paymentType lainnya, gunakan perhitungan normal
      const calculated = calculateInstallments(
        newPayrollData,
        employeeDataEdit.salary || 0,
        employeeDataEdit.grossSalary || 0,
        payrollData.overtime || 0
      );
      setPayrollData({
        ...newPayrollData,
        ...calculated,
      });
    }
  };

  const [errorsEdit, setErrorsEdit] = useState({
    name: false,
    dateOfBirth: false,
    cityOfBirth: false,
    religion: false,
    address: false,
    phone: false,
    email: false,
    gender: false,
    maritalStatus: false,
    employeeID: false,
    position: false,
    directorate: false,
    division: false,
    jobTitle: false,
    employeeStatus: false,
    employeeType: false,
    office: false,
    company: false,
    dateOfJoining: false,
    expiredDate: false,
    taxIdNumber: false,
    salary: false,
    salaryCoefficient: false,
    salaryDelta: false,
    contributionAllowance: false,
    serviceAllowance: false,
    otherAllowance: false,
    bankName: false,
    bankNumber: false,
    bankAccountName: false,
  });

  const validateFormEdit = () => {
    const newErrors: any = {};

    const mandatoryFields = [
      "name",
      "dateOfBirth",
      "cityOfBirth",
      "religion",
      "address",
      "phone",
      "email",
      "gender",
      "maritalStatus",
      "nik",
      "position",
      "directorate",
      "division",
      "jobTitle",
      "status",
      "employeeType",
      //"office",
      "dateOfJoining",
      "taxIdNumber",
      "salary",
      "bankName",
      "bankNumber",
      "bankAccountName",
      //"notes",
    ];

    // Jika menikah → wajib isi total anak
    if (employeeDataEdit.maritalStatus === "Married") {
      mandatoryFields.push("totalAnak");
    }

    // Jika tipe inorganic → wajib isi vendor company
    if (employeeDataEdit.employeeType === "Inorganic") {
      mandatoryFields.push("company");
    }

    // Validasi setiap field
    mandatoryFields.forEach((field) => {
      if (
        !employeeDataEdit[field] ||
        employeeDataEdit[field].toString().trim() === ""
      ) {
        newErrors[field] = true;
      }
    });

    setErrorsEdit(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setPayrollData({
      id: "",
      periodMonth: null,
      periodYear: null,
      paymentStatus: "",
      paymentEvidence: null,
      paymentDate: null,
      paymentType: "",
      thrInstallmentCoeff: null,
      thrInstallment: null,
      pensionDplkInstallmentCoeff: null,
      pensionDplkInstallment: null,
      jkk: null,
      jkm: null,
      payrollPph21: null,
      grossPayroll: null,
      bpjsKesCompany: null,
      bonusCoeff: null,
      takeHomePay: null,
      overtime: null,
      sppd: null,
      bonus: null,
      thr: null,
      kompensasi: null,
      others: null,
      bpjsTkContributionCoeff: null,
      bpjsTkContribution: null,
      tarifTER: null,
    });
    setPreviewUrl("");
    setErrors({
      periodMonth: false,
      periodYear: false,
      paymentStatus: false,
      paymentType: false,
      paymentDate: false,
      thrInstallmentCoeff: false,
      thrInstallment: false,
      pensionDplkInstallmentCoeff: false,
      pensionDplkInstallment: false,
      jkk: false,
      jkm: false,
      payrollPph21: false,
      grossPayroll: false,
      bpjsKesCompany: false,
      bonusCoeff: false,
      takeHomePay: false,
      overtime: false,
      sppd: false,
      bonus: false,
      thr: false,
      kompensasi: false,
      others: false,
      bpjsTkContributionCoeff: false,
      bpjsTkContribution: false,
      tarifTER: false,
    });
  };

  // Filter data untuk employee yang dipilih
  const filteredPayrolls = payrollDetails.filter(
    (p) => p.employeeId === selectedEmployeeId
  );

  const handleDownloadFile = async (filename: string) => {
    try {
      const fileData = await fetchPayrollFile(filename);
      if (fileData.url) {
        window.open(fileData.url, "_blank");
      }
    } catch (error) {
      console.error("Gagal download file:", error);
      Swal.fire("Error", "Gagal memuat file", "error");
    }
  };

  const isBulkFormValid = () => {
    const {
      office,
      employeeStatus,
      paymentType,
      periodMonth,
      periodYear,
      paymentStatus,
      paymentDate,
    } = bulkFormData;

    // Validasi required fields sesuai schema
    if (
      !office ||
      !employeeStatus ||
      !paymentType ||
      !periodMonth ||
      !periodYear ||
      !paymentStatus ||
      !paymentDate
    ) {
      return false;
    }

    // Validasi conditional fields
    if (
      paymentType === "Monthly Salary" &&
      !bulkFormData.bpjsTkContributionCoeff
    ) {
      return false;
    }

    // BonusCoeff optional untuk "Bonus/THR/Lain-lain"

    return true;
  };

  const handleBulkExcelSubmit = async () => {
    if (!selectedFile) {
      Swal.fire({
        icon: "warning",
        title: "Pilih File Terlebih Dahulu",
        text: "Silakan pilih file Excel untuk diupload",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    // Konfirmasi sebelum upload
    Swal.fire({
      title: "Konfirmasi Upload",
      html: `
        <div class="text-left">
          <p>Anda akan mengupload file:</p>
          <p><strong>${selectedFile.name}</strong></p>
          <p>Pastikan data payroll dalam file sudah benar.</p>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Upload Sekarang",
      cancelButtonText: "Periksa Ulang",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsUploading(true);

          // Tampilkan loading
          Swal.fire({
            title: "Sedang Mengupload...",
            html: `
              <div class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-3">Mohon tunggu, file sedang diproses...</p>
                <p class="text-sm text-muted">File: ${selectedFile.name}</p>
              </div>
            `,
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
              Swal.showLoading();
            },
          });

          // Proses upload
          const result = await bulkUpsertPayrollExcel(selectedFile);

          // Close loading
          Swal.close();

          // Tampilkan hasil sukses
          Swal.fire({
            title: "✅ Upload Berhasil!",
            html: `
              <div class="text-left">
                <p><strong>File berhasil diproses:</strong></p>
                <p>${selectedFile.name}</p>
                <hr>
                <p><strong>Hasil:</strong></p>
                <ul>
                  ${
                    result.data && result.data.processed
                      ? `<li>Data diproses: ${result.data.processed}</li>`
                      : ""
                  }
                  ${
                    result.data && result.data.created
                      ? `<li>Data baru: ${result.data.created}</li>`
                      : ""
                  }
                  ${
                    result.data && result.data.updated
                      ? `<li>Data diperbarui: ${result.data.updated}</li>`
                      : ""
                  }
                  ${
                    result.data && result.data.skipped
                      ? `<li>Data dilewati: ${result.data.skipped}</li>`
                      : ""
                  }
                </ul>
                <p class="text-success">${
                  result.message || "Data payroll berhasil diimport"
                }</p>
              </div>
            `,
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Selesai",
            width: 600,
          }).then(() => {
            // Reset form setelah sukses
            setSelectedFile(null);
            const fileInput = document.getElementById(
              "excel-file"
            ) as HTMLInputElement;
            if (fileInput) fileInput.value = "";
          });
        } catch (error: any) {
          Swal.close();

          // Tampilkan error detail
          let errorMessage = "Terjadi kesalahan saat mengupload file";
          let errorDetails = "";

          if (error.message) {
            errorMessage = error.message;
          }

          if (error.response?.data?.details) {
            errorDetails = `<div class="mt-3 text-danger">
              <strong>Detail Error:</strong><br>
              <pre style="text-align: left; font-size: 12px; max-height: 200px; overflow-y: auto;">
${JSON.stringify(error.response.data.details, null, 2)}
              </pre>
            </div>`;
          }

          Swal.fire({
            title: "❌ Upload Gagal",
            html: `
              <div class="text-left">
                <p><strong>Error:</strong> ${errorMessage}</p>
                ${errorDetails}
                <p class="mt-3 text-warning">
                  <strong>Tips:</strong> Periksa kembali format file Excel Anda.
                </p>
              </div>
            `,
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: "Tutup",
            width: 700,
          });
        } finally {
          setIsUploading(false);
        }
      }
    });
  };

  const handleBulkSubmit = async () => {
    try {
      // setIsLoading(true);
      console.log("🚀 Starting bulk submit...");

      // Validasi final - PASTIKAN INI DIPANGGIL
      if (!isBulkFormValid()) {
        console.log("❌ Form validation failed");
        await Swal.fire({
          icon: "error",
          title: "Data belum lengkap",
          text: "Harap lengkapi semua field yang required",
        });
        setIsLoading(false); // ← PASTIKAN INI DIPANGGIL
        return;
      }

      // Dapatkan employees berdasarkan filter untuk konfirmasi
      const filteredEmployees = rows.filter(
        (row) =>
          (!filterParams.office || row.office === filterParams.office) &&
          (!filterParams.status || row.status === filterParams.status)
      );

      if (filteredEmployees.length === 0) {
        console.log("❌ No employees found");
        await Swal.fire({
          icon: "warning",
          title: "Tidak ada karyawan",
          text: "Tidak ada karyawan yang sesuai dengan filter yang dipilih",
        });
        setIsLoading(false); // ← PASTIKAN INI DIPANGGIL
        return;
      }

      // Konfirmasi - PASTIKAN AWAIT DAN CONFIRM ISCONFIRMED
      const confirmResult = await Swal.fire({
        title: "Konfirmasi Bulk Insert",
        html: `Anda akan membuat payroll untuk karyawan :<br>
             <b>Office:</b> ${
               offices.find((o) => o.officeId === bulkFormData.office)
                 ?.officeName || bulkFormData.office
             }<br>
             <b>Status:</b> ${bulkFormData.employeeStatus}<br>
             <b>Payment Type:</b> ${bulkFormData.paymentType}<br>
             <b>Period:</b> ${bulkFormData.periodMonth}/${
          bulkFormData.periodYear
        }`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Insert",
        cancelButtonText: "Batal",
        allowOutsideClick: false, // ← PREVENT CLICK OUTSIDE
      });

      // PASTIKAN PENGE CEKAN INI BENAR
      if (!confirmResult.isConfirmed) {
        console.log("❌ User cancelled operation");
        setIsLoading(false);
        return;
      }

      // Siapkan payload
      const payload = {
        office: bulkFormData.office,
        employeeStatus: bulkFormData.employeeStatus,
        paymentType: bulkFormData.paymentType,
        periodMonth: bulkFormData.periodMonth,
        periodYear: bulkFormData.periodYear,
        paymentStatus: bulkFormData.paymentStatus,
        paymentDate: bulkFormData.paymentDate?.toISOString(),
        bpjsTkContributionCoeff: bulkFormData.bpjsTkContributionCoeff,
        bonusCoeff: bulkFormData.bonusCoeff,
      };

      console.log("📤 Sending payload:", payload);

      // 🚨 PERBAIKAN CRITICAL: Tambahkan timeout dan error handling
      try {
        const response = await Promise.race([
          bulkCreatePayroll(payload),
          new Promise((_, reject) =>
            setTimeout(
              () => reject(new Error("Request timeout setelah 30 detik")),
              30000
            )
          ),
        ]);

        console.log("✅ API Response:", response);

        // 🚨 PERBAIKAN: Handle response yang mungkin tidak memiliki success property
        if (response) {
          // Cek berbagai kemungkinan format success response
          const successCount =
            response.createdCount || response.success || response.count;
          const successMessage =
            response.message || "Payroll processed successfully";

          if (successCount !== undefined || response.message) {
            await // Response dianggap success jika ada count atau message
            Swal.fire({
              icon: "success",
              title: "Success",
              text: `${successMessage}${
                successCount !== undefined ? ` (${successCount} data)` : ""
              }`,
            });

            // Reset form
            setBulkFormData({
              office: filterParams.office || "",
              employeeStatus: filterParams.status || "",
              paymentType: "",
              periodMonth: null,
              periodYear: null,
              paymentStatus: "",
              paymentDate: null,
              bpjsTkContributionCoeff: null,
              bonusCoeff: null,
            });

            setBulkDialogOpen(false);
            await reloadEmployeeInorganic();
          } else {
            // Format tidak expected tapi mungkin masih success
            console.warn(
              "Unexpected but possibly successful response:",
              response
            );
            Swal.fire({
              icon: "success",
              title: "Processed",
              text: "Payroll berhasil diproses",
            });
            reloadEmployeeInorganic();
            setBulkDialogOpen(false);
          }
        } else {
          // Handle response format yang tidak expected
          throw new Error(
            "Format response tidak sesuai: " + JSON.stringify(response)
          );
        }
      } catch (apiError) {
        console.error("❌ API Error:", apiError);
        throw apiError; // Re-throw untuk ditangkap di catch block luar
      }
    } catch (error) {
      console.error("💥 Bulk insert error:", error);

      let errorMessage = "Terjadi kesalahan saat melakukan bulk insert";

      if (error.message.includes("timeout")) {
        errorMessage = "Request timeout - Server terlalu lama merespon";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      } else if (error instanceof TypeError) {
        errorMessage = "Network error - Periksa koneksi internet";
      }

      // 🚨 PASTIKAN SWAL.FIRE MENUNGGU SAMPAI SELESAI
      await Swal.fire({
        icon: "error",
        title: "Gagal",
        text: errorMessage,
        confirmButtonText: "OK",
      });
    } finally {
      // 🚨 PASTIKAN INI SELALU DIEKSEKUSI
      console.log("🏁 Bulk submit finished - setting loading to false");
      setIsLoading(false);
    }
  };

  const [modifiedPayrolls, setModifiedPayrolls] = useState<Set<string>>(
    new Set()
  );

  // Tambahkan handler untuk menandai data yang diubah
  const handlePayrollChange = (payrollId: string) => {
    setModifiedPayrolls((prev) => new Set(prev).add(payrollId));
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);

      if (payrollDetails.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Tidak ada data",
          text: "Tambahkan setidaknya satu detail payroll sebelum menyimpan",
        });
        return;
      }

      const savedPayrolls: string[] = [];
      const newPayrolls: PayrollEntry[] = [];
      const updatedPayrolls: PayrollEntry[] = [];

      // Pisahkan data baru dan data yang di-update
      payrollDetails.forEach((detail) => {
        if (detail.id) {
          // HANYA masukkan ke updatedPayrolls jika memang di-modified
          if (modifiedPayrolls.has(detail.id)) {
            updatedPayrolls.push(detail);
          }
        } else {
          newPayrolls.push(detail);
        }
      });

      console.log("Data to save:", {
        new: newPayrolls.length,
        updated: updatedPayrolls.length,
        total: payrollDetails.length,
      });

      // Handle data baru (CREATE)
      for (const detail of newPayrolls) {
        const payload = {
          employeeId: detail.employeeId,
          periodMonth: detail.periodMonth,
          periodYear: detail.periodYear,
          paymentStatus: detail.paymentStatus,
          paymentDate: detail.paymentDate,
          paymentType: detail.paymentType,
          thrInstallmentCoeff: detail.thrInstallmentCoeff,
          thrInstallment: detail.thrInstallment,
          pensionDplkInstallmentCoeff: detail.pensionDplkInstallmentCoeff,
          pensionDplkInstallment: detail.pensionDplkInstallment,
          bpjsKesCompany: detail.bpjsKesCompany,
          bonusCoeff: detail.bonusCoeff,
          takeHomePay: detail.takeHomePay,
          bpjsTkContributionCoeff: detail.bpjsTkContributionCoeff,
          bpjsTkContribution: detail.bpjsTkContribution,
          bpjsKesEmployee: employeeDataEdit.bpjsKesehatan,
          bpjsTkEmployee: employeeDataEdit.bpjsTK,
          jkk: detail.jkk,
          jkm: detail.jkm,
          payrollPph21: detail.payrollPph21,
          tarifTER: detail.tarifTER,
          grossPayroll: detail.grossPayroll,
          overtime: detail.overtime,
          sppd: detail.sppd,
          bonus: detail.bonus,
          thr: detail.thr,
          kompensasi: detail.kompensasi,
          others: detail.others,
        };

        const response = await createPayroll(payload);
        const payrollId = response.id;

        if (detail.paymentEvidence instanceof File) {
          await uploadItemFile(payrollId, detail.paymentEvidence);
        }

        savedPayrolls.push(payrollId);
      }

      // Handle data yang di-update (UPDATE) - HANYA yang di-modified
      for (const detail of updatedPayrolls) {
        const payload = {
          employeeId: detail.employeeId,
          periodMonth: detail.periodMonth,
          periodYear: detail.periodYear,
          paymentStatus: detail.paymentStatus,
          paymentDate: detail.paymentDate,
          paymentType: detail.paymentType,
          thrInstallmentCoeff: detail.thrInstallmentCoeff,
          thrInstallment: detail.thrInstallment,
          pensionDplkInstallmentCoeff: detail.pensionDplkInstallmentCoeff,
          pensionDplkInstallment: detail.pensionDplkInstallment,
          bpjsKesCompany: detail.bpjsKesCompany,
          bonusCoeff: detail.bonusCoeff,
          jkk: detail.jkk,
          jkm: detail.jkm,
          payrollPph21: detail.payrollPph21,
          tarifTER: detail.tarifTER,
          grossPayroll: detail.grossPayroll,
          takeHomePay: detail.takeHomePay,
          bpjsTkContributionCoeff: detail.bpjsTkContributionCoeff,
          bpjsTkContribution: detail.bpjsTkContribution,
          bpjsKesEmployee: employeeDataEdit.bpjsKesehatan,
          bpjsTkEmployee: employeeDataEdit.bpjsTK,
          overtime: detail.overtime,
          sppd: detail.sppd,
          bonus: detail.bonus,
          thr: detail.thr,
          kompensasi: detail.kompensasi,
          others: detail.others,
        };

        await updatePayroll(detail.id, payload);

        if (detail.paymentEvidence instanceof File) {
          await uploadItemFile(detail.id, detail.paymentEvidence);
        }

        savedPayrolls.push(detail.id);
      }

      // 🔥 RELOAD DATA PAYROLL UNTUK EMPLOYEE YANG SEDANG DIPILIH
      if (selectedEmployeeId) {
        await loadPayrollData(selectedEmployeeId);

        const filtered = payrollDetails.filter(
          (p) => p.employeeId === selectedEmployeeId
        );
        setRowsPayrollDetail(filtered);
        setTotalItemsPayrollDetail(filtered.length);
        setTotalPagesPayrollDetail(
          Math.ceil(filtered.length / rowsPerPagePayrollDetail)
        );
      }

      // Reset modified flags setelah save berhasil
      setModifiedPayrolls(new Set());
      resetForm();
      reloadEmployeeInorganic();

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: `Berhasil menyimpan ${savedPayrolls.length} data payroll (${newPayrolls.length} baru, ${updatedPayrolls.length} update)`,
      });

      setOpenEditEmployeeDialog(false);
    } catch (error) {
      console.error("Error saving payroll:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal menyimpan",
        text:
          error.response?.data?.message ||
          "Terjadi kesalahan saat menyimpan data payroll",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveRoleEdit = (index: number) => {
    const updatedPosition = [...employeeDataEdit.position];
    updatedPosition.splice(index, 1);
    setEmployeeDataEdit({
      ...employeeDataEdit,
      position: updatedPosition,
    });
  };

  const handleAddRoleEdit = () => {
    if (!newRole) return;

    // Cek apakah role sudah ada
    if (employeeDataEdit.position?.includes(newRole)) {
      Swal.fire({
        icon: "warning",
        title: "Role sudah diassign",
        text: "Role ini sudah diassign kepada karyawan",
      });
      return;
    }

    // Tambahkan role baru
    setEmployeeDataEdit((prev) => ({
      ...prev,
      position: [...(prev.position || []), newRole],
    }));

    // Reset dropdown
    setNewRole("");
  };

  useEffect(() => {
    const isFilterActive =
      filterParams.office &&
      filterPayrollParams.periodYear &&
      filterPayrollParams.periodMonth;
    setPdfDisabled(!isFilterActive);
  }, [
    filterParams.office,
    filterPayrollParams.periodYear,
    filterPayrollParams.periodMonth,
  ]);

  // Memanggil data saat komponen pertama kali dimuat
  useEffect(() => {
    // Load data inorganic saat pertama kali
    reloadEmployeeInorganic();
  }, [currentPage, rowsPerPage, filterParams, filterPayrollParams, sortConfig]);

  useEffect(() => {
    // Set office filter options
    setOfficeFilterOptions(
      offices.map((office) => ({
        officeId: office.officeId,
        officeName: office.officeName,
      }))
    );

    // Set vendor filter options
    setVendorFilterOptions(
      vendors.map((vendor) => ({
        vendorId: vendor.vendorId,
        vendorName: vendor.vendorName,
      }))
    );
  }, [offices, vendors]);

  useEffect(() => {
    const loadRoles = async () => {
      setLoadingRoles(true);
      try {
        const rolesData = await fetchRoles();
        setRoles(rolesData);
      } catch (error) {
        console.error("Gagal memuat roles:", error);
      } finally {
        setLoadingRoles(false);
      }
    };

    loadRoles();

    const loadVendors = async () => {
      setLoadingVendors(true);
      try {
        const vendorsData = await fetchVendors();
        setVendors(vendorsData);
      } catch (error) {
        console.error("Gagal memuat vendors:", error);
      } finally {
        setLoadingVendors(false);
      }
    };

    loadVendors();

    const loadOffices = async () => {
      setLoadingOffices(true);
      try {
        const officesData = await fetchOffices();
        setOffices(officesData);
      } catch (error) {
        console.error("Gagal memuat office:", error);
      } finally {
        setLoadingOffices(false);
      }
    };

    loadOffices();
  }, []);

  // Tambahkan useEffect untuk sync filter params dengan bulk form data
  useEffect(() => {
    if (bulkDialogOpen) {
      setBulkFormData((prev) => ({
        ...prev,
        office: filterParams.office || "",
        employeeStatus: filterParams.status || "",
      }));
    }
  }, [bulkDialogOpen, filterParams.office, filterParams.status]);

  useEffect(() => {
    // Auto-fetch tarif TER ketika gross salary dan category TER tersedia
    if (
      employeeDataEdit.grossSalary &&
      employeeDataEdit.grossSalary > 0 &&
      employeeDataEdit.categoryTER &&
      !payrollData.bpjsTkContribution
    ) {
      // handleGetTarifTER(); // Uncomment jika ingin auto-fetch
    }
  }, [employeeDataEdit.grossSalary, employeeDataEdit.categoryTER]);

  // ======================================== end of function ========================================================
  // ============================================ start ui ===========================================================

  return isLoading ? (
    <LoadingOverlay />
  ) : (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
      >
        <Typography variant="h6" fontWeight="bold">
          Payroll List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }}
            size="small"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          {/* <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )} */}
          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>
        {/* Office Filter */}
        <Autocomplete
          options={offices}
          getOptionLabel={(option) => option.officeName}
          value={
            offices.find((o) => o.officeId === filterParams.office) || null
          }
          onChange={(_, newValue) => {
            setFilterParams((prev) => ({
              ...prev,
              office: newValue?.officeId || "",
            }));
          }}
          size="small"
          sx={{ width: 200 }}
          renderInput={(params) => (
            <TextField {...params} label="Office" variant="outlined" />
          )}
        />

        {/* Employee Status Filter */}
        <TextField
          select
          label="Employee Status"
          value={filterParams.status || ""}
          onChange={(e) => {
            setFilterParams((prev) => ({
              ...prev,
              status: e.target.value,
            }));
          }}
          size="small"
          sx={{ width: 200 }}
        >
          <MenuItem value="">All Status</MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Probation">Probation</MenuItem>
          <MenuItem value="Contract">Contract</MenuItem>
          <MenuItem value="Resign">Resign</MenuItem>
        </TextField>

        {/* Payroll Month Filter */}
        <TextField
          select
          label="Payroll Month"
          value={filterPayrollParams.periodMonth || ""}
          onChange={(e) => {
            setFilterPayrollParams((prev) => ({
              ...prev,
              periodMonth: e.target.value,
            }));
          }}
          size="small"
          sx={{ width: 150 }}
        >
          <MenuItem value="">All Months</MenuItem>
          {Array.from({ length: 12 }, (_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {new Date(0, i).toLocaleString("default", { month: "long" })}
            </MenuItem>
          ))}
        </TextField>

        {/* Payroll Year Filter */}
        <TextField
          select
          label="Payroll Year"
          value={filterPayrollParams.periodYear || ""}
          onChange={(e) => {
            setFilterPayrollParams((prev) => ({
              ...prev,
              periodYear: e.target.value,
            }));
          }}
          size="small"
          sx={{ width: 150 }}
        >
          <MenuItem value="">All Years</MenuItem>
          {Array.from({ length: 10 }, (_, i) => (
            <MenuItem key={i} value={new Date().getFullYear() - i}>
              {new Date().getFullYear() - i}
            </MenuItem>
          ))}
        </TextField>

        {/* Payroll Status Filter */}
        <TextField
          select
          label="Payroll Status"
          value={filterPayrollParams.paymentStatus || ""}
          onChange={(e) => {
            setFilterPayrollParams((prev) => ({
              ...prev,
              paymentStatus: e.target.value,
            }));
          }}
          size="small"
          sx={{ width: 150 }}
        >
          <MenuItem value="">All Status</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Paid">Paid</MenuItem>
          <MenuItem value="Invalid">Invalid</MenuItem>
        </TextField>

        {/* Clear Filters Button */}
        <Button
          variant="outlined"
          onClick={() => {
            setFilterParams({});
            setFilterPayrollParams({});
            setSearchQuery("");
          }}
          size="small"
        >
          Clear
        </Button>

        {/* Right Controls */}
        <Box className="rightControls">
          {/* <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => handleDeleteEmployee(true)} // Pindahkan fungsi delete di sini
            disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          >
            Delete
          </Button> */}

          {/* Filter Button */}
          {/* <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button> */}
          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExportToPDF}
            disabled={pdfDisabled}
          >
            Export PDF
          </Button>

          <Button
            startIcon={<Download />}
            variant="contained"
            className="exportButton"
            onClick={handleExport}
          >
            Export Excel
          </Button>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setBulkDialogOpen(true)}
            disabled={!filterParams.office || !filterParams.status}
            sx={{ ml: 2 }}
          >
            Insert Bulk Payroll
          </Button>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setBulkDialogExcelOpen(true)}
            sx={{ ml: 2 }}
          >
            Insert Bulk Payroll + Others Excel
          </Button>
        </Box>
      </Box>

      {/* Delete Button & Subtitle */}
      {/* <Box className="deleteContainer">
        <IconButton
          onClick={() => setOpenDeleteDialog(true)}
          disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          className="deleteButton"
        >
          <TrashOutline color={"#333"} height="20px" width="20px" />
        </IconButton>
      </Box> */}

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of Payroll
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={
                    selectedRows.length > 0 && selectedRows.length < rows.length
                  }
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(
                      selectedRows.length === rows.length
                        ? []
                        : rows.map((row) => row.id)
                    )
                  }
                />
              </TableCell>
              <TableCell className="tableCell" width="50px">
                <strong>No</strong>
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("name")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Name</strong>
                {sortConfig.orderBy === "name" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("nik")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Number</strong>
                {sortConfig.orderBy === "nik" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("jobTitle")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Job Title</strong>
                {sortConfig.orderBy === "jobTitle" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("division")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Division</strong>
                {sortConfig.orderBy === "division" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("office")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Location</strong>
                {sortConfig.orderBy === "office" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("status")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Status</strong>
                {sortConfig.orderBy === "status" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("employeeType")}
                style={{ cursor: "pointer" }}
              >
                <strong>Employee Type</strong>
                {sortConfig.orderBy === "employeeType" &&
                  (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell
                className="tableCell"
                onClick={() => handleSort("employeeType")}
                style={{ cursor: "pointer" }}
              >
                <strong>Payment Status</strong>
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={10} align="center" style={{ color: "red" }}>
                  {error}
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={(event) => {
                        event.stopPropagation();
                        handleSelectRow(row.id);
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  <TableCell>
                    <strong>{row.name}</strong>
                  </TableCell>
                  <TableCell>{row.nik}</TableCell>
                  <TableCell>{row.jobTitle}</TableCell>
                  <TableCell>{row.division}</TableCell>
                  <TableCell>
                    {offices.find((office) => office.officeId === row.office)
                      ?.officeName || "-"}
                  </TableCell>
                  <TableCell>
                    <Box
                      className={`statusBadge ${getStatusClass(row.status)}`}
                    >
                      {row.status}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      className={`statusBadge ${
                        row.employeeType === "Organic"
                          ? "typeGreen"
                          : "typeGray"
                      }`}
                    >
                      {row.employeeType}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      className={`statusBadge ${getPaymentClass(
                        row.overallPaymentStatus
                      )}`}
                    >
                      {row.overallPaymentStatus}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        handleOpenEditDialog(row.id); // Ganti dari setOpenEditEmployeeDialog
                      }}
                    >
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog
        open={openFilterDialog}
        onClose={() => setOpenFilterDialog(false)}
      >
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters
              .map((f, i) => i !== index && f.field)
              .filter(Boolean);
            const availableOptions = availableFilters.filter(
              (opt) => !usedFields.includes(opt.value)
            );

            // Daftar nilai untuk status dan employee type
            const statusOptions = ["Active", "Probation", "Contract", "Resign"];
            const employeeTypeOptions = ["Organic", "Inorganic"];

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
              >
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) =>
                    handleFilterChange(index, "field", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {(() => {
                  if (filter.field === "office") {
                    return (
                      <Autocomplete
                        options={officeFilterOptions}
                        getOptionLabel={(option) => option.officeName}
                        value={officeFilterOptions.find(
                          (opt) => opt.officeName === filter.value
                        )}
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.officeName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Office"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 160 }}
                          />
                        )}
                        disableClearable
                        noOptionsText="No offices found"
                      />
                    );
                  } else if (filter.field === "company") {
                    return (
                      <Autocomplete
                        options={vendorFilterOptions}
                        getOptionLabel={(option) => option.vendorName}
                        value={vendorFilterOptions.find(
                          (opt) => opt.vendorName === filter.value
                        )}
                        onChange={(event, newValue) => {
                          const newFilters = [...filters];
                          newFilters[index].value = newValue?.vendorName || "";
                          setFilters(newFilters);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Vendor Company"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1, minWidth: 160 }}
                          />
                        )}
                        disableClearable
                        noOptionsText="No vendors found"
                      />
                    );
                  } else if (filter.field === "status") {
                    return (
                      // Kode existing untuk status filter
                      <TextField
                        select
                        label="Status"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1, minWidth: 160 }}
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option.replace("_", " ")}
                          </MenuItem>
                        ))}
                      </TextField>
                    );
                  } else if (filter.field === "employeeType") {
                    return (
                      // Kode existing untuk employeeType filter
                      <TextField
                        select
                        label="Employee Type"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1, minWidth: 160 }}
                      >
                        {employeeTypeOptions.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option.replace("_", " ")}
                          </MenuItem>
                        ))}
                      </TextField>
                    );
                  } else {
                    return (
                      // Default text field untuk filter lainnya
                      <TextField
                        label="Value"
                        variant="outlined"
                        size="small"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(index, "value", e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    );
                  }
                })()}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* =======================================Bulk Insert Dialog================================= */}
      <Dialog
        open={bulkDialogOpen}
        onClose={() => !isLoading && setBulkDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {isLoading ? "Processing..." : "Bulk Insert Payroll"}
          {!isLoading && (
            <IconButton
              aria-label="close"
              onClick={() => setBulkDialogOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>

        <DialogContent>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 200,
              }}
            >
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>
                Sedang memproses bulk insert...
              </Typography>
            </Box>
          ) : (
            <>
              {/* Display Filter Criteria (Read-only) */}
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                }}
              >
                <Typography variant="subtitle2" gutterBottom>
                  Filter Criteria (Auto-filled from your selection):
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Office"
                      value={
                        offices.find((o) => o.officeId === filterParams.office)
                          ?.officeName ||
                        filterParams.office ||
                        ""
                      }
                      InputProps={{ readOnly: true }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Employee Status"
                      value={filterParams.status || ""}
                      InputProps={{ readOnly: true }}
                      size="small"
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      <strong>Affected Employees:</strong> {
                        rows.filter(row =>
                          (!filterParams.office || row.office === filterParams.office) &&
                          (!filterParams.status || row.status === filterParams.status)
                        ).length
                      } employees
                    </Typography>
                  </Grid> */}
                </Grid>
              </Box>

              {/* Payment Details Form */}
              <Grid container spacing={2}>
                {/* Payment Type dengan enum yang sesuai */}
                <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Payment Type *"
                    value={bulkFormData.paymentType}
                    onChange={(e) =>
                      setBulkFormData({
                        ...bulkFormData,
                        paymentType: e.target.value,
                        // Reset coefficients when type changes
                        bpjsTkContributionCoeff: null,
                        bonusCoeff: null,
                      })
                    }
                    required
                    error={!bulkFormData.paymentType}
                  >
                    <MenuItem value="">Select Type</MenuItem>
                    <MenuItem value="Monthly Salary">Monthly Salary</MenuItem>
                    {/* <MenuItem value="Monthly Salary + Bonus/THR/Kompensasi/Lain-lain">
                      Monthly Salary + Bonus/THR/Kompensasi/Lain-lain
                    </MenuItem> */}
                  </TextField>
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Payroll Month *"
                    value={bulkFormData.periodMonth || ""}
                    onChange={(e) =>
                      setBulkFormData({
                        ...bulkFormData,
                        periodMonth: parseInt(e.target.value) || null,
                      })
                    }
                    inputProps={{ min: 1, max: 12 }}
                    required
                    error={!bulkFormData.periodMonth}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    type="number"
                    fullWidth
                    label="Payroll Year *"
                    value={bulkFormData.periodYear || ""}
                    onChange={(e) =>
                      setBulkFormData({
                        ...bulkFormData,
                        periodYear: parseInt(e.target.value) || null,
                      })
                    }
                    inputProps={{ min: 2000, max: 2100 }}
                    required
                    error={!bulkFormData.periodYear}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Payment Status *"
                    value={bulkFormData.paymentStatus}
                    onChange={(e) =>
                      setBulkFormData({
                        ...bulkFormData,
                        paymentStatus: e.target.value,
                      })
                    }
                    required
                    error={!bulkFormData.paymentStatus}
                  >
                    <MenuItem value="">Select Status</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Paid">Paid</MenuItem>
                    <MenuItem value="Invalid">Invalid</MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Payment Date *"
                      value={
                        bulkFormData.paymentDate
                          ? dayjs(bulkFormData.paymentDate)
                          : null
                      }
                      onChange={(newValue) =>
                        setBulkFormData({
                          ...bulkFormData,
                          paymentDate: newValue ? newValue.toDate() : null,
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          required: true,
                          error: !bulkFormData.paymentDate,
                        },
                      }}
                      format="YYYY-MM-DD HH:mm:ss"
                    />
                  </LocalizationProvider>
                </Grid>

                {/* Conditional Fields */}
                {bulkFormData.paymentType === "Monthly Salary" && (
                  <Grid item xs={6}>
                    <TextField
                      type="number"
                      fullWidth
                      label="Coefficient (%) *"
                      value={bulkFormData.bpjsTkContributionCoeff || ""}
                      onChange={(e) =>
                        setBulkFormData({
                          ...bulkFormData,
                          bpjsTkContributionCoeff:
                            parseFloat(e.target.value) || null,
                        })
                      }
                      inputProps={{ step: "0.01", min: "0", max: "100" }}
                      //helperText="Contoh: 3 untuk 3%"
                      // required
                      // error={!bulkFormData.bpjsTkContributionCoeff}
                    />
                  </Grid>
                )}

                {bulkFormData.paymentType ===
                  "Bonus/THR/Kompensasi/Lain-lain" && (
                  <Grid item xs={6}>
                    <TextField
                      type="number"
                      fullWidth
                      label="Coefficient (%) *"
                      value={bulkFormData.bonusCoeff || ""}
                      onChange={(e) =>
                        setBulkFormData({
                          ...bulkFormData,
                          bonusCoeff: parseFloat(e.target.value) || null,
                        })
                      }
                      inputProps={{ step: "0.01", min: "0" }}
                      //helperText="Contoh: 1.5 untuk 1.5x gaji"
                    />
                  </Grid>
                )}
              </Grid>

              <Typography variant="caption" sx={{ mt: 2, display: "block" }}>
                * Required fields
              </Typography>
            </>
          )}
        </DialogContent>

        <DialogActions>
          {!isLoading && (
            <>
              <Button onClick={() => setBulkDialogOpen(false)}>Cancel</Button>
              <Button
                onClick={handleBulkSubmit}
                variant="contained"
                disabled={!isBulkFormValid()}
              >
                Submit Bulk Insert
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* =======================================Bulk Excel Insert Dialog================================= */}
      <Dialog
        open={bulkDialogExcelOpen}
        onClose={() => !isLoading && setBulkDialogExcelOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {isLoading ? "Processing..." : "Bulk Excel Insert Payroll"}
          {!isLoading && (
            <IconButton
              aria-label="close"
              onClick={() => setBulkDialogExcelOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>

        <DialogContent>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 200,
              }}
            >
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>
                Sedang memproses bulk insert...
              </Typography>
            </Box>
          ) : (
            <>
              <Grid item xs={12}>
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    gap: 3,
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #aaa",
                    padding: 4,
                    mt: 2,
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    cursor: "pointer",
                    position: "relative",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                      handleFileUpload(e.dataTransfer.files[0]);
                    }
                  }}
                >
                  {previewUrl ? (
                    <>
                      <GridOn fontSize="large" color="primary" />
                      <Typography variant="body2" mt={1}>
                        {fileName || "Uploaded PDF"}
                      </Typography>
                      <IconButton
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          backgroundColor: "rgba(255,255,255,0.7)",
                          "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.9)",
                          },
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setPreviewUrl("");
                          setFileName("");
                          setPayrollData((prev) => ({
                            ...prev,
                            paymentEvidence: null,
                            paymentEvidenceType: "",
                          }));
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <GridOn fontSize="large" color="action" />
                      <Typography variant="body2" color="textSecondary" mt={1}>
                        Drag & drop or click to upload payment evidence
                      </Typography>
                    </>
                  )}
                  <input
                    hidden
                    accept=".xls,.xlsx"
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        handleFileUpload(e.target.files[0]);
                      }
                    }}
                  />
                  <Typography variant="caption" mt={1}>
                    Max size: 5MB (XLS/XLSX)
                  </Typography>
                </Box>
              </Grid>

              <Typography variant="caption" sx={{ mt: 2, display: "block" }}>
                * Required fields
              </Typography>
            </>
          )}
        </DialogContent>

        <DialogActions>
          {!isLoading && (
            <>
              <Button onClick={() => setBulkDialogExcelOpen(false)}>
                Cancel
              </Button>
              <Button onClick={handleBulkExcelSubmit} variant="contained">
                Submit Excel Bulk Insert
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* ================================ POPUP Edit payroll ======================================*/}
      <Dialog
        open={openEditEmployeeDialog}
        onClose={() => setOpenEditEmployeeDialog(false)}
        fullWidth
        maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Detail Employee
          </Typography>
          <IconButton onClick={handleCloseEdit} color="error">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            {/* Profile Picture & Employee ID */}
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle1" fontWeight="bold">
                PERSONAL DETAILS
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px dashed #aaa",
                  padding: 4,
                  borderRadius: "12px",
                  backgroundColor: "#fafafa",
                  textAlign: "center",
                  cursor: "pointer",
                  position: "relative",
                }}
                disabled
                // onDragOver={(e) => e.preventDefault()}
                // onDrop={(e) => {
                //   if (isEditing) {
                //     e.preventDefault();
                //     const file = e.dataTransfer.files[0];
                //     handleEditFileUpload(file);
                //   }
                // }}
                // onClick={() => {
                //   if (isEditing) {
                //     editFileInputRef.current?.click();
                //   }
                // }}
              >
                {employeeDataEdit.file ? (
                  <img
                    src={URL.createObjectURL(employeeDataEdit.file)}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      objectFit: "contain",
                      maxHeight: 180,
                    }}
                  />
                ) : !!employeeDataEdit.previewUrl ? (
                  <img
                    src={employeeDataEdit.previewUrl}
                    alt="Existing"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "8px",
                      objectFit: "contain",
                      maxHeight: 180,
                    }}
                  />
                ) : (
                  <>
                    <PhotoCamera fontSize="large" />
                    <Typography variant="body2" color="textSecondary" mt={1}>
                      Drag & drop or click to upload image
                    </Typography>
                  </>
                )}

                <input
                  hidden
                  accept="image/png, image/jpeg, image/jpg"
                  type="file"
                  ref={editFileInputRef}
                  onChange={(e) => handleEditFileUpload(e.target.files[0])}
                />
                <Typography variant="caption" mt={1}>
                  Max size: 5MB (.png, .jpg, .jpeg)
                </Typography>
              </Box>

              <TextField
                fullWidth
                label="Employee Name"
                value={employeeDataEdit.name}
                sx={{ mb: 1, mt: 1 }}
                name="name"
                disabled
                error={isEditing && !employeeDataEdit.name}
                helperText={
                  isEditing && !employeeDataEdit.name ? "Mandatory Field" : ""
                }
                onChange={handleInputChangeEdit}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Date Of Birth"
                  format="YYYY-MM-DD"
                  disabled
                  value={
                    employeeDataEdit.dateOfBirth
                      ? dayjs(employeeDataEdit.dateOfBirth)
                      : null
                  }
                  onChange={(newValue) =>
                    handleInputChangeEdit({
                      target: {
                        name: "dateOfBirth",
                        value: newValue
                          ? dayjs(newValue).format("YYYY-MM-DD")
                          : "",
                      },
                    })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      sx: { mb: 1 },
                      name: "dateOfBirth",
                      error: isEditing && !employeeDataEdit.dateOfBirth,
                      helperText:
                        isEditing && !employeeDataEdit.dateOfBirth
                          ? "Mandatory Field"
                          : "",
                    },
                  }}
                />
              </LocalizationProvider>
              <TextField
                fullWidth
                label="Place Of Birth"
                value={employeeDataEdit.cityOfBirth}
                sx={{ mb: 1 }}
                name="cityOfBirth"
                disabled
                error={isEditing && !employeeDataEdit.cityOfBirth}
                helperText={
                  isEditing && !employeeDataEdit.cityOfBirth
                    ? "Mandatory Field"
                    : ""
                }
                onChange={handleInputChangeEdit}
              />
              <TextField
                select
                fullWidth
                label="Religion"
                value={employeeDataEdit.religion}
                name="religion"
                error={!employeeDataEdit.religion}
                disabled
                helperText={
                  isEditing && !employeeDataEdit.religion
                    ? "Mandatory Field"
                    : ""
                }
                onChange={handleInputChangeEdit}
                sx={{ mb: 1 }}
              >
                <MenuItem value="" disabled>
                  Select item
                </MenuItem>
                <MenuItem value="Islam">Islam</MenuItem>
                <MenuItem value="Christian">Kristen Protestan</MenuItem>
                <MenuItem value="Catholic">Kristen Katolik</MenuItem>
                <MenuItem value="Hindu">Hindu</MenuItem>
                <MenuItem value="Buddha">Buddha</MenuItem>
                <MenuItem value="Konghucu">Konghucu</MenuItem>
              </TextField>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Address"
                value={employeeDataEdit.address}
                sx={{ mb: 1 }}
                name="address"
                disabled
                error={isEditing && !employeeDataEdit.address}
                helperText={
                  isEditing && !employeeDataEdit.address
                    ? "Mandatory Field"
                    : ""
                }
                onChange={handleInputChangeEdit}
              />
              <TextField
                fullWidth
                type="number"
                label="Phone Number"
                value={employeeDataEdit.phone}
                sx={{ mb: 1 }}
                name="phone"
                disabled
                error={isEditing && !employeeDataEdit.phone}
                helperText={
                  isEditing && !employeeDataEdit.phone ? "Mandatory Field" : ""
                }
                onChange={handleInputChangeEdit}
              />

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Gender"
                    value={employeeDataEdit.gender}
                    name="gender"
                    disabled
                    error={isEditing && !employeeDataEdit.gender}
                    helperText={
                      isEditing && !employeeDataEdit.gender
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Male">Laki-Laki</MenuItem>
                    <MenuItem value="Female">Perempuan</MenuItem>
                  </TextField>
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Marital Status"
                    value={employeeDataEdit.maritalStatus}
                    name="maritalStatus"
                    disabled
                    error={isEditing && !employeeDataEdit.maritalStatus}
                    helperText={
                      isEditing && !employeeDataEdit.maritalStatus
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  >
                    <MenuItem value="" disabled>
                      Select item
                    </MenuItem>
                    <MenuItem value="Single">Belum Menikah</MenuItem>
                    <MenuItem value="Married">Menikah</MenuItem>
                    <MenuItem value="Widow">Widow</MenuItem>
                    <MenuItem value="Widower">Widower</MenuItem>
                  </TextField>
                </Grid>
                {(employeeDataEdit.maritalStatus === "Married" ||
                  employeeDataEdit.maritalStatus === "Widow" ||
                  employeeDataEdit.maritalStatus === "Widower") && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Total Jumlah Anak"
                      sx={{ mb: 1 }}
                      value={employeeDataEdit.totalAnak}
                      name="totalAnak"
                      error={isEditing && !employeeDataEdit.totalAnak}
                      disabled
                      helperText={
                        isEditing && !employeeDataEdit.totalAnak
                          ? "Mandatory Field"
                          : ""
                      }
                      onChange={handleInputChangeEdit}
                    />
                  </Grid>
                )} */}
              </Grid>
            </Grid>

            {/* Personal Details & Employment Profile */}
            <Grid item xs={12} sm={8}>
              <Grid container spacing={2}>
                {/* Personal Details */}
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    EMPLOYMENT PROFILE
                  </Typography>
                  <TextField
                    fullWidth
                    label="Nomor Induk Karyawan"
                    value={employeeDataEdit.nik}
                    name="nik"
                    onChange={handleInputChangeEdit}
                    disabled
                    error={isEditing && !employeeDataEdit.nik}
                    helperText={
                      isEditing && !employeeDataEdit.nik
                        ? "Mandatory Field"
                        : ""
                    }
                    sx={{ mt: 1 }}
                  />
                  {/* Role Multi-Select */}
                  <Grid item xs={24} md={12} mb={2}>
                    <Box
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        p: 2,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mt: 2,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          color="text.secondary"
                        >
                          Assigned Permissions
                        </Typography>
                        {isEditing && (
                          <Typography variant="caption" color="text.secondary">
                            {employeeDataEdit.position?.length || 0} permissions
                          </Typography>
                        )}
                      </Box>

                      <Box
                        sx={{
                          flexGrow: 1,
                          maxHeight: 300,
                          overflowY: "auto",
                          p: 1,
                          backgroundColor: "background.default",
                          borderRadius: 1,
                          border: "1px solid",
                          borderColor: "divider",
                          minHeight: 100,
                        }}
                      >
                        {(employeeDataEdit.position || []).length > 0 ? (
                          <Grid container spacing={1}>
                            {employeeDataEdit.position.map((roleId, index) => {
                              const role = roles.find((r) => r.id === roleId);
                              return (
                                <Grid item xs={12} sm={6} key={index}>
                                  <Chip
                                    label={role?.name || roleId}
                                    // onDelete={
                                    //   isEditing
                                    //     ? () => handleRemoveRoleEdit(index)
                                    //     : undefined
                                    // }
                                    sx={{
                                      width: "100%",
                                      justifyContent: "space-between",
                                      borderRadius: 1,
                                      backgroundColor: isEditing
                                        ? "action.selected"
                                        : "background.paper",
                                      "& .MuiChip-deleteIcon": {
                                        color: "error.main",
                                      },
                                      // Tambahkan ini:
                                      color: isEditing
                                        ? undefined
                                        : "text.secondary",
                                      "& .MuiChip-label": {
                                        color: isEditing
                                          ? undefined
                                          : "text.secondary",
                                      },
                                    }}
                                  />
                                </Grid>
                              );
                            })}
                          </Grid>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: 100,
                              color: "text.disabled",
                            }}
                          >
                            <Typography variant="body2">
                              No role assigned
                            </Typography>
                            {!isEditing && (
                              <Typography variant="caption">
                                Click EDIT to add role
                              </Typography>
                            )}
                          </Box>
                        )}
                      </Box>

                      {isEditing && (
                        <Box
                          sx={{ display: "flex", gap: 1, alignItems: "center" }}
                        >
                          <Select
                            fullWidth
                            displayEmpty
                            value={newRole}
                            onChange={(e) =>
                              setNewRole(e.target.value as string)
                            }
                            size="small"
                            sx={{
                              flexGrow: 1,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 1,
                              },
                            }}
                            disabled
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 300,
                                },
                              },
                              disableEnforceFocus: true,
                              onKeyDown: (e) => {
                                if (
                                  document.activeElement.id ===
                                  "role-search-input-edit"
                                ) {
                                  e.stopPropagation();
                                }
                              },
                            }}
                            onOpen={() => {
                              setTimeout(() => {
                                const searchInput = document.getElementById(
                                  "role-search-input-edit"
                                );
                                if (searchInput) {
                                  searchInput.focus();
                                }
                              }, 100);
                            }}
                          >
                            {/* Search Field */}
                            <Box
                              sx={{ p: 1 }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <TextField
                                id="role-search-input-edit"
                                fullWidth
                                variant="outlined"
                                placeholder="Search roles..."
                                value={roleSearchEdit}
                                onChange={(e) =>
                                  setRoleSearchEdit(e.target.value)
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.currentTarget.focus();
                                }}
                                onKeyDown={(e) => e.stopPropagation()}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Search fontSize="small" />
                                    </InputAdornment>
                                  ),
                                  endAdornment: roleSearchEdit && (
                                    <InputAdornment position="end">
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setRoleSearchEdit("");
                                        }}
                                      >
                                        <Clear fontSize="small" />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  size: "small",
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    paddingRight: 1,
                                  },
                                }}
                                autoFocus
                              />
                            </Box>

                            {/* Filtered Role List */}
                            {roles
                              .filter((role) => {
                                // Filter by search and exclude already assigned roles
                                const matchesSearch =
                                  role.name
                                    .toLowerCase()
                                    .includes(roleSearchEdit.toLowerCase()) ||
                                  role.id
                                    .toLowerCase()
                                    .includes(roleSearchEdit.toLowerCase());
                                const notAssigned =
                                  !employeeDataEdit.position?.includes(role.id);
                                return matchesSearch && notAssigned;
                              })
                              .map((role) => (
                                <MenuItem key={role.id} value={role.name}>
                                  {role.name}
                                </MenuItem>
                              ))}

                            {roles.filter((role) => {
                              const matchesSearch =
                                role.name
                                  .toLowerCase()
                                  .includes(roleSearchEdit.toLowerCase()) ||
                                role.id
                                  .toLowerCase()
                                  .includes(roleSearchEdit.toLowerCase());
                              const notAssigned =
                                !employeeDataEdit.position?.includes(role.id);
                              return matchesSearch && notAssigned;
                            }).length === 0 && (
                              <MenuItem disabled>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  No roles found
                                </Typography>
                              </MenuItem>
                            )}
                          </Select>
                          <Button
                            variant="contained"
                            onClick={handleAddRoleEdit}
                            disabled={!newRole}
                            sx={{
                              minWidth: 120,
                              height: 40,
                              borderRadius: 1,
                              textTransform: "none",
                            }}
                          >
                            Add
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                  <TextField
                    fullWidth
                    label="Email"
                    value={employeeDataEdit.email}
                    sx={{ mb: 1 }}
                    name="email"
                    disabled
                    error={isEditing && !employeeDataEdit.email}
                    helperText={
                      isEditing && !employeeDataEdit.email
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                  {/* Directorate Field */}
                  <TextField
                    select
                    fullWidth
                    label="Directorate"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataEdit.directorate}
                    name="directorate"
                    disabled
                    error={isEditing && !employeeDataEdit.directorate}
                    helperText={
                      isEditing && !employeeDataEdit.directorate
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleDirectorateChangeEdit}
                  >
                    <MenuItem value="" disabled>
                      Select Directorate
                    </MenuItem>
                    {Object.keys(positionData).map((directorate) => (
                      <MenuItem key={directorate} value={directorate}>
                        {directorate}
                      </MenuItem>
                    ))}
                  </TextField>

                  {/* Division Field */}
                  <TextField
                    select
                    fullWidth
                    label="Division"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataEdit.division}
                    name="division"
                    error={isEditing && !employeeDataEdit.division}
                    helperText={
                      isEditing && !employeeDataEdit.division
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleDivisionChangeEdit}
                    disabled
                  >
                    <MenuItem value="" disabled>
                      Select Division
                    </MenuItem>

                    {divisionsEdit.map((division) => (
                      <MenuItem key={division} value={division}>
                        {division}
                      </MenuItem>
                    ))}
                  </TextField>

                  {/* Job Title Field */}
                  <TextField
                    select
                    fullWidth
                    label="Job Title"
                    sx={{ textAlign: "left", mt: 1 }}
                    value={employeeDataEdit.jobTitle}
                    name="jobTitle"
                    error={isEditing && !employeeDataEdit.jobTitle}
                    helperText={
                      isEditing && !employeeDataEdit.jobTitle
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleJobTitleChangeEdit}
                    disabled
                  >
                    <MenuItem value="" disabled>
                      Select Job Title
                    </MenuItem>

                    {jobTitlesEdit.map((jobTitle) => (
                      <MenuItem key={jobTitle} value={jobTitle}>
                        {jobTitle}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Status"
                        sx={{ mt: 1 }}
                        disabled
                        value={employeeDataEdit.status}
                        name="status"
                        error={isEditing && !employeeDataEdit.status}
                        helperText={
                          isEditing && !employeeDataEdit.status
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleInputChangeEdit}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Probation">Probation</MenuItem>
                        <MenuItem value="Contract">Contract</MenuItem>
                        <MenuItem value="Resign">Resign</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Employee Type"
                        sx={{ mt: 1 }}
                        disabled
                        value={employeeDataEdit.employeeType}
                        name="employeeType"
                        error={isEditing && !employeeDataEdit.employeeType}
                        helperText={
                          isEditing && !employeeDataEdit.employeeType
                            ? "Mandatory Field"
                            : ""
                        }
                        onChange={handleInputChangeEdit}
                      >
                        <MenuItem value="" disabled>
                          Select item
                        </MenuItem>
                        <MenuItem value="Organic">Organic</MenuItem>
                        <MenuItem value="Inorganic">Inorganic</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                  <Autocomplete
                    options={offices}
                    getOptionLabel={(option) => option.officeName || ""}
                    value={
                      offices.find(
                        (o) => o.officeId === employeeDataEdit.office
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleInputChangeEdit({
                        target: {
                          name: "office",
                          value: newValue ? newValue.officeId : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Office"
                        placeholder="Select Office"
                        margin="normal"
                        fullWidth
                        sx={{ mt: 1 }}
                        error={isEditing && !employeeDataEdit.office}
                        helperText={
                          isEditing && !employeeDataEdit.office
                            ? "Mandatory Field"
                            : ""
                        }
                        disabled
                      />
                    )}
                    loading={loadingOffices}
                    loadingText="Loading offices..."
                    noOptionsText={
                      offices.length === 0
                        ? "No offices available"
                        : "No matching offices found"
                    }
                    disabled
                  />
                  {employeeDataEdit.employeeType === "Inorganic" && (
                    <Autocomplete
                      options={vendors}
                      getOptionLabel={(option) => option.vendorName || ""}
                      value={
                        vendors.find(
                          (v) => v.vendorId === employeeDataEdit.company
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        handleInputChangeEdit({
                          target: {
                            name: "company",
                            value: newValue ? newValue.vendorId : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Vendor Company"
                          placeholder="Select Vendor"
                          margin="normal"
                          fullWidth
                          sx={{ mt: 1 }}
                          error={isEditing && !employeeDataEdit.company}
                          helperText={
                            isEditing && !employeeDataEdit.company
                              ? "Mandatory Field"
                              : ""
                          }
                          disabled
                        />
                      )}
                      loading={loadingVendors}
                      loadingText="Loading vendors..."
                      noOptionsText={
                        vendors.length === 0
                          ? "No vendors available"
                          : "No matching vendors found"
                      }
                      disabled
                    />
                  )}
                </Grid>

                {/* Employment Profile */}
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Date Joining"
                      format="YYYY-MM-DD"
                      disabled
                      value={
                        employeeDataEdit.dateOfJoining
                          ? dayjs(employeeDataEdit.dateOfJoining)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeEdit({
                          target: {
                            name: "dateOfJoining",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mb: 1, mt: 4.5 },
                          name: "dateOfJoining",
                          error: isEditing && !employeeDataEdit.dateOfJoining,
                          helperText:
                            isEditing && !employeeDataEdit.dateOfJoining
                              ? "Mandatory Field"
                              : "",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="End of Contract"
                      format="YYYY-MM-DD"
                      disabled
                      value={
                        employeeDataEdit.expiredDate
                          ? dayjs(employeeDataEdit.expiredDate)
                          : null
                      }
                      onChange={(newValue) =>
                        handleInputChangeEdit({
                          target: {
                            name: "expiredDate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: { mb: 1 },
                          error: false,
                          name: "expiredDate",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Enter notes"
                    sx={{ textAlign: "left", mt: 1, mb: 2 }}
                    value={employeeDataEdit.notes}
                    name="notes"
                    disabled
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Divider - Garis Pemisah */}
            <Grid item xs={12} sm={8}>
              <Divider sx={{ my: 0, borderBottom: "2px solid #ddd" }} />
            </Grid>

            {/* Personal Salary Information */}
            <Grid item xs={12} sm={8}>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                sx={{ mt: -2, mb: 0.5 }}
              >
                PERSONAL SALARY INFORMATION
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="No NPWP"
                    value={employeeDataEdit.taxIdNumber}
                    name="taxIdNumber"
                    disabled
                    error={isEditing && !employeeDataEdit.taxIdNumber}
                    helperText={
                      isEditing && !employeeDataEdit.taxIdNumber
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={bankData}
                    value={employeeDataEdit.bankName || null}
                    onChange={(event, newValue) => {
                      handleInputChangeEdit({
                        target: {
                          name: "bankName",
                          value: newValue || "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bank Name"
                        placeholder="Select Bank"
                        fullWidth
                        error={isEditing && !employeeDataEdit.bankName}
                        helperText={
                          isEditing && !employeeDataEdit.bankName
                            ? "Mandatory Field"
                            : ""
                        }
                        disabled
                      />
                    )}
                    noOptionsText="No banks available"
                    disabled
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Salary"
                    value={formatCurrency(employeeDataEdit.salary) ?? ""}
                    disabled={!isEditing}
                    onChange={(e) => {
                      handleSalaryChangeEdit(
                        "salary",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      );
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Bank Account Number"
                    value={employeeDataEdit.bankNumber}
                    name="bankNumber"
                    disabled
                    error={isEditing && !employeeDataEdit.bankNumber}
                    helperText={
                      isEditing && !employeeDataEdit.bankNumber
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary Coefficient"
                    value={employeeDataEdit.salaryCoefficient ?? ""}
                    disabled={!isEditing}
                    name="salaryCoefficient"
                    onChange={(e) => {
                      handleSalaryChangeEdit(
                        "salaryCoefficient",
                        e.target.value,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      );
                    }}
                    inputProps={{
                      step: "0.01",
                      min: "1",
                    }}
                    helperText="minimal 1"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Bank Account Name"
                    value={employeeDataEdit.bankAccountName}
                    name="bankAccountName"
                    disabled
                    error={isEditing && !employeeDataEdit.bankAccountName}
                    helperText={
                      isEditing && !employeeDataEdit.bankAccountName
                        ? "Mandatory Field"
                        : ""
                    }
                    onChange={handleInputChangeEdit}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Salary Delta"
                    value={employeeDataEdit.salaryDelta ?? ""}
                    disabled={!isEditing}
                    name="salaryDelta"
                    onChange={(e) => {
                      handleSalaryChangeEdit(
                        "salaryDelta",
                        e.target.value,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Contribution Allowance"
                    value={
                      formatCurrency(employeeDataEdit.contributionAllowance) ??
                      ""
                    }
                    disabled={!isEditing}
                    name="contributionAllowance"
                    onChange={(e) => {
                      handleSalaryChangeEdit(
                        "contributionAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      );
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Service Allowance"
                    value={
                      formatCurrency(employeeDataEdit.serviceAllowance) ?? ""
                    }
                    disabled={!isEditing}
                    name="serviceAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "serviceAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Coaching Assitance"
                    value={formatCurrency(employeeDataEdit.coachingAllowance)}
                    disabled={!isEditing}
                    name="coachingAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "coachingAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Transport Assitance"
                    value={formatCurrency(employeeDataEdit.transportAllowance)}
                    disabled={!isEditing}
                    name="transportAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "transportAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Housing Assitance"
                    value={formatCurrency(employeeDataEdit.housingAllowance)}
                    disabled={!isEditing}
                    name="housingAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "housingAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Telecommunication Assitance"
                    value={formatCurrency(
                      employeeDataEdit.telecommunicationAllowance
                    )}
                    disabled={!isEditing}
                    name="telecommunicationAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "telecommunicationAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Position Assitance"
                    value={formatCurrency(employeeDataEdit.positionAllowance)}
                    disabled={!isEditing}
                    name="positionAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "positionAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Mobile Phone Assitance"
                    value={formatCurrency(
                      employeeDataEdit.mobilePhoneAllowance
                    )}
                    disabled={!isEditing}
                    name="mobilePhoneAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "mobilePhoneAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Overtime Assitance"
                    value={payrollData.overtimeAllowance || ""}
                    name="overtimeAllowance"
                    onChange={(e) => {
                      handleOvertimeChange(parseFloat(e.target.value) || null);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Natura Assitance"
                    value={formatCurrency(employeeDataEdit.naturaAllowance)}
                    disabled={!isEditing}
                    name="naturaAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "naturaAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Other Assitance"
                    value={
                      formatCurrency(employeeDataEdit.otherAllowance) ?? ""
                    }
                    disabled={!isEditing}
                    name="otherAllowance"
                    onChange={(e) =>
                      handleSalaryChangeEdit(
                        "otherAllowance",
                        parseFloat(e.target.value) || null,
                        setEmployeeDataEdit,
                        employeeDataEdit
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                      inputProps: {
                        step: "0.01",
                        min: "0",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="BPJS Kesehatan (1%)"
                    value={formatCurrency(employeeDataEdit.bpjsKesehatan) ?? ""}
                    name="bpjsKesehatan"
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                    }}
                    helperText="1% dari gaji gross"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="BPJS TK (3%)"
                    value={formatCurrency(employeeDataEdit.bpjsTK) ?? ""}
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Rp</InputAdornment>
                      ),
                    }}
                    variant="outlined"
                    helperText="2% JHT + 1% JP dari gaji gross"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    select
                    fullWidth
                    label="Kategori PTKP"
                    value={employeeDataEdit.pTKPCategory || "TK/0"} // Pastikan ada fallback
                    disabled={!isEditing}
                    name="pTKPCategory"
                    onChange={handlePTKPChangeEdit} // Pastikan handler sudah benar
                  >
                    <MenuItem value="TK/0">
                      TK/0 - Tidak Kawin dan Tidak Ada Tanggungan
                    </MenuItem>
                    <MenuItem value="TK/1">
                      TK/1 - Tidak Kawin dengan Satu Tanggungan
                    </MenuItem>
                    <MenuItem value="TK/2">
                      TK/2 - Tidak Kawin dengan Dua Tanggungan
                    </MenuItem>
                    <MenuItem value="TK/3">
                      TK/3 - Tidak Kawin dengan Tiga Tanggungan
                    </MenuItem>
                    <MenuItem value="K/0">
                      K/0 - Kawin dan Tidak Ada Tanggungan
                    </MenuItem>
                    <MenuItem value="K/1">
                      K/1 - Kawin dengan Satu Tanggungan
                    </MenuItem>
                    <MenuItem value="K/2">
                      K/2 - Kawin dengan Dua Tanggungan
                    </MenuItem>
                    <MenuItem value="K/3">
                      K/3 - Kawin dengan Tiga Tanggungan
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Category TER"
                    value={employeeDataEdit.categoryTER}
                    disabled
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="outlined"
                    helperText="Automatically set based on PTKP category"
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="PPH21"
                    value={formatCurrency(employeeDataEdit.pph21)}
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid> */}
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Basic Salary"
                    value={formatCurrency(employeeDataEdit.nettSalary)}
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Gross Salary"
                    value={formatCurrency(employeeDataEdit.grossSalary)}
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                      readOnly: true,
                    }}
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} sm={8}>
                  <Divider sx={{ my: 0, borderBottom: "2px solid #ddd" }} />
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ mt: 2, mb: 2 }}
                    >
                      PAYROLL INFORMATION
                    </Typography>
                  </Grid>

                  {/* Period Month & Year */}
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Payroll Period Month"
                      value={payrollData.periodMonth || ""}
                      name="periodMonth"
                      onChange={(e) => {
                        setPayrollData({
                          ...payrollData,
                          periodMonth: parseInt(e.target.value) || null,
                        });
                        setErrors({
                          ...errors,
                          periodMonth: false,
                        });
                      }}
                      error={!payrollData.periodMonth}
                      helperText={
                        !payrollData.periodMonth ? "Mandatory Field" : ""
                      }
                      inputProps={{ min: 1, max: 12 }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Payroll Period Year"
                      value={payrollData.periodYear || ""}
                      name="periodYear"
                      onChange={(e) => {
                        setPayrollData({
                          ...payrollData,
                          periodYear: parseInt(e.target.value) || null,
                        });
                        setErrors({
                          ...errors,
                          periodYear: false,
                        });
                      }}
                      error={!payrollData.periodYear}
                      helperText={
                        !payrollData.periodYear ? "Mandatory Field" : ""
                      }
                      inputProps={{ min: 2000, max: 2100 }}
                    />
                  </Grid>
                  {/* Payment Status & Type */}
                  <Grid item xs={6}>
                    <TextField
                      select
                      fullWidth
                      label="Payment Status"
                      value={payrollData.paymentStatus}
                      name="paymentStatus"
                      onChange={handleInputChange}
                      error={!payrollData.paymentStatus}
                      helperText={
                        !payrollData.paymentStatus ? "Mandatory Field" : ""
                      }
                    >
                      <MenuItem value="" disabled>
                        Select status
                      </MenuItem>
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="Paid">Paid</MenuItem>
                      <MenuItem value="Invalid">Invalid</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      select
                      fullWidth
                      label="Payment Type"
                      value={payrollData.paymentType}
                      name="paymentType"
                      onChange={handleInputChange}
                      error={!payrollData.paymentType}
                      helperText={
                        !payrollData.paymentType ? "Mandatory Field" : ""
                      }
                    >
                      <MenuItem value="" disabled>
                        Select type
                      </MenuItem>
                      <MenuItem value="Monthly Salary">Monthly Salary</MenuItem>
                      <MenuItem value="Monthly Salary + Bonus/THR/Kompensasi/Lain-lain">
                        Monthly Salary + Bonus/THR/Kompensasi/Lain-lain
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Cicilan THR"
                      value={
                        formatCurrency(payrollData.thrInstallment) ||
                        calculatedOpenEdit?.thrInstallment ||
                        ""
                      }
                      name="thrInstallment"
                      onChange={(e) => {
                        setPayrollData({
                          ...payrollData,
                        });
                        setErrors({
                          ...errors,
                        });
                      }}
                      disabled={
                        ["Bonus", "THR", "Others"].includes(
                          payrollData.paymentType
                        ) || true
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Cicilan Pensiun/Kompensasi"
                      value={
                        formatCurrency(payrollData.pensionDplkInstallment) ||
                        calculatedOpenEdit?.pensionDplkInstallment ||
                        ""
                      }
                      name="pensionDplkInstallment"
                      onChange={(e) => {
                        setPayrollData({
                          ...payrollData,
                        });
                        setErrors({
                          ...errors,
                        });
                      }}
                      disabled={
                        ["Bonus", "THR", "Others"].includes(
                          payrollData.paymentType
                        ) || true
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Iuran JKK"
                      value={
                        formatCurrency(payrollData.jkk) ||
                        calculatedOpenEdit?.jkk ||
                        ""
                      }
                      name="jkk"
                      onChange={(e) => {
                        setPayrollData({
                          ...payrollData,
                        });
                        setErrors({
                          ...errors,
                        });
                      }}
                      disabled={
                        ["Bonus", "THR", "Others"].includes(
                          payrollData.paymentType
                        ) || true
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Iuran JKM"
                      value={
                        formatCurrency(payrollData.jkm) ||
                        calculatedOpenEdit?.jkm ||
                        ""
                      }
                      name="jkm"
                      onChange={(e) => {
                        setPayrollData({
                          ...payrollData,
                        });
                        setErrors({
                          ...errors,
                        });
                      }}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      variant="outlined"
                      // helperText="Net Salary - Cicilan"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Bonus"
                      value={payrollData.bonus || ""}
                      name="bonus"
                      onChange={(e) => {
                        handleBonusChange(parseFloat(e.target.value) || null);
                      }}
                      disabled={payrollData.paymentType === "Monthly Salary"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="THR"
                      value={payrollData.thr || ""}
                      name="thr"
                      onChange={(e) => {
                        handleThrChange(parseFloat(e.target.value) || null);
                      }}
                      disabled={payrollData.paymentType === "Monthly Salary"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Kompensasi"
                      value={payrollData.kompensasi || ""}
                      name="kompensasi"
                      onChange={(e) => {
                        handleKompensasiChange(
                          parseFloat(e.target.value) || null
                        );
                      }}
                      disabled={payrollData.paymentType === "Monthly Salary"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Lain-lain"
                      value={payrollData.others || ""}
                      name="others"
                      onChange={(e) => {
                        handleOtherChange(parseFloat(e.target.value) || null);
                      }}
                      disabled={payrollData.paymentType === "Monthly Salary"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Overtime Allowance"
                      value={payrollData.overtime || ""}
                      name="overtime"
                      onChange={(e) => {
                        handleOvertimeChange(
                          parseFloat(e.target.value) || null
                        );
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="SPPD"
                      value={payrollData.sppd || ""}
                      name="sppd"
                      onChange={(e) => {
                        handleSppdChange(parseFloat(e.target.value) || null);
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Iuran JKS"
                      value={
                        formatCurrency(payrollData.bpjsKesCompany) ||
                        calculatedOpenEdit?.bpjsKesCompany ||
                        ""
                      }
                      name="bpjsKesCompany"
                      disabled={
                        ["Bonus", "THR", "Others"].includes(
                          payrollData.paymentType
                        ) || true
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      variant="outlined"
                      helperText="4% dari gaji gross"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="PPH 21"
                      value={formatCurrency(payrollData.payrollPph21) || ""}
                      name="payrollPph21"
                      disabled // Non-aktifkan field karena diisi otomatis
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                        readOnly: true, // Jadikan read-only
                      }}
                      helperText="Akan dihitung otomatis dari Gross Payroll × Tarif TER"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Gross Payroll"
                      value={formatCurrency(payrollData.grossPayroll) || ""}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      variant="outlined"
                      helperText="Gross Salary + Overtime + JKK + JKM"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Coefficient"
                      value={payrollData.bpjsTkContributionCoeff || ""}
                      name="bpjsTkContributionCoeff"
                      onChange={(e) => {
                        handleCoefficientChange(
                          "bpjsTkContributionCoeff",
                          parseFloat(e.target.value) || null
                        );
                      }}
                      disabled={!payrollData.takeHomePay}
                      inputProps={{
                        step: "0.01",
                        min: "0",
                        max: "100",
                      }}
                      // Default value 1 untuk monthly salary
                      defaultValue={
                        payrollData.paymentType === "Monthly Salary" ? 1 : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Tarif TER"
                      value={payrollData.tarifTER || ""}
                      name="tarifTER"
                      disabled // Non-aktifkan field karena diisi otomatis
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                        readOnly: true, // Jadikan read-only
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      onClick={handleGetTarifTER}
                      variant="contained"
                      color="primary"
                      disabled={
                        loadingTarifTER ||
                        !employeeDataEdit.grossSalary ||
                        !employeeDataEdit.categoryTER
                      }
                      sx={{ width: 150 }}
                    >
                      {loadingTarifTER ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Get Tarif TER"
                      )}
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Take Home Pay"
                      value={formatCurrency(payrollData.takeHomePay) || ""}
                      name="takeHomePay"
                      disabled // Non-aktifkan field karena diisi otomatis
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">Rp</InputAdornment>
                        ),
                        inputProps: {
                          step: "0.01",
                          min: "0",
                        },
                        readOnly: true, // Jadikan read-only
                      }}
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Coefficient"
                      value={payrollData.bonusCoeff || ""}
                      name="bonusCoeff"
                      error={!payrollData.bonusCoeff}
                      helperText={
                        !payrollData.bonusCoeff ? "Mandatory Field" : ""
                      }
                      onChange={(e) => {
                        handleBonusCoefChange(
                          "bonusCoeff",
                          parseFloat(e.target.value) || null
                        );
                        setErrors({
                          ...errors,
                          bonusCoeff: false,
                        });
                      }}
                      inputProps={{
                        step: "0.01",
                        min: "0",
                        max: "10", // Atau batas maksimum yang sesuai
                      }}
                    />
                  </Grid> */}

                  {/* Payment Date */}
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        label="Payment Date"
                        value={
                          payrollData.paymentDate
                            ? dayjs(payrollData.paymentDate)
                            : null
                        }
                        onChange={(newValue) => {
                          setPayrollData({
                            ...payrollData,
                            paymentDate: newValue ? newValue.toDate() : null,
                          });
                          setErrors({
                            ...errors,
                            paymentDate: false,
                          });
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: !payrollData.paymentDate,
                            helperText: !payrollData.paymentDate
                              ? "Mandatory Field"
                              : "",
                          },
                        }}
                        format="YYYY-MM-DD HH:mm:ss"
                      />
                    </LocalizationProvider>
                  </Grid>

                  {/* Payment Evidence */}
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        gap: 3,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() => fileInputRef.current?.click()}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                          handleFileUpload(e.dataTransfer.files[0]);
                        }
                      }}
                    >
                      {previewUrl ? (
                        <>
                          <GridOn fontSize="large" color="primary" />
                          <Typography variant="body2" mt={1}>
                            {fileName || "Uploaded PDF"}
                          </Typography>
                          <IconButton
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              backgroundColor: "rgba(255,255,255,0.7)",
                              "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.9)",
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setPreviewUrl("");
                              setFileName("");
                              setPayrollData((prev) => ({
                                ...prev,
                                paymentEvidence: null,
                                paymentEvidenceType: "",
                              }));
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </>
                      ) : (
                        <>
                          <GridOn fontSize="large" color="action" />
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            mt={1}
                          >
                            Drag & drop or click to upload payment evidence
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                        type="file"
                        ref={fileInputRef}
                        onChange={(e) => {
                          if (e.target.files && e.target.files[0]) {
                            handleFileUpload(e.target.files[0]);
                          }
                        }}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (PDF, CSV/XLS/XLSX, WORD)
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Action Buttons */}
                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                  >
                    {payrollData.id ? (
                      <>
                        <Button
                          variant="outlined"
                          onClick={resetForm}
                          disabled={isLoading}
                          sx={{ mr: 2 }}
                        >
                          CANCEL
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() =>
                            handleEditPayrollDetail(payrollData.id)
                          }
                          disabled={isLoading || !payrollData.id}
                          color="primary"
                        >
                          {isLoading ? "Processing..." : "EDIT DATA PAYROLL"}
                        </Button>
                      </>
                    ) : (
                      <Button
                        variant="contained"
                        onClick={handleAddPayrollDetail}
                        disabled={isLoading || !selectedEmployeeId}
                        color="primary"
                      >
                        {isLoading ? "Processing..." : "TAMBAHKAN KE PAYROLL"}
                      </Button>
                    )}
                  </Grid>
                </Grid>

                <Box sx={{ mt: 3 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    gutterBottom
                  >
                    Payroll Review
                  </Typography>
                  <Box className="leftControls">
                    <Typography>Show</Typography>
                    <Select
                      value={rowsPerPage}
                      onChange={(e) => {
                        setRowsPerPagePayrollDetail(Number(e.target.value));
                        setCurrentPagePayrollDetail(1); // reset ke halaman 1 saat ganti limit
                      }}
                      size="small"
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                    </Select>

                    {/* Search Button & Input */}
                    <Button
                      variant="contained"
                      startIcon={<Search />}
                      onClick={() => setShowSearch((prev) => !prev)}
                      className="searchButton"
                    >
                      Search
                    </Button>
                    {showSearch && (
                      <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search"
                        value={searchQueryPayrollDetail}
                        onChange={(e) =>
                          setSearchQueryPayrollDetail(e.target.value)
                        }
                        onKeyDown={(e) =>
                          e.key === "Enter" && handleSearchPayrollDetail()
                        } // Pencarian dengan Enter
                        autoFocus
                        className="searchInput"
                      />
                    )}

                    {/* Menampilkan Error */}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </Box>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>No</TableCell>
                          <TableCell>Period Month</TableCell>
                          <TableCell>Period Year</TableCell>
                          <TableCell>Iuran JKK</TableCell>
                          <TableCell>Iuran JKM</TableCell>
                          <TableCell>Iuran JKS</TableCell>
                          <TableCell>PPH21</TableCell>
                          <TableCell>Take Home Pay</TableCell>
                          <TableCell>Payment Date</TableCell>
                          <TableCell>Payment Status</TableCell>
                          <TableCell>Payment Type</TableCell>
                          <TableCell>Payment Evidence</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {payrollDetails
                          .filter(
                            (payroll) =>
                              selectedEmployeeId &&
                              payroll.employeeId === selectedEmployeeId
                          )
                          .map((row, index) => (
                            <TableRow
                              key={row.id || index}
                              onClick={() => handleRowClickDetail(row)}
                            >
                              <TableCell>
                                <IconButton
                                  color="error"
                                  onClick={() =>
                                    handleDeletePayrollDetailRow(index)
                                  }
                                >
                                  <Delete />
                                </IconButton>
                              </TableCell>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{row.periodMonth}</TableCell>
                              <TableCell>{row.periodYear}</TableCell>
                              <TableCell>{formatCurrency(row.jkk)}</TableCell>
                              <TableCell>{formatCurrency(row.jkm)}</TableCell>
                              <TableCell>
                                {formatCurrency(row.bpjsKesCompany)}
                              </TableCell>
                              <TableCell>{formatCurrency(row.pph21)}</TableCell>
                              <TableCell>
                                {formatCurrency(row.takeHomePay ?? 0)}
                              </TableCell>
                              <TableCell>
                                {row.paymentDate?.toLocaleDateString("id-ID", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </TableCell>
                              <TableCell>{row.paymentStatus}</TableCell>
                              <TableCell>{row.paymentType}</TableCell>
                              {/* <TableCell>{JSON.stringify(row)}</TableCell> */}
                              <TableCell>
                                {row.paymentEvidence ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    {typeof row.paymentEvidence === "string" &&
                                    row.paymentEvidence.includes(".pdf") ? (
                                      // FILE PDF - TAMPILKAN ICON + FILENAME
                                      <>
                                        <PictureAsPdfIcon
                                          color="error"
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: 24,
                                          }}
                                        />
                                        <Typography variant="caption">
                                          {row.paymentEvidence}
                                        </Typography>
                                        <Button
                                          size="small"
                                          onClick={() =>
                                            handleDownloadFile(
                                              row.paymentEvidence
                                            )
                                          }
                                        >
                                          Download
                                        </Button>
                                      </>
                                    ) : typeof row.paymentEvidence ===
                                      "string" ? (
                                      // URL GAMBAR - TAMPILKAN PREVIEW
                                      <img
                                        src={row.paymentEvidence}
                                        alt="Payment Evidence"
                                        style={{
                                          width: 50,
                                          height: 50,
                                          objectFit: "cover",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          window.open(
                                            row.paymentEvidence,
                                            "_blank"
                                          )
                                        }
                                      />
                                    ) : row.paymentEvidence instanceof File ? (
                                      // FILE OBJECT - TAMPILKAN PREVIEW
                                      <>
                                        <GridOn
                                          color="primary"
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: 24,
                                          }}
                                        />
                                        <Typography variant="caption">
                                          {row.paymentEvidence.name}
                                        </Typography>
                                      </>
                                    ) : (
                                      // FALLBACK - TAMPILKAN ERROR
                                      <Typography
                                        variant="caption"
                                        color="error"
                                      >
                                        File tidak tersedia
                                      </Typography>
                                    )}
                                  </Box>
                                ) : (
                                  <Typography
                                    variant="caption"
                                    color="textSecondary"
                                  >
                                    No evidence
                                  </Typography>
                                )}
                              </TableCell>
                              <TableCell>
                                <Box sx={{ display: "flex", gap: 1 }}>
                                  <IconButton
                                    color="primary"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDownloadSlipGajiPDF(row);
                                    }}
                                    title="Download Slip Gaji"
                                  >
                                    <PictureAsPdfIcon fontSize="small" />
                                  </IconButton>
                                  {row.paymentType !== "Monthly Salary" &&
                                    row.bonus || row.bonus !== 0 && (
                                      <IconButton
                                        color="primary"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownloadSlipBonusPDF(row);
                                        }}
                                        title="Download Slip Bonus"
                                      >
                                        <PictureAsPdfIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  {row.paymentType !== "Monthly Salary" &&
                                    row.thr || row.thr !== 0 && (
                                      <IconButton
                                        color="primary"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownloadSlipThrPDF(row);
                                        }}
                                        title="Download Slip THR"
                                      >
                                        <PictureAsPdfIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  {row.paymentType !== "Monthly Salary" &&
                                    row.kompensasi || row.kompensasi !== 0 && (
                                      <IconButton
                                        color="primary"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownloadSlipKompensasiPDF(row);
                                        }}
                                        title="Download Slip Kompensasi"
                                      >
                                        <PictureAsPdfIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  {row.paymentType !== "Monthly Salary" &&
                                    row.others || row.others !== 0 && (
                                      <IconButton
                                        color="primary"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownloadSlipOthersPDF(row);
                                        }}
                                        title="Download Slip Lain-lain"
                                      >
                                        <PictureAsPdfIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  <IconButton
                                    color="secondary"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDownloadPph21PDF(row);
                                    }}
                                    title="Download Formulir PPH21"
                                  >
                                    <Download fontSize="small" />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Pagination */}
                  <Box
                    className="paginationContainer"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      padding: "16px 0",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      {`Showing ${Math.min(
                        (currentPagePayrollDetail - 1) *
                          rowsPerPagePayrollDetail +
                          1,
                        totalItemsPayrollDetail
                      )} to ${Math.min(
                        currentPagePayrollDetail * rowsPerPagePayrollDetail,
                        totalItemsPayrollDetail
                      )} of ${totalItemsPayrollDetail} entries`}
                    </Typography>
                    {/* Komponen Pagination */}
                    <Pagination
                      count={totalPagesPayrollDetail}
                      page={currentPagePayrollDetail}
                      onChange={(e, page) => setCurrentPagePayrollDetail(page)}
                      className="pagination"
                      showFirstButton
                      showLastButton
                      renderItem={(item) => (
                        <PaginationItem
                          {...item}
                          components={{ first: FirstPage, last: LastPage }}
                        />
                      )}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>

        {/* Buttons: Save & Close */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          <>
            <Button
              onClick={() => setIsEditing(false)}
              variant="outlined"
              color="error"
              sx={{ width: 120 }}
            >
              CANCEL
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              color="success"
              sx={{ width: 120 }}
            >
              SAVE
            </Button>
          </>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PayrollPage;
